const config = require("../config.js");
const UTILS = require("../libs/utils.js");
function f1330(p9996) {
  p9996 = p9996 || {};
  this.name = p9996.name;
  this.id = p9996.id;
  this.parent = p9996.parent;
  this.type = p9996.type;
  this.pos = p9996.pos;
  this.size = p9996.size;
  this.sub = p9996.sub;
  this.closed = p9996.closed;
  this.show = p9996.show;
  this.blueprint = {};
  if (this.parent) {
    var v8014 = this.id || this.name;
    this.parent.blueprint[v8014] = {
      type: this.type,
      children: p9996.children || {}
    };
    if (this.name) {
      this.parent.blueprint[v8014].name = this.name;
    }
    if (this.id) {
      this.parent.blueprint[v8014].id = this.id;
    }
    if (this.pos) {
      this.parent.blueprint[v8014].pos = this.pos;
    }
    if (this.size) {
      this.parent.blueprint[v8014].size = this.size;
    }
    if (this.sub) {
      this.parent.blueprint[v8014].sub = this.sub;
    }
    if (this.closed) {
      this.parent.blueprint[v8014].closed = true;
    }
    if (this.show != null) {
      this.parent.blueprint[v8014].show = this.show;
    }
    this.blueprint = this.parent.blueprint[v8014].children;
  }
  this.addFolder = function (p9997, p9998, p9999, p10000, p10001, p10002, p10003) {
    var vO226 = {
      name: p9997,
      parent: this,
      type: p10000 || this.type,
      children: p9998 || {}
    };
    if (p9999 || this.pos) {
      vO226.pos = p9999 || this.pos;
    }
    if (p10001 || this.size) {
      vO226.size = p10001 || this.size;
    }
    if (p10003) {
      vO226.sub = p10003;
    }
    if (p10002) {
      vO226.closed = true;
    }
    const v8015 = new f1330(vO226);
    return v8015;
  };
  this.addDiv = function (p10004, p10005, p10006, p10007) {
    var vO227 = {
      id: p10004,
      parent: this,
      type: "div",
      children: p10005 || {}
    };
    if (p10006 || this.size) {
      vO227.size = p10006 || this.size;
    }
    if (p10007 != null) {
      vO227.show = p10007;
    }
    const v8016 = new f1330(vO227);
    return v8016;
  };
  this.addOption = function (p10008, p10009) {
    this.blueprint[p10008] = {
      name: p10008,
      type: this.type,
      pos: "option",
      onClick: p10009
    };
    return this;
  };
  this.add = function (p10010, p10011, p10012, p10013, p10014, p10015, p10016, p10017) {
    var vO228 = {
      object: p10012,
      key: p10013,
      type: p10010
    };
    if (p10016) {
      vO228.line = "wide";
    }
    if (p10014) {
      vO228.args = p10014;
    }
    if (p10011) {
      vO228.name = p10011;
    }
    if (p10017) {
      vO228.sub = p10017;
    }
    if (p10015) {
      vO228.onChange = p10015;
    }
    if (vO228.args && (p10010 == "select" || p10010 == "button" || p10010 == "number" || p10010 == "text")) {
      vO228.args = [vO228.args];
    }
    this.blueprint[p10011 || p10013] = vO228;
    return this;
  };
  this.addPanelButton = function (p10018, p10019) {
    var vO229 = {
      type: "panel_buttons",
      direction: p10019
    };
    if (p10018) {
      vO229.label = p10018;
    } else {
      vO229.blank = true;
    }
    this.blueprint.panelButtons = vO229;
    return this;
  };
  this.addChildren = function (p10020) {
    this.blueprint = {
      ...p10020
    };
    return this;
  };
  var vLN01300 = 0;
  this.addRule = function () {
    this.blueprint["rule" + vLN01300] = {
      type: "rule"
    };
    vLN01300++;
    return this;
  };
  this.toJSON = function () {
    if (!p9996.parent) {
      return this.blueprint;
    }
  };
}
module.exports = function (p10021, p10022, p10023, p10024, p10025, p10026, p10027, p10028, p10029, p10030) {
  var v8017;
  var v8018;
  var vO230 = {
    _html: {
      panelButtons: function (p10031, p10032, p10033 = false) {
        let v8019 = "<div class=\"" + (p10031 == "left" ? "right" : "left") + " panelButton\" style=\"" + (p10033 ? "border-bottom-right-radius:5px" : "") + "\" onclick=\"KE.resizable.hide(this)\">\n\t\t\t\t\t<div class=\"hide\"><i class=\"material-icons hide\">keyboard_arrow_" + p10031 + "</i></div></div>";
        let v8020 = p10033 ? "<div></div>" : "<div class=\"" + (p10031 == "left" ? "left" : "right") + " panelButton\" onclick=\"GUI.panel.state.lock(this, '" + p10031 + "')\">\n\t\t\t\t\t<div class=\"lock\"\"><i class=\"material-icons lock\">lock" + (vO230.panel[p10031].locked ? "" : "_open") + "</i></div></div>";
        let v8021 = p10033 ? "<div></div>" : "<div class='panelLabel'>" + p10032 + "</div>";
        return "<div class=\"panelButtonLayout\">" + (p10031 == "left" ? v8020 + v8021 + v8019 : v8019 + v8021 + v8020) + "</div>";
      },
      arrow: function (p10034) {
        return "<i class=\"material-icons\" style=\"transform: translateY(5px) rotate(" + {
          up: -45,
          down: 135,
          left: -135,
          right: 45
        }[p10034] + "deg)\">call_made</i>";
      },
      folder: {
        standard: function (p10035, p10036 = "", p10037 = "", p10038 = false) {
          return "<div id=\"" + p10035.toLowerCase() + "H\" class=\"header\" onclick=\"GUI.update.folder(this);" + p10037 + "\">\n\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_" + (p10038 ? "right" : "down") + "</i><a>" + p10035 + "</a></div><hr>\n\t\t\t\t\t\t<div id=\"" + p10035.toLowerCase() + "B\" style=\"" + (p10038 ? "display:none" : "") + "\">" + p10036 + "<hr></div>";
        },
        small: function (p10039, p10040 = "", p10041 = "", p10042 = false, p10043 = false) {
          return "<div id=\"" + p10039.toLowerCase() + "H\" class=\"" + (p10043 ? "sub" : "") + "subheader\" style=\"cursor: pointer\"\n\t\t\t\t\t\tonclick=\"GUI.update.folder(this);" + p10041 + "\"><i class=\"material-icons\">keyboard_arrow_" + (p10042 ? "right" : "down") + "</i><a>" + p10039 + "</a></div>\n\t\t\t\t\t\t<div id=\"" + p10039.toLowerCase() + "B\" style=\"" + (p10042 ? "display:none" : "") + "\">" + p10040 + "</div>";
        },
        smaller: function (p10044, p10045 = "", p10046 = "", p10047 = false, p10048 = false) {
          return "<div id=\"" + p10044.toLowerCase() + "H\" class=\"" + (p10048 ? "sub" : "") + "subsubheader\" style=\"cursor: pointer\"\n\t\t\t\t\t\tonclick=\"GUI.update.folder(this);" + p10046 + "\"><i class=\"material-icons\">keyboard_arrow_" + (p10047 ? "right" : "down") + "</i><a>" + p10044 + "</a></div>\n\t\t\t\t\t\t<div id=\"" + p10044.toLowerCase() + "B\" style=\"" + (p10047 ? "display:none" : "") + "\">" + p10045 + "</div>";
        }
      },
      line: {
        standard: function (p10049, p10050 = "", p10051 = 0) {
          return "<div class=\"inlineItem\"><div class=\"section " + (["subsection", "subsubsection"][p10051 - 1] || "") + "\">" + p10049 + "</div>\n\t\t\t\t\t\t<div>" + p10050 + "</div></div>";
        },
        switch: function (p10052, p10053 = "", p10054 = 0) {
          return "<div class=\"inlineItem\" style=\"grid-template-columns: calc(85% - 5px) calc(15% - 5px);\">\n\t\t\t\t\t\t<div class=\"section " + (["subsection", "subsubsection"][p10054 - 1] || "") + "\">" + p10052 + "</div>\n\t\t\t\t\t\t<div>" + p10053 + "</div></div>";
        },
        nodiv: function (p10055, p10056 = "", p10057 = 0) {
          return "<div class=\"inlineItem\">\n\t\t\t\t\t\t<div class=\"section " + (["subsection", "subsubsection"][p10057 - 1] || "") + "\">" + p10055 + "</div>\n\t\t\t\t\t\t" + p10056 + "</div>";
        },
        wide: function (p10058, p10059 = "") {
          return "<div>" + p10059 + "</div>";
        }
      },
      input: {
        resizable: {
          button: function (p10060, p10061 = "", p10062) {
            return "<div class=\"eButton\" onclick=\"" + p10061 + "\">" + p10062 + "</div>";
          },
          dbutton: function (p10063, p10064 = "", p10065, p10066) {
            return "<div class=\"dbuttonTable\"><div class=\"dbutton\" onclick=\"" + p10064 + "\" id=\"left\">" + p10065 + "</div>\n\t\t\t\t\t\t<div class=\"dbutton\" onclick=\"" + p10064 + "\" style=\"margin-left: 5px;\" id=\"right\">" + p10066 + "</div></div>";
          },
          key: function (p10067 = "", p10068 = "", p10069 = [], p10070 = false) {
            return "<div class=\"inlineLabel " + (p10070 ? "" : "disabled") + "\" href=\"#\" " + (p10070 ? "onclick=\"" + p10068 + "\"" : "") + ">" + [p10067, ...p10069].join(" or ") + "</div>";
          },
          text: function (p10071 = "", p10072 = "", p10073 = "") {
            return "<input class=\"inlineInput\" type=\"text\" placeholder=\"" + p10073 + "\" value=\"" + p10071 + "\" oninput=\"" + p10072 + "\" onchange=\"GUI.update.field(this)\">";
          },
          number: function (p10074 = 0, p10075 = "", p10076 = "", p10077 = "", p10078 = "", p10079 = "") {
            return "<input class=\"inlineInput\" type=\"number\" placeholder=\"" + p10076 + "\" value=\"" + p10074 + "\" min=\"" + p10077 + "\" max=\"" + p10078 + "\" step=\"" + p10079 + "\"\n\t\t\t\t\t\tonmousedown=\"GUI.update.number.mousedown(this)\" onchange=\"GUI.update.field(this);GUI.update.number.change(this);" + p10075 + "\">";
          },
          color: function (p10080 = "#ffffff", p10081 = "") {
            return "<input class=\"color\" style=\"background-color:" + p10080 + ";color:" + UTILS.stringifyColor(UTILS.parseColor(p10080) < 7829367 ? 16777215 : 0) + "\"\n\t\t\t\t\t\ttype=\"text\" spellcheck=\"false\" value=\"" + p10080 + "\" onchange=\"GUI.update.field(this);GUI.update.color.change(this);" + p10081 + "\"\n\t\t\t\t\t\tonmousedown=\"GUI.update.color.mousedown(this)\">";
          },
          switch: function (p10082 = false, p10083 = "") {
            return "<label class=\"switch\" style=\"margin-top: 10px\"><input type=\"checkbox\"\n\t\t\t\t\t\tonclick=\"" + p10083 + "\" " + (p10082 ? "checked" : "") + "><span class=\"slider\"></span></label>";
          },
          slider: function (p10084 = 0, p10085 = "", p10086 = 0, p10087 = 1, p10088 = 0.1) {
            return "<div style=\"zoom:0.7;margin-top:12px;\">\n\t\t\t\t\t\t<input type=\"number\" class=\"sliderVal\" min=\"" + p10086 + "\" max=\"" + p10087 + "\" value=\"" + p10084 + "\"\n\t\t\t\t\t\tonchange=\"GUI.update.field(this);GUI.update.slider.val(this);" + p10085 + "\"><div class=\"slidecontainer\"><input type=\"range\"\n\t\t\t\t\t\tmin=\"" + p10086 + "\" max=\"" + p10087 + "\" step=\"" + p10088 + "\" value=\"" + p10084 + "\" class=\"sliderM\" oninput=\"GUI.update.slider.M(this);" + p10085 + "\">\n\t\t\t\t\t\t</div></div>";
          },
          select: function (p10089 = 0, p10090 = "", p10091) {
            return "<select onchange=\"" + p10090 + "\">" + p10091.map(p10092 => "<option value=\"" + p10092.value + "\"\n\t\t\t\t\t\t" + (p10089 == p10092.value ? "selected" : "") + ">" + p10092.name + "</option>") + "</select>";
          },
          selectClick: function (p10093 = 0, p10094 = "", p10095, p10096, p10097) {
            return "<div class=\"multiItem\"><select onchange=\"" + p10094 + "\">" + p10095.map(p10098 => "<option value=\"" + p10098.value + "\"\n\t\t\t\t\t\t" + (p10093 == p10098.value ? "selected" : "") + ">" + p10098.name + "</option>") + "</select>\n\t\t\t\t\t\t<div class=\"iconButton\" onclick=\"" + p10096 + "\"><span class=\"material-icons\" style=\"line-height: 1.2;\">" + p10097 + "</span></div></div>";
          }
        },
        fixed: {
          vector3: function (p10099, p10100 = "", p10101 = [0, 0, 0], p10102 = "", p10103 = "", p10104 = "") {
            if (p10099 === "Rotation" && p10021.settings.degToRad) {
              p10101 = p10101.map(p10105 => p10023.MathUtils.radToDeg(p10105).round(2));
            }
            return "<div class=\"section\">" + p10099 + "</div><div class=\"vector3\">\n\t\t\t\t\t\t" + p10021.xyzKeys.map((p10106, p10107) => "<input type=\"number\" placeholder=\"" + p10106 + "\" min=\"" + p10102 + "\" max=\"" + p10103 + "\" step=\"" + p10104 + "\"\n\t\t\t\t\t\tonmousedown=\"GUI.update.number.mousedown(this)\" onchange=\"GUI.update.field(this);GUI.update.number.change(this);" + p10100 + "\"\n\t\t\t\t\t\tvalue=\"" + p10101[p10107] + "\">").join("\n") + "</div>";
          }
        }
      },
      toolbar: {
        root: function (p10108, p10109) {
          return "<div class=\"toolbarItem\" onmouseover=\"GUI.update.toolbar(this, true)\" onmouseout=\"GUI.update.toolbar(this)\">\n\t\t\t\t\t\t" + p10108 + "<div class=\"toolbarDropDown\">" + p10109 + "</div></div>";
        },
        menu: function (p10110, p10111) {
          return "<div class=\"toolbarDropDownItem\" onmouseover=\"GUI.update.toolbar(this, true)\" onmouseout=\"GUI.update.toolbar(this)\">\n\t\t\t\t\t\t" + p10110 + "<div class=\"toolbarSubDropDown\" style=\"top: this.offsetTop\">" + p10111 + "</div></div>";
        },
        option: function (p10112, p10113 = "") {
          return "<div class=\"toolbarDropDownItem\" onclick=\";" + p10113 + "\">" + p10112 + "</div>";
        },
        textarea: function (p10114, p10115 = "") {
          return "<div class=\"toolbarDropDownItem textarea\" onclick=\";" + p10115 + "\"><textarea class=\"qs_textarea\" rows=\"5\"></textarea></div>";
        }
      },
      chunk: function (p10116, p10117, p10118, p10119) {
        let v8022 = UTILS.arrayChunk(p10116, p10117).map(p10120 => p10120.join("\n")).join("" + p10119 + p10118);
        return "" + p10118 + v8022 + p10119;
      }
    },
    update: {
      folder: function (p10121) {
        let v8023 = p10121.parentElement.querySelector("[id='" + p10121.id.substring(0, p10121.id.length - 1) + "B']");
        let v8024 = v8023.style.display == "none";
        p10121.children[0].innerHTML = "keyboard_arrow_" + (v8024 ? "down" : "right");
        v8023.style.display = v8024 ? null : "none";
      },
      field: function (p10122) {
        p10122.blur();
      },
      key: {
        choice: {},
        keydown: function (p10123) {
          let v8025 = vO230.update.key.choice;
          if (v8025.elem) {
            p10123 = window.event || p10123;
            let v8026 = p10123.key.toUpperCase();
            if (v8026.length == 1) {
              v8025.callback(p10123.key.toUpperCase(), true);
            } else {
              v8025.callback(v8025.prev);
            }
            v8025.elem = null;
          }
        },
        mousedown: function (p10124) {
          let v8027 = vO230.update.key.choice;
          if (v8027.elem) {
            p10124 = window.event || p10124;
            v8027.callback(v8027.prev);
            v8027.elem = null;
          }
        }
      },
      number: {
        mousedown: function (p10125) {
          vO230.update.number.elem = p10125;
        },
        mousemove: function (p10126) {
          let v8028 = vO230.update.number.elem;
          p10126 = window.event || p10126;
          if (v8028) {
            v8028.value = parseFloat(v8028.value) - p10126.movementY * (parseFloat(v8028.step) || 1);
            if (v8028.min && v8028.value < v8028.min) {
              v8028.value = parseFloat(v8028.min);
            }
            if (v8028.max && v8028.value > v8028.max) {
              v8028.value = parseFloat(v8028.max);
            }
            v8028.onchange();
          }
        },
        mouseup: function () {
          delete vO230.update.number.elem;
        },
        change: function (p10127) {
          if (p10127.value == "") {
            p10127.value = 0;
          }
        }
      },
      color: {
        init: function () {
          let v8029 = document.createElement("div");
          v8029.style.display = "none";
          document.body.appendChild(v8029);
          vO230.update.color.pickr = Pickr.create({
            el: v8029,
            theme: "nano",
            swatches: null,
            comparison: false,
            lockOpacity: true,
            autoReposition: false,
            defaultRepresentation: "HEX",
            closeOnScroll: true,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                input: false,
                cancel: false,
                clear: false,
                save: false
              }
            }
          });
          var vF54 = p10128 => {
            let v8030 = vO230.update.color.elem;
            if (p10128.key === "Enter" && UTILS.isHexColor(v8030.value)) {
              vO230.update.color.pickr.setColor(v8030.value, true);
            }
          };
          vO230.update.color.pickr.on("show", function (p10129, p10130) {
            let v8031 = vO230.update.color.elem.getBoundingClientRect();
            vO230.update.color.elem.removeEventListener("keydown", vF54);
            vO230.update.color.elem.addEventListener("keydown", vF54, {
              capture: true
            });
            let v8032 = v8031.y;
            let v8033 = v8031.x + v8031.width + 4;
            v8032 = window.innerHeight - v8032 < p10130._root.app.offsetHeight ? v8032 - p10130._root.app.offsetHeight + v8031.height : v8032;
            v8033 = window.innerWidth - v8033 < p10130._root.app.offsetWidth ? v8033 - p10130._root.app.offsetWidth - v8031.width - 8 : v8033;
            p10130._root.app.style.top = v8032 + "px";
            p10130._root.app.style.left = v8033 + "px";
            p10130.setColor(vO230.update.color.elem.value);
            KE.updateColorSwatches();
          }).on("change", function (p10131) {
            let v8034 = vO230.update.color.elem;
            if (v8034) {
              v8034.value = p10131.toHEXA().toString();
              v8034.setAttribute("data-hsva", p10131.toHSVA().toString());
              v8034.onchange();
            }
          }).on("hide", function () {
            vO230.update.color.elem.removeEventListener("keydown", vF54);
            delete vO230.update.color.elem;
          }).on("swatchselect", function (p10132) {
            let v8035 = vO230.update.color.elem;
            if (v8035) {
              v8035.value = p10132.toHEXA().toString();
              v8035.setAttribute("data-hsva", p10132.toHSVA().toString());
              v8035.onchange();
            }
          });
        },
        change: function (p10133) {
          let v8036 = p10133.style.backgroundColor;
          let v8037 = v8036.substr(4, v8036.length - 5).split(", ");
          p10133.value = UTILS.isHexColor(p10133.value) ? p10133.value : UTILS.rgbToHex(...v8037);
          p10133.style.backgroundColor = p10133.value;
          p10133.style.color = UTILS.stringifyColor(UTILS.parseColor(p10133.value) < 7829367 ? 16777215 : 0);
          var v8038 = p10133.getAttribute("data-hsva") || p10133.value;
          vO230.update.color.pickr.setColor(v8038, true);
        },
        mousedown: function (p10134) {
          var v8039 = window.event;
          if (v8039 && v8039.which === 1) {
            vO230.update.color.show = true;
            vO230.update.color.elem = p10134;
            vO230.update.color.pickr.show();
          }
        }
      },
      slider: {
        val: function (p10135) {
          p10135.parentElement.children[1].children[0].value = Math.max(Math.min(p10135.value, p10135.max), p10135.min);
          p10135.value = p10135.parentElement.children[1].children[0].value;
        },
        M: function (p10136) {
          p10136.parentElement.parentElement.children[0].value = p10136.value;
        }
      },
      toolbar: function (p10137, p10138) {
        if (p10138) {
          p10137.children[0].style.display = "block";
          if (p10137.children[0].className == "toolbarSubDropDown" && !p10137.children[0].style.top) {
            requestAnimationFrame(function () {
              p10137.children[0].style.top = p10137.offsetTop + "px";
            }, 0);
          }
        } else if (p10137 && p10137.children[0]) {
          p10137.children[0].style.display = null;
        }
      }
    },
    action: function (p10139, p10140) {
      let vVO230 = vO230;
      p10139.forEach(p10141 => vVO230 = vVO230[p10141]);
      switch (vVO230.type) {
        case "toolbar":
          if (!p10021.quickGUI._hidden) {
            if (vVO230.pos != "textarea") {
              p10021.quickGUI.hide();
            }
          } else {
            let vP10140 = p10140;
            p10139.slice(p10139.indexOf("blueprint") + 2).forEach(() => vP10140 = vP10140.parentElement);
            vO230.update.toolbar(vP10140);
          }
          if (vVO230.onClick) {
            vVO230.onClick(p10140, window.event);
          }
          break;
        case "folder":
          let v8040 = document.getElementById(p10140.id.substring(0, p10140.id.length - 1) + "B");
          let v8041 = v8040.style.display == "none";
          let vA394 = [...p10139];
          vA394[vA394.indexOf("blueprint")] = "folderStore";
          let vVO2302 = vO230;
          vA394.forEach(p10142 => vVO2302 = vVO2302[p10142] ? vVO2302[p10142] : vVO2302[p10142] = {});
          vVO2302.closed = v8041;
          break;
        case "vector3":
          let v8042 = [...p10140.parentElement.children].map(p10143 => parseFloat(p10143.value).round(vVO230.round || 0));
          vVO230.object[vVO230.key] = v8042;
          if (vVO230.onChange) {
            vVO230.onChange(p10140, v8042);
          }
          break;
        case "key":
          let v8043 = vO230.update.key.choice;
          v8043.prev = p10140.innerHTML;
          p10140.innerHTML = "Press Any Key";
          v8043.callback = function (p10144, p10145) {
            p10140.innerHTML = [p10144, ...vVO230.args[0]].join(" or ");
            if (p10145) {
              vVO230.object[vVO230.key] = p10144;
              if (vVO230.onChange) {
                vVO230.onChange(p10140, p10144);
              }
            }
          };
          v8043.elem = p10140;
          break;
        case "dbutton":
          if (vVO230.onChange) {
            vVO230.onChange(p10140, null);
          }
          break;
        default:
          let v8044 = p10140.type == "checkbox" ? p10140.checked : ["text", "select-one"].includes(p10140.type) ? p10140.value : parseFloat(p10140.value);
          let v8045 = p10140.nodeName == "DIV" && vVO230.type == "selectClick" && vVO230.onClick;
          if (v8045) {
            vVO230.onClick();
          } else {
            if (typeof vVO230.object[vVO230.key] == "function") {
              vVO230.object[vVO230.key](p10140.id, vVO230);
            } else {
              vVO230.object[vVO230.key] = v8044;
            }
            if (vVO230.onChange) {
              vVO230.onChange(p10140, v8044);
            }
          }
      }
    },
    _build: function (p10146, p10147, p10148) {
      let vVO2303 = vO230;
      p10146.forEach(p10149 => vVO2303 = vVO2303[p10149]);
      let v8046 = Object.keys(vVO2303).map(p10150 => {
        let v8047 = vVO2303[p10150];
        let v8048 = "GUI.action(" + JSON.stringify([...p10146, p10150]).replace(/\"/g, "'") + ", this)";
        switch (v8047.type) {
          case "panel_buttons":
            return vO230._html.panelButtons(v8047.direction, v8047.label, v8047.blank);
          case "rule":
            return "<hr>";
          case "div":
            return "<div id=" + v8047.id + " " + (v8047.show ? null : "style=\"display: none\"") + ">" + vO230._build([...p10146, p10150, "children"]) + "</div>";
          case "toolbar":
            if (["option", "textarea"].includes(v8047.pos)) {
              return vO230._html.toolbar[v8047.pos](v8047.name, v8048);
            } else {
              return vO230._html.toolbar[v8047.pos](v8047.name, vO230._build([...p10146, p10150, "children"]));
            }
          case "chunktoolbar":
            if (["option", "textarea"].includes(v8047.pos)) {
              return vO230._html.toolbar[v8047.pos](v8047.name, v8048);
            } else {
              return vO230._html.toolbar[v8047.pos](v8047.name, vO230._build([...p10146, p10150, "children"], vO230._html.chunk, [12, "<div class='toolbarChunkSubDropDown'>", "</div>"]));
            }
          case "folder":
            let vA395 = [...p10146, p10150];
            vA395[vA395.indexOf("blueprint")] = "folderStore";
            let vVO2304 = vO230;
            vA395.forEach(p10151 => vVO2304 = vVO2304[p10151] ? vVO2304[p10151] : vVO2304[p10151] = {});
            if (p10021.settings.preserveFolderState && vVO2304.closed != null) {
              v8047.closed = vVO2304.closed;
            } else {
              vVO2304.closed = !!v8047.closed;
            }
            return vO230._html.folder[v8047.size](v8047.name, vO230._build([...p10146, p10150, "children"]), v8048, v8047.closed, v8047.sub);
          case "vector3":
            return vO230._html.input.fixed.vector3(v8047.name, v8048, v8047.object[v8047.key], v8047.min);
          case "selectClick":
            return vO230._html.line[v8047.type == "switch" ? "switch" : v8047.line || "standard"](v8047.name, vO230._html.input.resizable.selectClick(v8047.object[v8047.key], v8048, ...(v8047.args ? v8047.args : []), v8048, v8047.icon), v8047.sub);
          default:
            return vO230._html.line[v8047.type == "switch" ? "switch" : v8047.line || "standard"](v8047.name, vO230._html.input.resizable[v8047.type](v8047.object[v8047.key], v8048, ...(v8047.args ? v8047.args : [])), v8047.sub);
        }
      });
      if (p10147) {
        return p10147(v8046, ...p10148);
      } else {
        return v8046.join("\n");
      }
    },
    _toolbar: {
      elem: document.getElementById("_toolbar"),
      show: function () {
        let vA396 = [];
        let vA397 = [];
        let vA398 = [];
        let vA399 = [];
        let vA400 = [];
        for (let v8049 in p10024.prefabs) {
          if ((!p10024.prefabs[v8049].localOnly || !config.isProd) && !p10024.prefabs[v8049].custom && !p10024.prefabs[v8049].noExport) {
            if (p10024.prefabs[v8049].name != "") {
              (p10024.prefabs[v8049].edCat == "lights" ? vA398 : p10024.prefabs[v8049].zone ? vA400 : p10024.prefabs[v8049].tool || p10024.prefabs[v8049].tool2 ? vA397 : p10024.prefabs[v8049].gen ? vA396 : vA399).push({
                name: UTILS.formatConstName(p10024.prefabs[v8049].name),
                type: "toolbar",
                pos: "option",
                onClick: function (p10152, p10153) {
                  if (p10153 && p10153.shiftKey) {
                    p10021.reuseSelected(v8049);
                  } else {
                    p10021.createObjects[v8049]();
                  }
                }
              });
            }
          }
        }
        var v8050 = new f1330({
          type: "toolbar",
          pos: "root"
        });
        var v8051 = v8050.addFolder("File");
        v8051.addOption("Import Project", function () {
          if (window.event.shiftKey) {
            p10021.loadFile("importMap");
          } else {
            p10021.importMapPopup();
          }
        });
        if (p10021.dev) {
          v8051.addOption("Import Old Project", function () {
            p10021.importOldMap();
          });
        }
        v8051.addOption("New Project", function () {
          if (confirm("Are you sure you want to reset the map?")) {
            p10021.clearMap();
          }
        });
        v8051.addOption("Save Project", () => p10021.save());
        v8051.addOption("Load Backup", () => showWindow(15));
        v8051.addRule();
        v8051.addOption("Export", function () {
          if (window.event.shiftKey) {
            p10021.copyToClipboard(p10021.getMapExport());
          }
          p10021.exportMap();
        });
        v8051.addOption("Copy Export", () => UTILS.copyToClipboard(p10021.getMapExport()));
        v8051.addRule();
        v8051.addOption("Export GLTF", () => p10021.exportScene());
        v8051.addOption("Export MTL", () => p10021.exportScene2());
        var v8052 = v8050.addFolder("Edit");
        v8052.addOption("Undo (Ctrl + Z)", () => p10021.executeHistory("undo"));
        v8052.addOption("Redo (Ctrl + Y)", () => p10021.executeHistory("redo"));
        v8052.addRule();
        v8052.addOption("Delete (Del)", function () {
          if (p10021.objectSelected(true)) {
            p10021.removeGroup();
          } else {
            p10021.removeObject();
          }
        });
        v8052.addOption("Duplicate (Shift + R)", function () {
          if (p10021.objectSelected(true)) {
            p10021.duplicateGroup();
          } else {
            p10021.duplicateObject();
          }
        });
        v8052.addRule();
        v8052.addOption("Settings...", () => showWindow(3));
        var v8053 = v8050.addFolder("Object");
        v8053.addOption("Scene Graph", () => vO230.panel.right.objectList.show());
        v8053.addRule();
        v8053.addFolder("Basic", vA399, "menu");
        v8053.addFolder("Models", vA396, "menu", "chunktoolbar");
        v8053.addFolder("Tools", vA397, "menu", "chunktoolbar");
        v8053.addFolder("Lights", vA398, "menu");
        v8053.addFolder("Zones", vA400, "menu");
        v8053.addRule();
        v8053.addOption("Placeholder", () => p10021.createPlaceholder());
        var v8054 = v8053.addFolder("Group", null, "menu");
        v8054.addOption("Create", () => p10021.advancedOptions.create());
        v8054.addOption("Stop", () => p10021.advancedOptions.stop());
        v8054.addOption("Stop All", () => p10021.advancedOptions.stopAll());
        v8054.addRule();
        v8054.addOption("Copy", () => p10021.advancedOptions.copy());
        v8054.addOption("Cut", () => p10021.advancedOptions.cut());
        v8054.addOption("Paste", () => p10021.advancedOptions.paste());
        v8054.addRule();
        var v8055 = v8054.addFolder("Prefab", null, "menu");
        var v8056 = v8055.addFolder("Import", null, "menu");
        v8056.addOption("JSON", () => p10021.advancedOptions.json());
        v8056.addOption("File", () => p10021.advancedOptions.file());
        v8055.addOption("Export", () => p10021.advancedOptions.exportObj());
        v8055.addOption("Tools", () => vO230.panel.right.prefab.show());
        v8053.addRule();
        v8053.addOption("Custom...", () => p10021.createObjects[44]());
        var v8057 = v8050.addFolder("Components");
        v8057.addOption("Environment", () => vO230.panel.right.environment.show());
        v8057.addOption("Terrain", () => vO230.panel.right.terrain.show());
        v8057.addOption("Zone", () => vO230.panel.right.zone.show());
        v8057.addOption("Ocean", () => vO230.panel.right.ocean.show());
        v8057.addOption("GUI", () => vO230.panel.right.gui.show());
        v8050.addOption("Scripting", () => KE.scriptPopup());
        var v8058 = v8050.addFolder("Game");
        v8058.addOption("Test Game", () => p10021.testMap());
        v8058.addOption("Host Game", () => p10021.testMap(true));
        v8058.addRule();
        v8058.addOption("Quick Start", () => p10021.quickStart());
        v8058.addOption("Templates", () => p10021.showTempls());
        v8058.addRule();
        v8058.addOption("Tools", () => vO230.panel.right.tools.show());
        var v8059 = v8050.addFolder("Publish");
        v8059.addOption("Game", () => p10021.publishMap());
        v8059.addOption("Asset", () => p10021.publishAssetPopup());
        v8059.addRule();
        v8059.addOption("Publishing Guide", () => showWindow(11));
        var v8060 = v8050.addFolder("Account");
        if (p10021.autoLog && !p10021.account) {
          v8060.addOption("Logging in...", () => {});
        } else if (p10021.account) {
          v8060.addOption("Username: " + p10021.account.name, () => {});
          v8060.addOption("My Games", () => showWindow(14));
          v8060.addOption("My Assets", () => p10021.myAssets());
        } else {
          v8060.addOption("Login", () => loginPopup());
        }
        var v8061 = v8050.addFolder("Help");
        v8061.addOption("Controls", () => showWindow(1));
        v8061.addOption("Guide", () => showWindow(8));
        v8050.addOption("Documentation", () => window.open("//docs.krunker.io", "_blank"));
        this.blueprint = v8050.toJSON();
        this.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
      }
    },
    panel: {
      state: {
        lock: function (p10154, p10155) {
          let v8062 = p10154.children[0].children[0];
          let v8063 = v8062.innerHTML.includes("open");
          v8062.innerHTML = "lock" + (v8063 ? "" : "_open");
          vO230.panel[p10155].locked = v8063;
        },
        setActive: function (p10156) {
          vO230.panel[p10156[1]].elem.id = p10156.join("_");
        },
        isActive: function (p10157) {
          return vO230.panel[p10157[1]].elem.id == p10157.join("_");
        },
        refresh: function (p10158) {
          let v8064 = document.getElementById(p10158);
          if (!v8064) {
            return;
          }
          let vVO2305 = vO230;
          p10158.split("_").forEach(p10159 => vVO2305 = vVO2305[p10159]);
          if (vVO2305.show) {
            vVO2305.show();
          }
        },
        refreshAll: function () {
          return UTILS.getObjKeys(vO230.panel, ["state", "blueprint", "objKeys", "folderStore", "show", "elem", "restore"]).forEach(p10160 => {
            vO230.panel.state.refresh("panel_" + p10160.replace(/\|/g, "_"));
          });
        }
      },
      left: {
        elem: document.getElementsByClassName("panel")[0].children[1],
        restore: document.getElementsByClassName("restore")[0],
        essential: {
          show: function () {
            p10021.resizable.restore(vO230.panel.left.restore);
            if (vO230.panel.left.locked && !vO230.panel.state.isActive(this.objKeys)) {
              return;
            }
            let vO231 = {};
            let vA401 = [];
            for (var vLN01311 = 0; vLN01311 < p10028.length; vLN01311++) {
              v8017 = p10028[vLN01311];
              if (!v8017.cost && (!v8017.preventCustomGames || !!p10021.account && !!p10021.account.isDev)) {
                if (p10021.serverConfig.modes[vLN01311] == null) {
                  p10021.serverConfig.modes[vLN01311] = !vLN01311;
                }
                vA401.push({
                  name: v8017.name + " [ID: " + vLN01311 + "]",
                  object: p10021.serverConfig.modes,
                  key: vLN01311,
                  type: "switch",
                  sub: 1
                });
              }
            }
            let vA402 = [];
            for (var vLN01311 = 0; vLN01311 < p10026.length; vLN01311++) {
              v8017 = p10026[vLN01311];
              if (!v8017.cost) {
                if (p10021.serverConfig.classes[vLN01311] == null) {
                  p10021.serverConfig.classes[vLN01311] = true;
                }
                vA402.push({
                  name: v8017.name + " [ID: " + vLN01311 + "]",
                  object: p10021.serverConfig.classes,
                  key: vLN01311,
                  type: "switch",
                  sub: 1
                });
              }
            }
            let vA403 = [];
            vO231 = {};
            for (var vLN01311 = 0; vLN01311 < config.serverConfig.length; vLN01311++) {
              v8017 = config.serverConfig[vLN01311];
              if (!v8017.cost && !v8017.hideE) {
                if (p10021.serverConfig.settings[v8017.varN] == null) {
                  p10021.serverConfig.settings[v8017.varN] = v8017.def;
                }
                var v8066 = vA403;
                if (v8017.sub) {
                  if (!vO231[v8017.sub]) {
                    vO231[v8017.sub] = {
                      name: v8017.sub,
                      type: "folder",
                      size: "small",
                      children: [],
                      closed: true
                    };
                    v8066.push(vO231[v8017.sub]);
                  }
                  v8066 = vO231[v8017.sub].children;
                }
                if (v8017.bool) {
                  v8066.push({
                    name: v8017.name,
                    object: p10021.serverConfig.settings,
                    key: v8017.varN,
                    type: "switch",
                    sub: 1
                  });
                } else if (v8017.input) {
                  v8066.push({
                    name: v8017.name,
                    object: p10021.serverConfig.settings,
                    key: v8017.varN,
                    type: "text",
                    sub: 1
                  });
                } else if (v8017.select) {
                  v8066.push({
                    name: v8017.name,
                    object: p10021.serverConfig.settings,
                    key: v8017.varN,
                    type: "select",
                    args: [v8017.options.map((p10161, p10162) => ({
                      name: p10161,
                      value: p10162
                    }))],
                    sub: 1
                  });
                } else {
                  v8066.push({
                    name: v8017.name,
                    object: p10021.serverConfig.settings,
                    key: v8017.varN,
                    type: "slider",
                    args: [v8017.min, v8017.maxF || v8017.maxP || v8017.max, v8017.step],
                    sub: 1
                  });
                }
              }
            }
            for (var vLN01311 = 0; vLN01311 < vA403.length; ++vLN01311) {
              if (vA403[vLN01311].children) {
                vA403[vLN01311].children.unshift({
                  type: "rule"
                });
                vA403[vLN01311].children.push({
                  type: "rule"
                });
              }
            }
            let vA404 = [];
            for (var vLN01312 = 0; vLN01312 < p10025.length; vLN01312++) {
              v8017 = p10025[vLN01312];
              if (p10021.serverConfig.weps[vLN01312] == null) {
                p10021.serverConfig.weps[vLN01312] = {};
              }
              vA404["w" + vLN01312] = {
                name: (p10021.serverConfig.weps[vLN01312].name || v8017.name) + " [ID: " + vLN01312 + "]",
                type: "folder",
                size: "small",
                children: [],
                closed: true
              };
              for (var vLN01311 = 0; vLN01311 < config.weaponConfig.length; vLN01311++) {
                v8018 = config.weaponConfig[vLN01311];
                if (p10025[vLN01312][v8018.varN] != null) {
                  if (p10021.serverConfig.weps[vLN01312][v8018.varN] == null) {
                    p10021.serverConfig.weps[vLN01312][v8018.varN] = p10025[vLN01312][v8018.varN];
                  }
                  if (v8018.varN == "name") {
                    vA404["w" + vLN01312].children.push({
                      id: vLN01312,
                      name: v8018.name,
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      onChange: function () {
                        delayTimer("WepName" + this.id, function () {
                          vO230.panel.state.refresh("panel_left_essential");
                        }, 1000);
                      },
                      sub: 1
                    });
                  } else if (v8018.varN == "pj_asset") {
                    vA404["w" + vLN01312].children.push({
                      name: v8018.name + " ID",
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1
                    });
                    vA404["w" + vLN01312].children.push({
                      id: vLN01312,
                      line: "wide",
                      object: p10021,
                      key: "selectWeaponAsset",
                      type: "button",
                      args: ["Select Asset"],
                      sub: 1
                    });
                  } else if (v8018.varN == "assetIcon") {
                    vA404["w" + vLN01312].children.push({
                      name: v8018.name + " ID",
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1
                    });
                    vA404["w" + vLN01312].children.push({
                      id: vLN01312,
                      line: "wide",
                      object: p10021,
                      key: "selectWeaponIcon",
                      type: "button",
                      args: ["Select Icon"],
                      sub: 1
                    });
                  } else if (v8018.bool) {
                    vA404["w" + vLN01312].children.push({
                      name: v8018.name,
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "switch",
                      sub: 1
                    });
                  } else if (v8018.input) {
                    vA404["w" + vLN01312].children.push({
                      name: v8018.name,
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      sub: 1
                    });
                  } else {
                    vA404["w" + vLN01312].children.push({
                      name: v8018.name,
                      object: p10021.serverConfig.weps[vLN01312],
                      key: v8018.varN,
                      type: "slider",
                      args: [v8018.min, v8018.max, v8018.step],
                      sub: 1
                    });
                  }
                }
              }
            }
            let vA405 = [];
            for (var vLN01312 = 0; vLN01312 < p10026.length; vLN01312++) {
              v8017 = p10026[vLN01312];
              if (p10021.serverConfig.cls[vLN01312] == null) {
                p10021.serverConfig.cls[vLN01312] = {};
              }
              vA405["c" + vLN01312] = {
                name: p10021.serverConfig.cls[vLN01312].name || v8017.name,
                type: "folder",
                size: "small",
                children: [],
                closed: true
              };
              vA405["c" + vLN01312].children.push({
                id: vLN01312,
                line: "wide",
                object: p10021,
                key: "copyPlayerConfig",
                type: "button",
                args: ["Copy to All Classes"],
                sub: 1
              });
              vA405["c" + vLN01312].children.push({
                id: vLN01312,
                line: "wide",
                object: p10021,
                key: "resetPlayerConfig",
                type: "button",
                args: ["Reset"],
                sub: 1
              });
              vO231 = {};
              for (var vLN01311 = 0; vLN01311 < config.classConfig.length; vLN01311++) {
                v8018 = config.classConfig[vLN01311];
                if (p10026[vLN01312][v8018.varN] != null) {
                  if (p10021.serverConfig.cls[vLN01312][v8018.varN] == null) {
                    p10021.serverConfig.cls[vLN01312][v8018.varN] = p10026[vLN01312][v8018.varN];
                  }
                  var v8066 = vA405["c" + vLN01312].children;
                  if (v8018.sub) {
                    if (!vO231[v8018.sub]) {
                      vO231[v8018.sub] = {
                        name: v8018.sub,
                        type: "folder",
                        size: "smaller",
                        children: [],
                        closed: true
                      };
                      v8066.push(vO231[v8018.sub]);
                      vO231[v8018.sub].children.push({
                        id: vLN01312,
                        cat: v8018.sub,
                        line: "wide",
                        object: p10021,
                        key: "copyPlayerConfigCat",
                        type: "button",
                        args: ["Copy " + v8018.sub + " to All Classes"],
                        sub: 1
                      });
                    }
                    v8066 = vO231[v8018.sub].children;
                  }
                  if (v8018.varN == "name") {
                    v8066.push({
                      id: vLN01312,
                      name: v8018.name,
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      onChange: function () {
                        delayTimer("ClassName" + this.id, function () {
                          vO230.panel.state.refresh("panel_left_essential");
                        }, 1000);
                      },
                      sub: 1
                    });
                  } else if (v8018.varN == "aID") {
                    v8066.push({
                      name: v8018.name + " ID",
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1
                    });
                    v8066.push({
                      id: vLN01312,
                      line: "wide",
                      object: p10021,
                      key: "selectPlayerType",
                      type: "button",
                      args: ["Select Asset"],
                      sub: 1
                    });
                  } else if (v8018.varN == "cID") {
                    v8066.push({
                      name: v8018.name + " ID",
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1
                    });
                    v8066.push({
                      id: vLN01312,
                      line: "wide",
                      object: p10021,
                      key: "selectCrosshair",
                      type: "button",
                      args: ["Select Asset"],
                      sub: 1
                    });
                  } else if (v8018.varN == "ccID") {
                    v8066.push({
                      name: v8018.name + " ID",
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1
                    });
                    v8066.push({
                      id: vLN01312,
                      line: "wide",
                      object: p10021,
                      key: "selectCrosshairC",
                      type: "button",
                      args: ["Select Asset"],
                      sub: 1
                    });
                  } else if (v8018.bool) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "switch",
                      sub: 1
                    });
                  } else if (v8018.input) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      sub: 1
                    });
                  } else if (v8018.select) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "select",
                      args: [v8018.options.map((p10163, p10164) => ({
                        name: p10163,
                        value: p10164
                      }))],
                      sub: 1
                    });
                  } else {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.cls[vLN01312],
                      key: v8018.varN,
                      type: "slider",
                      args: [v8018.min, v8018.maxF || v8018.maxP || v8018.max, v8018.step],
                      sub: 1
                    });
                  }
                }
              }
            }
            for (var vLN01312 = 0; vLN01312 < p10026.length; vLN01312++) {
              if (vA405["c" + vLN01312].children) {
                vA405["c" + vLN01312].children.unshift({
                  type: "rule"
                });
                vA405["c" + vLN01312].children.push({
                  type: "rule"
                });
              }
            }
            let vA406 = [];
            for (var vLN01312 = 0; vLN01312 < p10027.length; vLN01312++) {
              v8017 = p10027[vLN01312];
              if (p10021.serverConfig.prks[vLN01312] == null) {
                p10021.serverConfig.prks[vLN01312] = {};
              }
              vA406["p" + vLN01312] = {
                name: p10021.serverConfig.prks[vLN01312].name || v8017.name,
                type: "folder",
                size: "small",
                children: [],
                closed: true
              };
              vA406["p" + vLN01312].children.push({
                id: vLN01312,
                line: "wide",
                object: p10021,
                key: "resetEffectConfig",
                type: "button",
                args: ["Reset"],
                sub: 1
              });
              vO231 = {};
              for (var vLN01311 = 0; vLN01311 < config.effectConfig.length; vLN01311++) {
                v8018 = config.effectConfig[vLN01311];
                if (p10027[vLN01312][v8018.varN] != null) {
                  if (p10021.serverConfig.prks[vLN01312][v8018.varN] == null) {
                    p10021.serverConfig.prks[vLN01312][v8018.varN] = p10027[vLN01312][v8018.varN];
                  }
                  var v8066 = vA406["p" + vLN01312].children;
                  if (v8018.sub) {
                    if (!vO231[v8018.sub]) {
                      vO231[v8018.sub] = {
                        name: v8018.sub,
                        type: "folder",
                        size: "smaller",
                        children: [],
                        closed: true
                      };
                      v8066.push(vO231[v8018.sub]);
                    }
                    v8066 = vO231[v8018.sub].children;
                  }
                  if (v8018.varN == "name") {
                    v8066.push({
                      id: vLN01312,
                      name: v8018.name,
                      object: p10021.serverConfig.prks[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      onChange: function () {
                        delayTimer("EffectName" + this.id, function () {
                          vO230.panel.state.refresh("panel_left_essential");
                        }, 1000);
                      },
                      sub: 1
                    });
                  } else if (v8018.bool) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.prks[vLN01312],
                      key: v8018.varN,
                      type: "switch",
                      sub: 1
                    });
                  } else if (v8018.input) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.prks[vLN01312],
                      key: v8018.varN,
                      type: "text",
                      sub: 1
                    });
                  } else if (v8018.select) {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.prks[vLN01312],
                      key: v8018.varN,
                      type: "select",
                      args: [v8018.options.map((p10165, p10166) => ({
                        name: p10165,
                        value: p10166
                      }))],
                      sub: 1
                    });
                  } else {
                    v8066.push({
                      name: v8018.name,
                      object: p10021.serverConfig.prks[vLN01312],
                      key: v8018.varN,
                      type: "slider",
                      args: [v8018.min, v8018.maxF || v8018.maxP || v8018.max, v8018.step],
                      sub: 1
                    });
                  }
                }
              }
            }
            for (var vLN01312 = 0; vLN01312 < p10027.length; vLN01312++) {
              if (vA406["p" + vLN01312].children) {
                vA406["p" + vLN01312].children.unshift({
                  type: "rule"
                });
                vA406["p" + vLN01312].children.push({
                  type: "rule"
                });
              }
            }
            var v8067 = new f1330({
              type: "folder",
              size: "standard"
            });
            v8067.addPanelButton("Essential", "left");
            v8067.add("text", "Name", p10021.mapConfig, "name", "Name");
            v8067.add("text", "Welcome Msg", p10021.mapConfig, "welMsg", "Welcome");
            v8067.add("text", "Mod URL", p10021.mapConfig, "modURL", "Mod URL");
            v8067.add("button", null, p10021.advancedOptions, "selectMod", "Select Mod", null, true);
            v8067.add("slider", "Death Height", p10021.mapConfig, "dthY", [-1000, 3000, 1], function (p10167, p10168) {
              p10021.mapConfig.dthY = p10168;
              p10021.updateDeathBarrier();
            });
            v8067.add("switch", "Force Old AO", p10021.mapConfig, "oldAO", null);
            v8067.add("text", "Minimap AssetId", p10021.mapConfig, "mmId", null);
            v8067.addRule();
            v8067.addFolder("Game Modes", vA401, null, "folder", "standard", true);
            v8067.addFolder("Server Preset", vA403, null, "folder", "standard", true);
            v8067.addFolder("Weapon Config", vA404, null, "folder", "standard", true);
            v8067.addFolder("Classes", vA402, null, "folder", "standard", true);
            v8067.addFolder("Class Config", vA405, null, "folder", "standard", true);
            v8067.addFolder("Effect Config", vA406, null, "folder", "standard", true);
            this.blueprint = v8067.toJSON();
            vO230.panel.state.setActive(this.objKeys);
            vO230.panel.left.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
          }
        }
      },
      right: {
        elem: document.getElementsByClassName("panel")[1].children[1],
        restore: document.getElementsByClassName("restore")[1],
        blank: {
          show: function () {
            if (!vO230.panel.right.locked || !!vO230.panel.state.isActive(this.objKeys)) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  blank: true
                }
              };
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        object: {
          show: function () {
            if (vO230.panel.right.locked && !vO230.panel.state.isActive(this.objKeys)) {
              return;
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Object"
              }
            };
            vO230.panel.right.blank.show();
            let v8068 = p10021.transformControl.object;
            if (!v8068) {
              return;
            }
            let v8069 = v8068.userData.owner;
            let v8070 = Object.keys(p10021.objGroups).includes(v8069.boundingMesh.uuid);
            this.blueprint.panelButtons.label = v8070 ? "Group" : v8069.name;
            for (var v8071 of p10021.configVal) {
              p10021.objConfig[v8071] = v8069[v8071];
            }
            let vO232 = {};
            let v8072 = p10021.objConfig;
            for (let v8073 of p10021.stringifiedColors) {
              Object.defineProperty(vO232, v8073, {
                get() {
                  return UTILS.stringifyColor(v8072[v8073]);
                },
                set(p10169) {
                  return v8072[v8073] = UTILS.parseColor(p10169);
                }
              });
            }
            if (v8069.prefab.ai) {
              this.blueprint.aiName = {
                name: "AI Name",
                object: p10021.objConfig,
                key: "aiName",
                type: "text",
                args: ["BOT"],
                onChange: function (p10170, p10171) {
                  v8069.aiName = p10171;
                }
              };
            }
            if (v8069.prefab.bot) {
              this.blueprint.botName = {
                name: "Bot Name",
                object: p10021.objConfig,
                key: "botName",
                type: "text",
                args: ["Gnomie"],
                onChange: function (p10172, p10173) {
                  v8069.botName = p10173;
                }
              };
            }
            if (!v8069.prefab.tool || v8069.prefab.bounce) {
              this.blueprint.visible = {
                name: "Visible",
                object: p10021.objConfig,
                key: "visible",
                type: "switch",
                onChange: function (p10174, p10175) {
                  v8069.visible = p10175;
                }
              };
            }
            if (!v8069.prefab.tool && !v8069.prefab.forceCollision && !v8069.prefab.noCollision) {
              this.blueprint.collidable = {
                name: "Collidable",
                object: p10021.objConfig,
                key: "collidable",
                type: "switch",
                onChange: function (p10176, p10177) {
                  p10021.objCount[p10021.cntCheck(v8069)]--;
                  v8069.collidable = p10177;
                  p10021.objCount[p10021.cntCheck(v8069)]++;
                  p10021.warningCheck("objects");
                  p10021.updateObjectCount();
                }
              };
            }
            if (v8069.prefab.canComplexColl) {
              this.blueprint.complexColl = {
                name: "Complex Collisions",
                object: p10021.objConfig,
                key: "complexColl",
                type: "switch",
                onChange: function (p10178, p10179) {
                  v8069.complexColl = p10179;
                }
              };
            }
            if (v8069.prefab.name == "TRIGGER") {
              this.blueprint.playerCollidable = {
                name: "Player Collidable",
                object: p10021.objConfig,
                key: "playerCollidable",
                type: "switch",
                onChange: function (p10180, p10181) {
                  v8069.playerCollidable = p10181;
                }
              };
            }
            if (v8069.prefab.editBulletCol) {
              this.blueprint.bulletColl = {
                name: "Bullet Collisions",
                object: p10021.objConfig,
                key: "bulletColl",
                type: "switch",
                onChange: function (p10182, p10183) {
                  v8069.bulletColl = p10183;
                }
              };
            }
            if (v8069.prefab.editAICol) {
              this.blueprint.aiColl = {
                name: "AI Collisions",
                object: p10021.objConfig,
                key: "aiColl",
                type: "switch",
                onChange: function (p10184, p10185) {
                  v8069.aiColl = p10185;
                }
              };
            }
            if (v8069.prefab.editPen) {
              this.blueprint.penetrable = {
                name: "Penetrable",
                object: p10021.objConfig,
                key: "penetrable",
                type: "slider",
                args: [0, 1, 0.01],
                onChange: function (p10186, p10187) {
                  v8069.penetrable = p10187;
                }
              };
            }
            if (v8069.prefab.canWallJump) {
              this.blueprint.canWallJump = {
                name: "Wall Jumpable",
                object: p10021.objConfig,
                key: "canWallJump",
                type: "switch",
                onChange: function (p10188, p10189) {
                  v8069.canWallJump = p10189;
                }
              };
            }
            if (v8069.prefab.canGrapple) {
              this.blueprint.canGrapple = {
                name: "Can Grapple",
                object: p10021.objConfig,
                key: "canGrapple",
                type: "switch",
                onChange: function (p10190, p10191) {
                  v8069.canGrapple = p10191;
                }
              };
            }
            if (v8069.prefab.canImpulse) {
              this.blueprint.canImpulse = {
                name: "Can Impulse",
                object: p10021.objConfig,
                key: "canImpulse",
                type: "switch",
                onChange: function (p10192, p10193) {
                  v8069.canImpulse = p10193;
                }
              };
            }
            if (v8069.prefab.boostable) {
              this.blueprint.boost = {
                name: "Boost",
                object: p10021.objConfig,
                key: "boost",
                type: "slider",
                args: [-config.boostRange, config.boostRange, 0.01],
                onChange: function (p10194, p10195) {
                  v8069.boost = p10195;
                }
              };
            }
            if (v8069.prefab.bounce) {
              this.blueprint.bounce = {
                name: "Bounce",
                object: p10021.objConfig,
                key: "bounce",
                type: "slider",
                args: [-3, 3, 0.1],
                onChange: function (p10196, p10197) {
                  v8069.bounce = p10197;
                }
              };
              this.blueprint.crouch = {
                name: "Crouch Reduces",
                object: p10021.objConfig,
                key: "crouch",
                type: "switch",
                onChange: function (p10198, p10199) {
                  v8069.crouch = p10199;
                }
              };
            }
            if (v8069.prefab.edgeNoise) {
              this.blueprint.edgeNoise = {
                name: "Edge Noise",
                object: p10021.objConfig,
                key: "edgeNoise",
                type: "slider",
                args: [-5, 5, 0.1],
                onChange: function (p10200, p10201) {
                  v8069.edgeNoise = p10201;
                }
              };
            }
            if (v8069.prefab.hasBorder) {
              this.blueprint.border = {
                name: "Border",
                object: p10021.objConfig,
                key: "border",
                type: "switch",
                onChange: function (p10202, p10203) {
                  v8069.border = p10203;
                }
              };
            }
            if (v8069.prefab.showMinimap) {
              this.blueprint.showMinimap = {
                name: "Show On Minimap",
                object: p10021.objConfig,
                key: "showMinimap",
                type: "switch",
                onChange: function (p10204, p10205) {
                  v8069.showMinimap = p10205;
                }
              };
            }
            if (v8069.prefab.name == "MAP_ANCHOR") {
              this.blueprint.anchorType = {
                name: "Anchor Type",
                object: p10021.objConfig,
                key: "anchorType",
                type: "select",
                args: [[{
                  name: "Corner",
                  value: 0
                }, {
                  name: "Center",
                  value: 1
                }]],
                onChange: function (p10206, p10207) {
                  v8069.anchorType = p10207;
                }
              };
            }
            if (v8069.prefab.name == "KR_ZONE") {
              this.blueprint.minimum = {
                name: "Minimum Amount",
                object: p10021.objConfig,
                key: "minimum",
                type: "slider",
                args: [0, 10000000, 100],
                onChange: function (p10208, p10209) {
                  v8069.minimum = p10209;
                }
              };
            }
            if (v8069.prefab.gen || v8069.prefab.hasSpin) {
              this.blueprint.spin = {
                name: "Spin",
                object: p10021.objConfig,
                key: "spin",
                type: "slider",
                args: [-20, 20, 0.1],
                onChange: function (p10210, p10211) {
                  v8069.spin = p10211;
                }
              };
              if (v8069.prefab.gen || v8069.prefab.hasSpinDir) {
                this.blueprint.spinAxis = {
                  name: "Spin Axis",
                  object: p10021.objConfig,
                  key: "spinAxis",
                  type: "select",
                  args: [[{
                    name: "Y",
                    value: 0
                  }, {
                    name: "X",
                    value: 1
                  }]],
                  onChange: function (p10212, p10213) {
                    if (v8069.defaultMesh) {
                      v8069.defaultMesh.rotation.set(0, 0, 0);
                    }
                    if (v8069.mesh) {
                      v8069.mesh.rotation.set(0, 0, 0);
                    }
                    v8069.spinAxis = parseInt(p10213);
                  }
                };
              }
            }
            if (v8069.prefab.name == "CYLINDER") {
              this.blueprint.openEnded = {
                name: "Open Ended",
                object: p10021.objConfig,
                key: "openEnded",
                type: "switch",
                onChange: function (p10214, p10215) {
                  v8069.openEnded = p10215;
                  v8069.regen();
                }
              };
              this.blueprint.radiusTop = {
                name: "Radius Top",
                object: p10021.objConfig,
                key: "radiusTop",
                type: "slider",
                args: [0, 1, 0.01],
                onChange: function (p10216, p10217) {
                  v8069.radiusTop = p10217;
                  v8069.regen();
                }
              };
              this.blueprint.radiusBottom = {
                name: "Radius Bottom",
                object: p10021.objConfig,
                key: "radiusBottom",
                type: "slider",
                args: [0, 1, 0.01],
                onChange: function (p10218, p10219) {
                  v8069.radiusBottom = p10219;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "LIGHT_CONE" || v8069.prefab.name == "CYLINDER") {
              this.blueprint.sides = {
                name: "Sides",
                object: p10021.objConfig,
                key: "sides",
                type: "slider",
                args: [3, 64, 1],
                onChange: function (p10220, p10221) {
                  v8069.sides = p10221;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "CYLINDER") {
              this.blueprint.thetaStart = {
                name: "Theta Start",
                object: p10021.objConfig,
                key: "thetaStart",
                type: "slider",
                args: [v8069.prefab.name == "CYLINDER" ? 0 : 1, 360, 0.1],
                onChange: function (p10222, p10223) {
                  v8069.thetaStart = p10223;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "LIGHT_CONE" || v8069.prefab.name == "CYLINDER") {
              this.blueprint.thetaLength = {
                name: "Theta Length",
                object: p10021.objConfig,
                key: "thetaLength",
                type: "slider",
                args: [0.1, 360, 0.1],
                onChange: function (p10224, p10225) {
                  v8069.thetaLength = p10225;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "LEADERBOARD") {
              this.blueprint.leaderType = {
                name: "Leader Type",
                object: p10021.objConfig,
                key: "leaderType",
                type: "select",
                args: [[{
                  name: "Score",
                  value: 0
                }, {
                  name: "Time",
                  value: 1
                }]],
                onChange: function (p10226, p10227) {
                  v8069.leaderType = p10227;
                }
              };
              this.blueprint.leaderTypeCust = {
                name: "Leader Type Custom",
                object: p10021.objConfig,
                key: "leaderTypeCust",
                type: "text",
                args: [""],
                onChange: function (p10228, p10229) {
                  v8069.leaderTypeCust = p10229;
                }
              };
              this.blueprint.leaderOrder = {
                name: "Leader Order",
                object: p10021.objConfig,
                key: "leaderOrder",
                type: "select",
                args: [[{
                  name: "ASC",
                  value: 0
                }, {
                  name: "DESC",
                  value: 1
                }]],
                onChange: function (p10230, p10231) {
                  v8069.leaderOrder = p10231;
                }
              };
              this.blueprint.leaderResults = {
                name: "Leader Results",
                object: p10021.objConfig,
                key: "leaderResults",
                type: "slider",
                args: [1, 50, 1],
                onChange: function (p10232, p10233) {
                  v8069.leaderResults = p10233;
                  v8069.regen(true);
                }
              };
            }
            if (v8069.prefab.customDirection) {
              this.blueprint.direction = {
                name: "Direction",
                object: p10021.objConfig,
                key: "direction",
                type: "slider",
                args: [0, v8069.prefab.extraDirection ? 7 : v8069.prefab.altDirection ? 5 : 3, 1],
                onChange: function (p10234, p10235) {
                  v8069.direction = p10235;
                }
              };
            }
            if (v8069.prefab.optionalDirection) {
              this.blueprint.forceDir = {
                name: "Force Direction",
                object: p10021.objConfig,
                key: "forceDir",
                type: "switch",
                onChange: function (p10236, p10237) {
                  v8069.forceDir = p10237;
                }
              };
            }
            if (v8069.prefab.teamable) {
              var v8079 = Array((v8069.prefab.noDefault ? 1 : 0) + config.teamLimit).fill(0).map((p10238, p10239) => ({
                name: v8069.prefab.noDefault ? config.teamNames[p10239] : p10239 == 0 ? "Default" : config.teamNames[p10239 - 1],
                value: p10239
              }));
              if (v8069.prefab.canNeutral) {
                v8079.push({
                  name: "Neutral",
                  value: -1
                });
              }
              this.blueprint.teamable = {
                name: "Team",
                object: p10021.objConfig,
                key: "team",
                type: "select",
                args: [v8079],
                onChange: function (p10240, p10241) {
                  v8069.team = p10241;
                  if (v8069.objType == "SPAWN_POINT" || v8069.objType == "FLAG") {
                    v8069.regen();
                  }
                }
              };
            }
            if (v8069.objType == "SERVER_NODE") {
              this.blueprint.nodeTag = {
                name: "Tag",
                object: p10021.objConfig,
                key: "nodeTag",
                type: "text",
                args: [""],
                onChange: function (p10242, p10243) {
                  v8069.nodeTag = p10243;
                }
              };
              this.blueprint.spread = {
                name: "Max Spread",
                object: p10021.objConfig,
                key: "spread",
                type: "slider",
                args: [0, 50, 0.1],
                onChange: function (p10244, p10245) {
                  v8069.spread = p10245;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "RAMP") {
              this.blueprint.enclose = {
                name: "Enclose",
                object: p10021.objConfig,
                key: "enclose",
                type: "switch",
                onChange: function (p10246, p10247) {
                  v8069.enclose = p10247;
                  v8069.regen();
                }
              };
            }
            if (v8069.prefab.name == "CAMERA_POSITION") {
              this.blueprint.static = {
                name: "Static Cam",
                object: p10021.objConfig,
                key: "static",
                type: "switch",
                onChange: function (p10248, p10249) {
                  v8069.static = p10249;
                }
              };
            }
            if (v8069.prefab.name == "PATH_NODE") {
              this.blueprint.nodeId = {
                name: "Node Id",
                object: p10021.objConfig,
                key: "nodeId",
                type: "slider",
                args: [0, 1000, 1],
                onChange: function (p10250, p10251) {
                  v8069.nodeId = p10251;
                }
              };
            }
            if (v8069.prefab.name == "PRIZE_WHEEL") {
              this.blueprint.stype = {
                name: "Spin Type",
                object: p10021.objConfig,
                key: "stype",
                type: "select",
                args: [[{
                  name: "Starter",
                  value: 0
                }, {
                  name: "Elite",
                  value: 1
                }, {
                  name: "Heroic",
                  value: 2
                }]],
                onChange: function (p10252, p10253) {
                  v8069.stype = p10253;
                }
              };
            }
            if (v8069.prefab.gen) {
              this.blueprint.mSize = {
                name: "Model Scale",
                object: p10021.objConfig,
                key: "mSize",
                type: "slider",
                args: [0.01, 100, 0.01],
                onChange: function (p10254, p10255) {
                  v8069.mSize = p10255;
                  v8069.updateMeshScale();
                }
              };
              if (v8069.prefab.ai) {
                this.blueprint.mYOff = {
                  name: "Model Y Offset",
                  object: p10021.objConfig,
                  key: "mYOff",
                  type: "slider",
                  args: [-100, 100, 0.1],
                  onChange: function (p10256, p10257) {
                    v8069.mYOff = p10257;
                    v8069.regenM();
                  }
                };
                this.blueprint.mROff = {
                  name: "Model Direction",
                  object: p10021.objConfig,
                  key: "mROff",
                  type: "slider",
                  args: [0, 360, 1],
                  onChange: function (p10258, p10259) {
                    v8069.mROff = p10259;
                    v8069.regenM();
                  }
                };
              }
            }
            if (v8069.prefab.sprayTexture) {
              this.blueprint.sprayTexture = {
                name: "Spray",
                object: p10021.objConfig,
                key: "sprayTexture",
                type: "selectClick",
                line: "nodiv",
                args: [p10021.sprayList],
                onChange: function (p10260, p10261) {
                  v8069.sprayTexture = p10261;
                  p10021.updateObjConfigGUI();
                },
                icon: "dashboard_customize",
                onClick: () => p10021.viewTextureList(),
                sub: 1
              };
            }
            if (v8069.prefab.name == "SHOWCASE") {
              this.blueprint.itemID = {
                name: "Item",
                object: p10021.objConfig,
                key: "itemID",
                type: "selectClick",
                line: "nodiv",
                args: [Object.keys(p10021.skinList).map(p10262 => ({
                  name: p10262,
                  value: p10021.skinList[p10262]
                }))],
                onChange: function (p10263, p10264) {
                  v8069.itemID = p10264;
                  v8069.regenM();
                },
                icon: "dashboard_customize",
                onClick: () => p10021.viewTextureList()
              };
            }
            if (v8069.prefab.canSetObjective) {
              this.blueprint.objectiveId = {
                name: "Objective Id",
                object: p10021.objConfig,
                key: "objectiveId",
                type: "slider",
                args: [0, 10, 1],
                onChange: function (p10265, p10266) {
                  v8069.objectiveId = p10266;
                }
              };
            }
            if (v8069.prefab.name == "CAMERA") {
              this.blueprint.camType = {
                name: "Camera Type",
                object: p10021.objConfig,
                key: "camType",
                type: "select",
                args: [config.cameraTypes.map((p10267, p10268) => ({
                  name: p10267,
                  value: p10268
                }))],
                onChange: function (p10269, p10270) {
                  v8069.camType = p10270;
                  vO230.panel.state.refresh("panel_right_object");
                }
              };
              if (v8069.camType == 0) {
                this.blueprint.objectiveLink = {
                  name: "Objective Link",
                  object: p10021.objConfig,
                  key: "objectiveLink",
                  type: "slider",
                  args: [-1, 10, 1],
                  onChange: function (p10271, p10272) {
                    v8069.objectiveLink = p10272;
                  }
                };
              } else if (v8069.camType == 1) {
                this.blueprint.forceCam = {
                  name: "Force Player Cam",
                  object: p10021.objConfig,
                  key: "forceCam",
                  type: "switch",
                  onChange: function (p10273, p10274) {
                    v8069.forceCam = p10274;
                  }
                };
                this.blueprint.followPath = {
                  name: "Follow Path",
                  object: p10021.objConfig,
                  key: "followPath",
                  type: "text",
                  args: ["id,id,id"],
                  onChange: function (p10275, p10276) {
                    v8069.followPath = p10276;
                  }
                };
              }
            }
            if (v8069.prefab.stepSrc) {
              this.blueprint.stepSrc = {
                name: "Step Sound",
                object: p10021.objConfig,
                key: "stepSrc",
                type: "select",
                args: [Object.keys(p10021.stepsList).map(p10277 => ({
                  name: p10277,
                  value: p10021.stepsList[p10277]
                }))],
                onChange: function (p10278, p10279) {
                  v8069.stepSrc = p10279;
                }
              };
            }
            this.blueprint.rule = {
              type: "rule"
            };
            this.blueprint.transform = {
              name: "Transform",
              type: "folder",
              size: "standard",
              children: {
                position: {
                  name: "Position",
                  object: p10021.objConfig,
                  key: "pos",
                  type: "vector3",
                  round: 2,
                  onChange: function (p10280, p10281) {
                    v8069.pos = p10281;
                  }
                }
              },
              closed: !v8070
            };
            if (!v8069.prefab.noRotation) {
              this.blueprint.transform.children.rotation = {
                name: "Rotation",
                object: p10021.objConfig,
                key: "rot",
                type: "vector3",
                round: 2,
                onChange: function (p10282, p10283) {
                  v8069.rot = p10021.degToRad(p10283);
                }
              };
            }
            if (v8069.prefab.scalable && !v8069.assetID) {
              this.blueprint.transform.children.size = {
                name: "Size",
                object: p10021.objConfig,
                key: "size",
                type: "vector3",
                min: 0,
                round: 2,
                onChange: function (p10284, p10285) {
                  if (v8069.prefab.noScaleX) {
                    p10285[0] = v8069.prefab.defaultSize[0];
                  }
                  if (v8069.prefab.noScaleY) {
                    p10285[1] = v8069.prefab.defaultSize[1];
                  }
                  v8069.size = p10285;
                }
              };
            }
            if (v8070) {
              this.blueprint.transform.children.reflect = {
                name: "Reflect",
                type: "folder",
                size: "small",
                children: {
                  direction: {
                    name: "Direction",
                    object: p10021.advancedOptions,
                    key: "groupReflectDir",
                    type: "select",
                    args: [[{
                      name: "X",
                      value: 0
                    }, {
                      name: "Y",
                      value: 1
                    }, {
                      name: "Z",
                      value: 2
                    }]],
                    sub: 1
                  },
                  execute: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "groupReflect",
                    type: "button",
                    args: ["Execute"]
                  }
                }
              };
            }
            if (!v8069.prefab.notStyleable) {
              let vO233 = {};
              if (v8070) {
                vO233.tex = {
                  name: "Texture",
                  object: p10021.advancedOptions,
                  key: "texture",
                  type: "select",
                  args: [p10021.textureList],
                  onChange: function (p10286, p10287) {
                    p10021.editGroup("texture", p10287);
                  }
                };
                vO233.color = {
                  name: "Color",
                  object: p10021.advancedOptions,
                  key: "editColor",
                  type: "button",
                  args: ["Open"]
                };
              }
              if ((v8069.prefab.texturable || v8069.prefab.movingTexture || v8069.prefab.frameTexture) && !v8069.prefab.sprayTexture) {
                vO233.texture = {
                  name: "Texture",
                  type: "folder",
                  size: "small",
                  children: {},
                  closed: true
                };
              }
              if (v8069.prefab.ai || v8069.prefab.name == "CUSTOM_ASSET" || v8069.prefab.name == "TRIGGER") {
                vO233.assetID = {
                  name: "Asset ID",
                  object: p10021.objConfig,
                  key: "assetID",
                  type: "text",
                  args: ["ID"],
                  onChange: function (p10288, p10289) {
                    v8069.assetID = p10289;
                    v8069.regenM();
                  },
                  sub: 1
                };
                vO233.customSelect = {
                  line: "wide",
                  object: p10021.advancedOptions,
                  key: "selectModel",
                  type: "button",
                  args: ["Select Custom"]
                };
              }
              if (v8069.prefab.texturable && !v8069.prefab.sprayTexture) {
                vO233.texture.children.type = {
                  name: "Type",
                  object: p10021.objConfig,
                  key: "texture",
                  type: "selectClick",
                  line: "nodiv",
                  args: [p10021.textureList],
                  onChange: function (p10290, p10291) {
                    v8069.assetTexture = 0;
                    v8069.texture = p10291;
                    p10021.updateObjConfigGUI();
                  },
                  icon: "dashboard_customize",
                  onClick: () => p10021.viewTextureList(),
                  sub: 1
                };
                if (v8069.texturePrefab && v8069.texturePrefab.variants) {
                  vO233.texture.children.texVar = {
                    name: "Variant",
                    object: p10021.objConfig,
                    key: "texVar",
                    type: "select",
                    args: [v8069.texturePrefab.variants.map((p10292, p10293) => ({
                      name: p10292.name,
                      value: p10293
                    }))],
                    onChange: function (p10294, p10295) {
                      v8069.texVar = parseInt(p10295);
                      v8069.texture = v8069.texture;
                    },
                    sub: 1
                  };
                }
                if (v8069.prefab.assetTextures) {
                  vO233.texture.children.custom = {
                    name: "Asset ID",
                    object: p10021.objConfig,
                    key: "assetTexture",
                    type: "text",
                    args: ["Texture Asset ID", 0],
                    onChange: function (p10296, p10297) {
                      v8069.assetTexture = p10297;
                    },
                    sub: 1
                  };
                  vO233.texture.children.customSelect = {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectTexture",
                    type: "button",
                    args: ["Select Custom"]
                  };
                }
                if (v8069.prefab.canStretch) {
                  vO233.texture.children.stretch = {
                    name: "Stretch",
                    object: p10021.objConfig,
                    key: "texStretch",
                    type: "switch",
                    onChange: function (p10298, p10299) {
                      v8069.texStretch = p10299;
                      v8069.regen();
                    },
                    sub: 1
                  };
                  vO233.texture.children.scale = {
                    name: "Scale",
                    object: p10021.objConfig,
                    key: "texScale",
                    type: "slider",
                    args: [0, 10, 0.01],
                    onChange: function (p10300, p10301) {
                      v8069.texScale = p10301;
                      v8069.regen();
                    },
                    sub: 1
                  };
                }
              }
              if ((v8069.prefab.texturable && !v8069.prefab.sprayTexture || v8069.prefab.name == "AI_SPAWNER") && v8069.prefab.canTrans) {
                vO233.texture.children.forceTrans = {
                  name: "Force Transparency",
                  object: p10021.objConfig,
                  key: "forceTrans",
                  type: "switch",
                  onChange: function (p10302, p10303) {
                    v8069.forceTrans = p10303;
                  },
                  sub: 1
                };
              }
              if (v8069.prefab.texturable && !v8069.prefab.sprayTexture) {
                vO233.texture.children.rotation = {
                  name: "Rotation",
                  object: p10021.objConfig,
                  key: "texRot",
                  type: "slider",
                  args: [0, 360, 1],
                  onChange: function (p10304, p10305) {
                    v8069.texRot = p10305;
                  },
                  sub: 1
                };
                vO233.texture.children.offset = {
                  name: "Offset",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    x: {
                      name: "X",
                      object: p10021.objConfig,
                      key: "texOffX",
                      type: "slider",
                      args: [0, 1, 0.01],
                      onChange: function (p10306, p10307) {
                        v8069.texOffX = p10307;
                      },
                      sub: 2
                    },
                    y: {
                      name: "Y",
                      object: p10021.objConfig,
                      key: "texOffY",
                      type: "slider",
                      args: [0, 1, 0.01],
                      onChange: function (p10308, p10309) {
                        v8069.texOffY = p10309;
                      },
                      sub: 2
                    }
                  },
                  sub: 1
                };
              }
              if (v8069.prefab.movingTexture) {
                vO233.texture.children.movement = {
                  name: "Movement",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    speed: {
                      name: "Speed",
                      object: p10021.objConfig,
                      key: "movingSpeed",
                      type: "slider",
                      args: [-20, 20, 0.1],
                      onChange: function (p10310, p10311) {
                        v8069.movingSpeed = p10311;
                      },
                      sub: 2
                    },
                    axis: {
                      name: "Axis",
                      object: p10021.objConfig,
                      key: "movingAxis",
                      type: "select",
                      args: [[{
                        name: "X",
                        value: 0
                      }, {
                        name: "Y",
                        value: 1
                      }]],
                      onChange: function (p10312, p10313) {
                        v8069.movingAxis = p10313;
                      },
                      sub: 2
                    }
                  },
                  sub: 1
                };
              }
              if (v8069.prefab.frameTexture) {
                vO233.texture.children.frame = {
                  name: "Frame Animation",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    frames: {
                      name: "Frame Count",
                      object: p10021.objConfig,
                      key: "frameCount",
                      type: "slider",
                      args: [0, 100, 1],
                      onChange: function (p10314, p10315) {
                        v8069.frameCount = p10315;
                        v8069.frameCur = 0;
                        v8069.frameDur = v8069.frameSpeed * 100;
                        v8069.frameNumX = Math.min(10, v8069.frameCount);
                        v8069.frameNumY = v8069.frameCount > 10 ? Math.ceil(v8069.frameCount / 10) : 0;
                        v8069.regen(true);
                      },
                      sub: 2
                    },
                    frameT: {
                      name: "Frame Speed",
                      object: p10021.objConfig,
                      key: "frameSpeed",
                      type: "slider",
                      args: [0, 10, 0.1],
                      onChange: function (p10316, p10317) {
                        v8069.frameSpeed = p10317;
                        v8069.frameDur = v8069.frameSpeed * 100;
                        v8069.frameCur = 0;
                      },
                      sub: 2
                    }
                  },
                  sub: 1
                };
              }
              if (vO233.texture) {
                vO233.texture.children.rule = {
                  type: "rule"
                };
              }
              if (v8069.prefab.variants) {
                vO233.texVar = {
                  name: "Variant",
                  object: p10021.objConfig,
                  key: "texVar",
                  type: "selectClick",
                  line: "nodiv",
                  args: [v8069.prefab.variants.map((p10318, p10319) => ({
                    name: p10318.name,
                    value: p10319
                  }))],
                  onChange: function (p10320, p10321) {
                    v8069.texVar = parseInt(p10321);
                    v8069.regenM();
                  },
                  icon: "dashboard_customize",
                  onClick: () => p10021.viewModelList()
                };
              }
              if (!v8069.prefab.sprayTexture) {
                vO233.texEncode = {
                  name: "Encoding",
                  object: p10021.objConfig,
                  key: "texEncode",
                  type: "select",
                  args: [config.encodingTypes.map((p10322, p10323) => ({
                    name: p10322.name,
                    value: p10323
                  }))],
                  onChange: function (p10324, p10325) {
                    v8069.texEncode = p10325;
                  }
                };
              }
              if (v8069.prefab.editColor) {
                vO233.color = {
                  name: "Color",
                  object: vO232,
                  key: "color",
                  type: "color",
                  onChange: function (p10326, p10327) {
                    v8069.color = p10327;
                  }
                };
              }
              if (v8069.prefab.editEmissive) {
                vO233.emissive = {
                  name: "Emissive",
                  object: vO232,
                  key: "emissive",
                  type: "color",
                  onChange: function (p10328, p10329) {
                    v8069.emissive = p10329;
                  }
                };
              }
              if (v8069.prefab.editOpac) {
                vO233.opacity = {
                  name: "Opacity",
                  object: p10021.objConfig,
                  key: "opacity",
                  type: "slider",
                  args: [0, 1, 0.1],
                  onChange: function (p10330, p10331) {
                    v8069.opacity = p10331;
                  }
                };
              }
              if (v8069.prefab.custom || v8069.prefab.name == "TRIGGER" || v8069.prefab.name == "AI_SPAWNER") {
                vO233.texSmooth = {
                  name: "Texture Smoothing",
                  object: p10021.objConfig,
                  key: "texSmooth",
                  type: "switch",
                  onChange: function (p10332, p10333) {
                    v8069.texSmooth = p10333;
                  }
                };
              }
              if (!v8069.prefab.complex && !v8069.prefab.tool) {
                vO233.shading = {
                  name: "Shading",
                  object: p10021.objConfig,
                  key: "ambient",
                  type: "switch",
                  onChange: function (p10334, p10335) {
                    v8069.ambient = p10335;
                  }
                };
              }
              if (v8069.prefab.editFog) {
                vO233.fog = {
                  name: "Fog",
                  object: p10021.objConfig,
                  key: "fog",
                  type: "switch",
                  onChange: function (p10336, p10337) {
                    v8069.fog = p10337;
                  }
                };
              }
              if (v8069.prefab.name == "CUSTOM_ASSET" || v8069.prefab.name == "TRIGGER") {
                vO233.cast = {
                  name: "Cast Shadows",
                  object: p10021.objConfig,
                  key: "cast",
                  type: "switch",
                  onChange: function (p10338, p10339) {
                    v8069.cast = p10339;
                  }
                };
                vO233.receive = {
                  name: "Receive Shadows",
                  object: p10021.objConfig,
                  key: "receive",
                  type: "switch",
                  onChange: function (p10340, p10341) {
                    v8069.receive = p10341;
                  }
                };
                vO233.forceRender = {
                  name: "Force Render",
                  object: p10021.objConfig,
                  key: "forceRender",
                  type: "switch",
                  onChange: function (p10342, p10343) {
                    v8069.forceRender = p10343;
                  }
                };
              }
              if (v8069.prefab.editAlphaTest) {
                vO233.alphaTest = {
                  name: "AlphaTest",
                  object: p10021.objConfig,
                  key: "alphaTest",
                  type: "slider",
                  args: [0, 1, 0.01],
                  onChange: function (p10344, p10345) {
                    v8069.alphaTest = p10345;
                    v8069.regenM();
                  }
                };
              }
              if (v8069.prefab.editRenderSide) {
                vO233.renderSide = {
                  name: "Render Side",
                  object: p10021.objConfig,
                  key: "renderSide",
                  type: "select",
                  args: [[{
                    name: "Game Default",
                    value: -1
                  }, {
                    name: "Front",
                    value: 0
                  }, {
                    name: "Back",
                    value: 1
                  }, {
                    name: "Double",
                    value: 2
                  }]],
                  onChange: function (p10346, p10347) {
                    v8069.renderSide = p10347;
                  }
                };
              }
              if (v8069.prefab.name == "AI_SPAWNER") {
                vO233.bobD = {
                  name: "Bob Distance",
                  object: p10021.objConfig,
                  key: "bobD",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10348, p10349) {
                    v8069.bobD = p10349;
                  }
                };
                vO233.bobS = {
                  name: "Bob Speed",
                  object: p10021.objConfig,
                  key: "bobS",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10350, p10351) {
                    v8069.bobS = p10351;
                  }
                };
              }
              if (v8069.objType == "LIGHT_CONE") {
                vO233.lightCone = {
                  name: "Full Cone",
                  object: p10021.objConfig,
                  key: "fullcone",
                  type: "switch",
                  onChange: function (p10352, p10353) {
                    v8069.fullcone = p10353;
                    v8069.regen(true);
                  }
                };
              }
              if (v8069.prefab.canSprite) {
                vO233.mimicSprite = {
                  name: "Mimic Sprite",
                  object: p10021.objConfig,
                  key: "mimicSprite",
                  type: "switch",
                  onChange: function (p10354, p10355) {
                    v8069.mimicSprite = p10355;
                  }
                };
              }
              if (Object.keys(vO233).length) {
                this.blueprint.style = {
                  name: "Style",
                  closed: !v8070,
                  type: "folder",
                  size: "standard",
                  children: vO233
                };
              }
            }
            if (!v8069.prefab.notTechnical) {
              let vO234 = {};
              if (v8070) {
                let vA407 = [];
                let v8075 = Object.getOwnPropertyDescriptors(p10022.prototype);
                for (let v8076 in v8075) {
                  if (v8075[v8076].set) {
                    vA407.push(v8076);
                  }
                }
                vO234.key = {
                  name: "Key",
                  object: p10021.advancedOptions,
                  key: "editCustomKey",
                  type: "select",
                  args: [vA407.map(p10356 => ({
                    name: p10356,
                    value: p10356
                  }))],
                  onChange: function () {}
                };
                vO234.execute = {
                  line: "wide",
                  object: p10021.advancedOptions,
                  key: "editCustomExec",
                  type: "button",
                  args: ["Execute"]
                };
              }
              if (v8069.objType == "DEPOSIT_BOX") {
                vO234 = {
                  withdraw: {
                    name: "Withdraw Amount",
                    object: p10021.objConfig,
                    key: "withdraw",
                    type: "slider",
                    args: [0, 100000, 1],
                    onChange: function (p10357, p10358) {
                      v8069.withdraw = p10358;
                    }
                  },
                  deposit: {
                    name: "Deposit Amount",
                    object: p10021.objConfig,
                    key: "deposit",
                    type: "slider",
                    args: [0, 100000, 1],
                    onChange: function (p10359, p10360) {
                      v8069.deposit = p10360;
                    }
                  }
                };
              }
              if (v8069.prefab.customScore) {
                var v8077 = v8069.prefab.mysteryBox || v8069.prefab.perkMachine || v8069.prefab.packapunch;
                var v8078 = v8077 ? 50000 : 10000;
                vO234.customScore = {
                  name: v8077 ? "Cost" : v8069.prefab.interact ? "Amount" : "Score",
                  object: p10021.objConfig,
                  key: "score",
                  type: "slider",
                  args: [v8069.prefab.interact || v8069.prefab.ai ? 0 : 1, v8078, 1],
                  onChange: function (p10361, p10362) {
                    v8069.score = p10362;
                  }
                };
              }
              if (v8069.prefab.perkMachine) {
                vO234.perk = {
                  name: "Perk Type",
                  object: p10021.objConfig,
                  key: "perk",
                  type: "select",
                  args: [config.zombiePerks.map((p10363, p10364) => ({
                    name: p10363,
                    value: p10364
                  }))],
                  onChange: function (p10365, p10366) {
                    v8069.perk = p10366;
                    v8069.regen();
                  }
                };
              }
              if (v8069.objType == "CHECK_POINT" || v8069.objType == "TRIGGER" || v8069.prefab.ai) {
                vO234.singleUse = {
                  name: "Single Use",
                  object: p10021.objConfig,
                  key: "single",
                  type: "switch",
                  onChange: function (p10367, p10368) {
                    v8069.single = p10368;
                  }
                };
              }
              if (v8069.objType == "TRIGGER") {
                vO234.singleUseP = {
                  name: "Once Per Player",
                  object: p10021.objConfig,
                  key: "singleP",
                  type: "switch",
                  onChange: function (p10369, p10370) {
                    v8069.singleP = p10370;
                  }
                };
              }
              if (v8069.prefab.interact) {
                if (v8069.prefab.interact) {
                  vO234.method = {
                    name: "Method",
                    object: p10021.objConfig,
                    key: "method",
                    type: "select",
                    args: [[{
                      name: "Cost Score",
                      value: 0
                    }, {
                      name: "Require Score",
                      value: 1
                    }, {
                      name: "Require Kills",
                      value: 2
                    }, {
                      name: "Requires Account",
                      value: 3
                    }, {
                      name: "Requires Verified",
                      value: 4
                    }, {
                      name: "Requires Premium",
                      value: 5
                    }, {
                      name: "Requires Partner",
                      value: 6
                    }, {
                      name: "Requires Level",
                      value: 7
                    }]],
                    onChange: function (p10371, p10372) {
                      v8069.method = p10372;
                    }
                  };
                  if (v8069.prefab.canUndo) {
                    vO234.closeable = {
                      name: "Closeable",
                      object: p10021.objConfig,
                      key: "closeable",
                      type: "switch",
                      onChange: function (p10373, p10374) {
                        v8069.closeable = p10374;
                      }
                    };
                    vO234.startsClosed = {
                      name: "Starts Hidden",
                      object: p10021.objConfig,
                      key: "startClosed",
                      type: "switch",
                      onChange: function (p10375, p10376) {
                        v8069.startClosed = p10376;
                      }
                    };
                  }
                }
                vO234.hidden = {
                  name: "No Popup",
                  object: p10021.objConfig,
                  key: "hidden",
                  type: "switch",
                  onChange: function (p10377, p10378) {
                    v8069.hidden = p10378;
                  }
                };
              }
              if (v8069.prefab.interactMsg || v8069.objType == "TRIGGER" && p10029.events[v8069.event] && (p10029.events[v8069.event].name == "onInteractKey" || p10029.events[v8069.event].name == "onHoldMouse")) {
                vO234.interactM = {
                  name: "Custom Message",
                  object: p10021.objConfig,
                  key: "interactM",
                  type: "text",
                  args: [""],
                  onChange: function (p10379, p10380) {
                    v8069.interactM = p10380;
                  }
                };
              }
              if (v8069.prefab.hasHealth) {
                vO234.canDest = {
                  name: "Destructible",
                  object: p10021.objConfig,
                  key: "canDest",
                  type: "switch",
                  onChange: function (p10381, p10382) {
                    v8069.canDest = p10382;
                  }
                };
                if (v8069.prefab.name != "GATE") {
                  vO234.startDest = {
                    name: "Start Destroyed",
                    object: p10021.objConfig,
                    key: "startDest",
                    type: "switch",
                    onChange: function (p10383, p10384) {
                      v8069.startDest = p10384;
                    }
                  };
                }
                if (v8069.prefab.name != "GATE") {
                  vO234.spawnChance = {
                    name: "Spawn Chance",
                    object: p10021.objConfig,
                    key: "spawnChance",
                    type: "slider",
                    args: [0, 100, 0.01],
                    onChange: function (p10385, p10386) {
                      v8069.spawnChance = p10386;
                    }
                  };
                }
                if (v8069.prefab.name == "TRIGGER") {
                  vO234.selfDestruct = {
                    name: "Destroy On Use",
                    object: p10021.objConfig,
                    key: "selfDestruct",
                    type: "switch",
                    onChange: function (p10387, p10388) {
                      v8069.selfDestruct = p10388;
                    }
                  };
                }
                vO234.health = {
                  name: "Health",
                  object: p10021.objConfig,
                  key: "health",
                  type: "slider",
                  args: [0, 50000, 10],
                  onChange: function (p10389, p10390) {
                    v8069.health = p10390;
                  }
                };
                vO234.trul = {
                  type: "rule"
                };
              }
              if (v8069.prefab.hasHealth) {
                vO234.respawn = {
                  name: "Respawn",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {
                    timer: {
                      name: "Timer (s)",
                      object: p10021.objConfig,
                      key: "respawnT",
                      type: "slider",
                      args: [0, 3600, 0.1],
                      onChange: function (p10391, p10392) {
                        v8069.respawnT = p10392;
                      },
                      sub: 1
                    },
                    random: {
                      name: "Random",
                      object: p10021.objConfig,
                      key: "respawnR",
                      type: "switch",
                      onChange: function (p10393, p10394) {
                        v8069.respawnR = p10394;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
              }
              if (v8069.prefab.alterHitbox) {
                vO234.hitbox = {
                  name: "Hitbox",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {
                    width: {
                      name: "Width Mlt",
                      object: p10021.objConfig,
                      key: "hbWidth",
                      type: "slider",
                      args: [0.1, 10, 0.1],
                      onChange: function (p10395, p10396) {
                        v8069.hbWidth = p10396;
                      },
                      sub: 1
                    },
                    height: {
                      name: "Height Mlt",
                      object: p10021.objConfig,
                      key: "hbHeight",
                      type: "slider",
                      args: [0.1, 20, 0.1],
                      onChange: function (p10397, p10398) {
                        v8069.hbHeight = p10398;
                      },
                      sub: 1
                    }
                  }
                };
              }
              if (v8069.prefab.ai) {
                vO234.hitbox.children.critDmg = {
                  name: "Crit Damage Mlt",
                  object: p10021.objConfig,
                  key: "critDmg",
                  type: "slider",
                  args: [0, 5, 0.01],
                  onChange: function (p10399, p10400) {
                    v8069.critDmg = p10400;
                  },
                  sub: 1
                };
                vO234.behavior = {
                  name: "Behavior",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {
                    ignoreOnStuck: {
                      name: "Ignore When Stuck",
                      object: p10021.objConfig,
                      key: "ignoreOnStuck",
                      type: "switch",
                      onChange: function (p10401, p10402) {
                        v8069.ignoreOnStuck = p10402;
                      },
                      sub: 1
                    },
                    driftOnStuck: {
                      name: "Drift When Stuck",
                      object: p10021.objConfig,
                      key: "driftOnStuck",
                      type: "switch",
                      onChange: function (p10403, p10404) {
                        v8069.driftOnStuck = p10404;
                      },
                      sub: 1
                    },
                    invincibleOnStuck: {
                      name: "Invincible When Stuck",
                      object: p10021.objConfig,
                      key: "invincibleOnStuck",
                      type: "switch",
                      onChange: function (p10405, p10406) {
                        v8069.invincibleOnStuck = p10406;
                      },
                      sub: 1
                    },
                    friendly: {
                      name: "Friendly",
                      object: p10021.objConfig,
                      key: "friendly",
                      type: "switch",
                      onChange: function (p10407, p10408) {
                        v8069.friendly = p10408;
                      },
                      sub: 1
                    },
                    targPlr: {
                      name: "Target Players",
                      object: p10021.objConfig,
                      key: "targPlr",
                      type: "switch",
                      onChange: function (p10409, p10410) {
                        v8069.targPlr = p10410;
                      },
                      sub: 1
                    },
                    targAI: {
                      name: "Target other AI",
                      object: p10021.objConfig,
                      key: "targAI",
                      type: "switch",
                      onChange: function (p10411, p10412) {
                        v8069.targAI = p10412;
                      },
                      sub: 1
                    },
                    behaviorType: {
                      name: "Behavior Type",
                      object: p10021.objConfig,
                      key: "behaviorType",
                      type: "slider",
                      args: [0, 20, 1],
                      onChange: function (p10413, p10414) {
                        v8069.behaviorType = p10414;
                      },
                      sub: 1
                    },
                    aiChasd: {
                      name: "Chase Distance",
                      object: p10021.objConfig,
                      key: "aiChasd",
                      type: "slider",
                      args: [0, 2000, 1],
                      onChange: function (p10415, p10416) {
                        v8069.aiChasd = p10416;
                      },
                      sub: 1
                    },
                    roamRad: {
                      name: "Roam Radius",
                      object: p10021.objConfig,
                      key: "roamRad",
                      type: "slider",
                      args: [0, 500, 1],
                      onChange: function (p10417, p10418) {
                        v8069.roamRad = p10418;
                      },
                      sub: 1
                    },
                    roamTime: {
                      name: "Roam Time",
                      object: p10021.objConfig,
                      key: "roamTime",
                      type: "slider",
                      args: [1000, 10000, 1],
                      onChange: function (p10419, p10420) {
                        v8069.roamTime = p10420;
                      },
                      sub: 1
                    },
                    pathType: {
                      name: "Path Type",
                      object: p10021.objConfig,
                      key: "pathType",
                      type: "select",
                      args: [config.pathTypes.map((p10421, p10422) => ({
                        name: p10421,
                        value: p10422
                      }))],
                      onChange: function (p10423, p10424) {
                        v8069.pathType = p10424;
                      },
                      sub: 1
                    },
                    pathInput: {
                      name: "Path Input",
                      object: p10021.objConfig,
                      key: "pathInput",
                      type: "text",
                      args: ["id,id,id"],
                      onChange: function (p10425, p10426) {
                        v8069.pathInput = p10426;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.mov = {
                  name: "Movement",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    speed: {
                      name: "Speed",
                      object: p10021.objConfig,
                      key: "speed",
                      type: "slider",
                      args: [0, 10, 0.1],
                      onChange: function (p10427, p10428) {
                        v8069.speed = p10428;
                      },
                      sub: 1
                    },
                    turnSpd: {
                      name: "Turn Speed",
                      object: p10021.objConfig,
                      key: "turnSpd",
                      type: "slider",
                      args: [0, 30, 0.1],
                      onChange: function (p10429, p10430) {
                        v8069.turnSpd = p10430;
                      },
                      sub: 1
                    },
                    gravity: {
                      name: "Gravity",
                      object: p10021.objConfig,
                      key: "gravity",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (p10431, p10432) {
                        v8069.gravity = p10432;
                      },
                      sub: 1
                    },
                    physMov: {
                      name: "Velocity Movement",
                      object: p10021.objConfig,
                      key: "pMov",
                      type: "switch",
                      onChange: function (p10433, p10434) {
                        v8069.pMov = p10434;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.vision = {
                  name: "Vision",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    visDis: {
                      name: "Vision Distance",
                      object: p10021.objConfig,
                      key: "visDis",
                      type: "slider",
                      args: [10, 1000, 10],
                      onChange: function (p10435, p10436) {
                        v8069.visDis = p10436;
                      },
                      sub: 1
                    },
                    xrayVis: {
                      name: "Xray Vision",
                      object: p10021.objConfig,
                      key: "xrayVis",
                      type: "switch",
                      onChange: function (p10437, p10438) {
                        v8069.xrayVis = p10438;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.meleeing = {
                  name: "Melee",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    canHit: {
                      name: "Can Melee",
                      object: p10021.objConfig,
                      key: "canHit",
                      type: "switch",
                      onChange: function (p10439, p10440) {
                        v8069.canHit = p10440;
                      },
                      sub: 1
                    },
                    meldmg: {
                      name: "Melee Dmg",
                      object: p10021.objConfig,
                      key: "meldmg",
                      type: "slider",
                      args: [1, 200, 1],
                      onChange: function (p10441, p10442) {
                        v8069.meldmg = p10442;
                      },
                      sub: 1
                    },
                    hrate: {
                      name: "Melee Rate",
                      object: p10021.objConfig,
                      key: "hrate",
                      type: "slider",
                      args: [200, 10000, 50],
                      onChange: function (p10443, p10444) {
                        v8069.hrate = p10444;
                      },
                      sub: 1
                    },
                    melrng: {
                      name: "Melee Range",
                      object: p10021.objConfig,
                      key: "melrng",
                      type: "slider",
                      args: [10, 100, 1],
                      onChange: function (p10445, p10446) {
                        v8069.melrng = p10446;
                      },
                      sub: 1
                    },
                    melDel: {
                      name: "Melee Delay (ms)",
                      object: p10021.objConfig,
                      key: "melDel",
                      type: "slider",
                      args: [0, 5000, 1],
                      onChange: function (p10447, p10448) {
                        v8069.melDel = p10448;
                      },
                      sub: 1
                    },
                    melShake: {
                      name: "Melee Shake",
                      object: p10021.objConfig,
                      key: "melShake",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (p10449, p10450) {
                        v8069.melShake = p10450;
                      },
                      sub: 1
                    },
                    hitEff: {
                      name: "Effect On Hit",
                      object: p10021.objConfig,
                      key: "hitEff",
                      type: "select",
                      args: [[{
                        name: "None",
                        value: -1
                      }, ...p10027.map((p10451, p10452) => ({
                        name: p10451.name,
                        value: p10452
                      }))]],
                      onChange: function (p10453, p10454) {
                        v8069.hitEff = p10454;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.attacking = {
                  name: "Shooting",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    canShoot: {
                      name: "Can Shoot",
                      object: p10021.objConfig,
                      key: "canShoot",
                      type: "switch",
                      onChange: function (p10455, p10456) {
                        v8069.canShoot = p10456;
                      },
                      sub: 1
                    },
                    frate: {
                      name: "Firerate",
                      object: p10021.objConfig,
                      key: "frate",
                      type: "slider",
                      args: [200, 10000, 50],
                      onChange: function (p10457, p10458) {
                        v8069.frate = p10458;
                      },
                      sub: 1
                    },
                    aicur: {
                      name: "Spread",
                      object: p10021.objConfig,
                      key: "aicur",
                      type: "slider",
                      args: [0, 1, 0.001],
                      onChange: function (p10459, p10460) {
                        v8069.aicur = p10460;
                      },
                      sub: 1
                    },
                    shoBrk: {
                      name: "Shot Break (ms)",
                      object: p10021.objConfig,
                      key: "shoBrk",
                      type: "slider",
                      args: [0, 5000, 1],
                      onChange: function (p10461, p10462) {
                        v8069.shoBrk = p10462;
                      },
                      sub: 1
                    },
                    shoOffH: {
                      name: "Offset Shot",
                      object: p10021.objConfig,
                      key: "shoOffH",
                      type: "switch",
                      onChange: function (p10463, p10464) {
                        v8069.shoOffH = p10464;
                      },
                      sub: 1
                    },
                    shoArY: {
                      name: "Shot Arch Y",
                      object: p10021.objConfig,
                      key: "shoArY",
                      type: "slider",
                      args: [-90, 90, 1],
                      onChange: function (p10465, p10466) {
                        v8069.shoArY = p10466;
                      },
                      sub: 1
                    },
                    shoDel: {
                      name: "Shot Delay (ms)",
                      object: p10021.objConfig,
                      key: "shoDel",
                      type: "slider",
                      args: [0, 5000, 1],
                      onChange: function (p10467, p10468) {
                        v8069.shoDel = p10468;
                      },
                      sub: 1
                    },
                    shoShake: {
                      name: "Shot Shake",
                      object: p10021.objConfig,
                      key: "shoShake",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (p10469, p10470) {
                        v8069.shoShake = p10470;
                      },
                      sub: 1
                    },
                    shotEff: {
                      name: "Effect On Shot",
                      object: p10021.objConfig,
                      key: "shotEff",
                      type: "select",
                      args: [[{
                        name: "None",
                        value: -1
                      }, ...p10027.map((p10471, p10472) => ({
                        name: p10471.name,
                        value: p10472
                      }))]],
                      onChange: function (p10473, p10474) {
                        v8069.shotEff = p10474;
                      },
                      sub: 1
                    },
                    projFol: {
                      name: "Projectile",
                      type: "folder",
                      closed: true,
                      size: "smaller",
                      children: {
                        projA: {
                          name: "Projectile Asset",
                          object: p10021.objConfig,
                          key: "projA",
                          type: "text",
                          args: ["ID"],
                          onChange: function (p10475, p10476) {
                            v8069.projA = p10476;
                          },
                          sub: 1
                        },
                        customProj: {
                          id: "AI",
                          line: "wide",
                          object: p10021.advancedOptions,
                          key: "selectProjModel",
                          type: "button",
                          args: ["Select Custom"]
                        },
                        projDmg: {
                          name: "Projectile Dmg",
                          object: p10021.objConfig,
                          key: "projDmg",
                          type: "slider",
                          args: [0, 1000, 1],
                          onChange: function (p10477, p10478) {
                            v8069.projDmg = p10478;
                          },
                          sub: 1
                        },
                        projSpd: {
                          name: "Projectile Speed",
                          object: p10021.objConfig,
                          key: "projSpd",
                          type: "slider",
                          args: [0, 20, 0.01],
                          onChange: function (p10479, p10480) {
                            v8069.projSpd = p10480;
                          },
                          sub: 1
                        },
                        projSC: {
                          name: "Projectile Size",
                          object: p10021.objConfig,
                          key: "projSC",
                          type: "slider",
                          args: [0.1, 10, 0.1],
                          onChange: function (p10481, p10482) {
                            v8069.projSC = p10482;
                          },
                          sub: 1
                        },
                        projMS: {
                          name: "Projectile Mesh Scale",
                          object: p10021.objConfig,
                          key: "projMS",
                          type: "slider",
                          args: [0.01, 10, 0.01],
                          onChange: function (p10483, p10484) {
                            v8069.projMS = p10484;
                          },
                          sub: 1
                        },
                        projS: {
                          name: "Projectile Spin",
                          object: p10021.objConfig,
                          key: "projS",
                          type: "slider",
                          args: [0, 2, 0.01],
                          onChange: function (p10485, p10486) {
                            v8069.projS = p10486;
                          },
                          sub: 1
                        },
                        projG: {
                          name: "Projectile Gravity",
                          object: p10021.objConfig,
                          key: "projG",
                          type: "slider",
                          args: [-2, 2, 0.01],
                          onChange: function (p10487, p10488) {
                            v8069.projG = p10488;
                          },
                          sub: 1
                        },
                        projGL: {
                          name: "Projectile Glow",
                          object: p10021.objConfig,
                          key: "projGL",
                          type: "switch",
                          onChange: function (p10489, p10490) {
                            v8069.projGL = p10490;
                          },
                          sub: 1
                        },
                        projT: {
                          name: "Projectile Transparency",
                          object: p10021.objConfig,
                          key: "projT",
                          type: "switch",
                          onChange: function (p10491, p10492) {
                            v8069.projT = p10492;
                          },
                          sub: 1
                        },
                        explode: {
                          name: "Explode",
                          object: p10021.objConfig,
                          key: "explode",
                          type: "switch",
                          onChange: function (p10493, p10494) {
                            v8069.explode = p10494;
                          },
                          sub: 1
                        }
                      }
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.reward = {
                  name: "Rewards",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    rewardType: {
                      name: "Skin Rewards",
                      object: p10021.objConfig,
                      key: "rewardType",
                      type: "text",
                      args: ["id,id,id"],
                      onChange: function (p10495, p10496) {
                        v8069.rewardType = p10496;
                      },
                      sub: 1
                    },
                    rewardMethod: {
                      name: "Reward Method",
                      object: p10021.objConfig,
                      key: "rewardMethod",
                      type: "select",
                      args: [[{
                        name: "Auto",
                        value: 0
                      }, {
                        name: "Drop From AI",
                        value: 1
                      }, {
                        name: "Drop on Node",
                        value: 2
                      }]],
                      onChange: function (p10497, p10498) {
                        v8069.rewardMethod = p10498;
                      },
                      sub: 1
                    },
                    rewardReq: {
                      name: "Reward Requirements",
                      object: p10021.objConfig,
                      key: "rewardReq",
                      type: "select",
                      args: [[{
                        name: "Player Active",
                        value: 0
                      }, {
                        name: "Player Active & Damage",
                        value: 1
                      }, {
                        name: "Player Killed",
                        value: 2
                      }]],
                      onChange: function (p10499, p10500) {
                        v8069.rewardReq = p10500;
                      },
                      sub: 1
                    },
                    rewardNode: {
                      name: "Reward Node Id",
                      object: p10021.objConfig,
                      key: "rewardNode",
                      type: "slider",
                      args: [0, 1000, 1],
                      onChange: function (p10501, p10502) {
                        v8069.rewardNode = p10502;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.nameTag = {
                  name: "Nametag",
                  type: "folder",
                  closed: true,
                  size: "small",
                  children: {
                    aiLvl: {
                      name: "Level",
                      object: p10021.objConfig,
                      key: "aiLvl",
                      type: "slider",
                      args: [0, 999, 1],
                      onChange: function (p10503, p10504) {
                        v8069.aiLvl = p10504;
                      },
                      sub: 1
                    },
                    aiTagScale: {
                      name: "Health Scale",
                      object: p10021.objConfig,
                      key: "aiTagScale",
                      type: "slider",
                      args: [0, 10, 0.1],
                      onChange: function (p10505, p10506) {
                        v8069.aiTagScale = p10506;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
              }
              if (v8069.prefab.bot) {
                vO234.botClass = {
                  name: "Class",
                  object: p10021.objConfig,
                  key: "botClass",
                  type: "number",
                  args: ["id", 0],
                  onChange: function (p10507, p10508) {
                    v8069.botClass = p10508;
                  }
                };
                vO234.botForceClass = {
                  name: "Force Class",
                  object: p10021.objConfig,
                  key: "botForceClass",
                  type: "switch",
                  onChange: function (p10509, p10510) {
                    v8069.botForceClass = p10510;
                  }
                };
                vO234.botLives = {
                  name: "Lives",
                  object: p10021.objConfig,
                  key: "botLives",
                  type: "slider",
                  args: [0, 10, 1],
                  onChange: function (p10511, p10512) {
                    v8069.botLives = p10512;
                  }
                };
                var v8079 = Array((v8069.prefab.noDefault ? 1 : 0) + config.teamLimit).fill(0).map((p10513, p10514) => ({
                  name: v8069.prefab.noDefault ? config.teamNames[p10514] : p10514 == 0 ? "Default" : config.teamNames[p10514 - 1],
                  value: p10514
                }));
                vO234.botTeam = {
                  name: "Team",
                  object: p10021.objConfig,
                  key: "botTeam",
                  type: "select",
                  args: [v8079],
                  onChange: function (p10515, p10516) {
                    v8069.botTeam = p10516;
                  }
                };
                vO234.healthMlt = {
                  name: "Health Mlt",
                  object: p10021.objConfig,
                  key: "healthMlt",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10517, p10518) {
                    v8069.healthMlt = p10518;
                  }
                };
                vO234.dmgMlt = {
                  name: "Damage Mlt",
                  object: p10021.objConfig,
                  key: "dmgMlt",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10519, p10520) {
                    v8069.dmgMlt = p10520;
                  }
                };
                vO234.spreadMlt = {
                  name: "Spread Mlt",
                  object: p10021.objConfig,
                  key: "spreadMlt",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10521, p10522) {
                    v8069.spreadMlt = p10522;
                  }
                };
                vO234.rangeMlt = {
                  name: "Range Mlt",
                  object: p10021.objConfig,
                  key: "rangeMlt",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10523, p10524) {
                    v8069.rangeMlt = p10524;
                  }
                };
                vO234.speedMlt = {
                  name: "Speed Mlt",
                  object: p10021.objConfig,
                  key: "speedMlt",
                  type: "slider",
                  args: [0, 10, 0.01],
                  onChange: function (p10525, p10526) {
                    v8069.speedMlt = p10526;
                  }
                };
                vO234.botRecoil = {
                  name: "Recoil",
                  object: p10021.objConfig,
                  key: "botRecoil",
                  type: "switch",
                  onChange: function (p10527, p10528) {
                    v8069.botRecoil = p10528;
                  }
                };
                vO234.botBehavior = {
                  name: "Behavior",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {
                    botRandomSpawn: {
                      name: "Choose Random Spawn",
                      object: p10021.objConfig,
                      key: "botRandomSpawn",
                      type: "switch",
                      onChange: function (p10529, p10530) {
                        v8069.botRandomSpawn = p10530;
                      },
                      sub: 1
                    },
                    botRoam: {
                      name: "Roam When No Target",
                      object: p10021.objConfig,
                      key: "botRoam",
                      type: "switch",
                      onChange: function (p10531, p10532) {
                        v8069.botRoam = p10532;
                      },
                      sub: 1
                    },
                    botGodMode: {
                      name: "God Mode",
                      object: p10021.objConfig,
                      key: "botGodMode",
                      type: "switch",
                      onChange: function (p10533, p10534) {
                        v8069.botGodMode = p10534;
                      },
                      sub: 1
                    },
                    botVoiceChat: {
                      name: "Voicechat on Kill",
                      object: p10021.objConfig,
                      key: "botVoiceChat",
                      type: "switch",
                      onChange: function (p10535, p10536) {
                        v8069.botVoiceChat = p10536;
                      },
                      sub: 1
                    },
                    botJoinMessage: {
                      name: "Message on Join",
                      object: p10021.objConfig,
                      key: "botJoinMessage",
                      type: "switch",
                      onChange: function (p10537, p10538) {
                        v8069.botJoinMessage = p10538;
                      },
                      sub: 1
                    },
                    botLeaveMessage: {
                      name: "Message on Leave",
                      object: p10021.objConfig,
                      key: "botLeaveMessage",
                      type: "switch",
                      onChange: function (p10539, p10540) {
                        v8069.botLeaveMessage = p10540;
                      },
                      sub: 1
                    },
                    botNodYes: {
                      name: "Nod Yes",
                      object: p10021.objConfig,
                      key: "botNodYes",
                      type: "switch",
                      onChange: function (p10541, p10542) {
                        v8069.botNodYes = p10542;
                      },
                      sub: 1
                    },
                    botNodNo: {
                      name: "Nod No",
                      object: p10021.objConfig,
                      key: "botNodNo",
                      type: "switch",
                      onChange: function (p10543, p10544) {
                        v8069.botNodNo = p10544;
                      },
                      sub: 1
                    },
                    botRemoveOnDeath: {
                      name: "Remove On Death",
                      object: p10021.objConfig,
                      key: "botRemoveOnDeath",
                      type: "switch",
                      onChange: function (p10545, p10546) {
                        v8069.botRemoveOnDeath = p10546;
                      },
                      sub: 1
                    },
                    botUseSpawnDelay: {
                      name: "Has Spawn Delay",
                      object: p10021.objConfig,
                      key: "botUseSpawnDelay",
                      type: "switch",
                      onChange: function (p10547, p10548) {
                        v8069.botUseSpawnDelay = p10548;
                      },
                      sub: 1
                    },
                    botCanRespawn: {
                      name: "Can Respawn",
                      object: p10021.objConfig,
                      key: "botCanRespawn",
                      type: "switch",
                      onChange: function (p10549, p10550) {
                        v8069.botCanRespawn = p10550;
                      },
                      sub: 1
                    },
                    botSlideHop: {
                      name: "Can Slide hop",
                      object: p10021.objConfig,
                      key: "botSlideHop",
                      type: "switch",
                      onChange: function (p10551, p10552) {
                        v8069.botSlideHop = p10552;
                      },
                      sub: 1
                    },
                    botMimicTarget: {
                      name: "Mimic Target",
                      object: p10021.objConfig,
                      key: "botMimicTarget",
                      type: "switch",
                      onChange: function (p10553, p10554) {
                        v8069.botMimicTarget = p10554;
                      },
                      sub: 1
                    },
                    botWatchTarget: {
                      name: "Watch Target",
                      object: p10021.objConfig,
                      key: "botWatchTarget",
                      type: "switch",
                      onChange: function (p10555, p10556) {
                        v8069.botWatchTarget = p10556;
                      },
                      sub: 1
                    },
                    botFollowTarget: {
                      name: "Follow Target",
                      object: p10021.objConfig,
                      key: "botFollowTarget",
                      type: "switch",
                      onChange: function (p10557, p10558) {
                        v8069.botFollowTarget = p10558;
                      },
                      sub: 1
                    },
                    botAttackTarget: {
                      name: "Attack Target",
                      object: p10021.objConfig,
                      key: "botAttackTarget",
                      type: "switch",
                      onChange: function (p10559, p10560) {
                        v8069.botAttackTarget = p10560;
                      },
                      sub: 1
                    },
                    botForceCrouch: {
                      name: "Force Crouch",
                      object: p10021.objConfig,
                      key: "botForceCrouch",
                      type: "switch",
                      onChange: function (p10561, p10562) {
                        v8069.botForceCrouch = p10562;
                      },
                      sub: 1
                    },
                    botTargetTeam: {
                      name: "Can Target Team",
                      object: p10021.objConfig,
                      key: "botTargetTeam",
                      type: "switch",
                      onChange: function (p10563, p10564) {
                        v8069.botTargetTeam = p10564;
                      },
                      sub: 1
                    },
                    botTargetBots: {
                      name: "Can Target Bots",
                      object: p10021.objConfig,
                      key: "botTargetBots",
                      type: "switch",
                      onChange: function (p10565, p10566) {
                        v8069.botTargetBots = p10566;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
                vO234.botCosmetics = {
                  name: "Cosmetics",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {
                    botPrimSkin: {
                      name: "Primary Skin",
                      object: p10021.objConfig,
                      key: "botPrimSkin",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10567, p10568) {
                        v8069.botPrimSkin = p10568;
                      },
                      sub: 1
                    },
                    botMelee: {
                      name: "Melee Skin",
                      object: p10021.objConfig,
                      key: "botMelee",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10569, p10570) {
                        v8069.botMelee = p10570;
                      },
                      sub: 1
                    },
                    botHat: {
                      name: "Hat",
                      object: p10021.objConfig,
                      key: "botHat",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10571, p10572) {
                        v8069.botHat = p10572;
                      },
                      sub: 1
                    },
                    botHead: {
                      name: "Head",
                      object: p10021.objConfig,
                      key: "botHead",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10573, p10574) {
                        v8069.botHead = p10574;
                      },
                      sub: 1
                    },
                    botFace: {
                      name: "Face",
                      object: p10021.objConfig,
                      key: "botFace",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10575, p10576) {
                        v8069.botFace = p10576;
                      },
                      sub: 1
                    },
                    botBody: {
                      name: "Body",
                      object: p10021.objConfig,
                      key: "botBody",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10577, p10578) {
                        v8069.botBody = p10578;
                      },
                      sub: 1
                    },
                    botBack: {
                      name: "Back",
                      object: p10021.objConfig,
                      key: "botBack",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10579, p10580) {
                        v8069.botBack = p10580;
                      },
                      sub: 1
                    },
                    botWaist: {
                      name: "Waist",
                      object: p10021.objConfig,
                      key: "botWaist",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10581, p10582) {
                        v8069.botWaist = p10582;
                      },
                      sub: 1
                    },
                    botShoes: {
                      name: "Shoes",
                      object: p10021.objConfig,
                      key: "botShoes",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10583, p10584) {
                        v8069.botShoes = p10584;
                      },
                      sub: 1
                    },
                    botDye: {
                      name: "Dye",
                      object: p10021.objConfig,
                      key: "botDye",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10585, p10586) {
                        v8069.botDye = p10586;
                      },
                      sub: 1
                    },
                    botWrist: {
                      name: "Wrist",
                      object: p10021.objConfig,
                      key: "botWrist",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10587, p10588) {
                        v8069.botWrist = p10588;
                      },
                      sub: 1
                    },
                    botWrist: {
                      name: "Wrist",
                      object: p10021.objConfig,
                      key: "botWrist",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10589, p10590) {
                        v8069.botWrist = p10590;
                      },
                      sub: 1
                    },
                    botPet: {
                      name: "Pet",
                      object: p10021.objConfig,
                      key: "botPet",
                      type: "text",
                      args: ["id"],
                      onChange: function (p10591, p10592) {
                        v8069.botPet = p10592;
                      },
                      sub: 1
                    },
                    rule: {
                      type: "rule"
                    }
                  }
                };
              }
              if (vO234.hitbox) {
                vO234.hitbox.children.rule = {
                  type: "rule"
                };
              }
              if (v8069.objType == "WEAPON_PICKUP") {
                vO234.weapon = {
                  name: "Weapon",
                  type: "folder",
                  size: "small",
                  children: {
                    type: {
                      name: "Type",
                      object: p10021.objConfig,
                      key: "weaponId",
                      type: "select",
                      args: [p10025.map((p10593, p10594) => p10593.src ? {
                        name: p10593.name,
                        value: p10594
                      } : null).filter(p10595 => p10595)],
                      onChange: function (p10596, p10597) {
                        v8069.weaponId = p10597;
                        v8069.regen();
                      },
                      sub: 1
                    },
                    replace: {
                      name: "Replaceable",
                      object: p10021.objConfig,
                      key: "weaponReplace",
                      type: "switch",
                      onChange: function (p10598, p10599) {
                        v8069.weaponReplace = p10599;
                      },
                      sub: 1
                    },
                    random: {
                      name: "Random",
                      object: p10021.objConfig,
                      key: "randWep",
                      type: "switch",
                      onChange: function (p10600, p10601) {
                        v8069.randWep = p10601;
                      },
                      sub: 1
                    },
                    groupId: {
                      name: "Grouping Id",
                      object: p10021.objConfig,
                      key: "randWepGroup",
                      type: "slider",
                      args: [0, 10000, 1],
                      onChange: function (p10602, p10603) {
                        v8069.randWepGroup = p10603;
                      },
                      sub: 1
                    },
                    showPickupIcon: {
                      name: "Show Icon",
                      object: p10021.objConfig,
                      key: "showPickupIcon",
                      type: "switch",
                      onChange: function (p10604, p10605) {
                        v8069.showPickupIcon = p10605;
                      },
                      sub: 1
                    },
                    noTexture: {
                      name: "White Texture",
                      object: p10021.objConfig,
                      key: "noTexture",
                      type: "switch",
                      onChange: function (p10606, p10607) {
                        v8069.noTexture = p10607;
                      },
                      sub: 1
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                };
              }
              if (v8069.objType == "TRIGGER" || v8069.prefab.ai) {
                vO234.events = {
                  name: "Trigger Event",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {}
                };
                if (v8069.prefab.ai) {
                  vO234.events.children.canTrigger = {
                    name: "Can Trigger",
                    object: p10021.objConfig,
                    key: "canTrigger",
                    type: "switch",
                    onChange: function (p10608, p10609) {
                      v8069.canTrigger = p10609;
                    }
                  };
                }
                vO234.events.children.event = {
                  name: "Event",
                  object: p10021.objConfig,
                  key: "event",
                  type: "select",
                  args: [p10029.events.map((p10610, p10611) => ({
                    name: p10610.name,
                    value: p10611
                  })).filter(p10612 => !!v8069.prefab.ai && !!p10612.name.includes("onAI") || v8069.objType == "TRIGGER" && !p10612.name.includes("onAI"))],
                  onChange: function (p10613, p10614) {
                    v8069.event = p10614;
                    vO230.panel.state.refresh("panel_right_object");
                  }
                };
                vO234.events.children.constE = {
                  name: "Event Value",
                  object: p10021.objConfig,
                  key: "constE",
                  type: "slider",
                  args: [0, 10000, 1],
                  onChange: function (p10615, p10616) {
                    v8069.constE = p10616;
                  },
                  rule: {
                    type: "rule"
                  }
                };
                vO234.actions = {
                  name: "Trigger Actions",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: {},
                  rule: {
                    type: "rule"
                  }
                };
                if (p10029.events[v8069.event] && p10029.events[v8069.event].name == "onInteractKey") {
                  vO234.actions.children.actionMethod = {
                    name: "Action Method",
                    object: p10021.objConfig,
                    key: "actionMethod",
                    type: "select",
                    args: [[{
                      name: "Cost KR",
                      value: 0
                    }, {
                      name: "Cost Score",
                      value: 1
                    }, {
                      name: "Require Score",
                      value: 2
                    }, {
                      name: "Require Kills",
                      value: 3
                    }, {
                      name: "Requires Account",
                      value: 4
                    }, {
                      name: "Requires Verified",
                      value: 5
                    }, {
                      name: "Requires Premium",
                      value: 6
                    }, {
                      name: "Requires Partner",
                      value: 7
                    }, {
                      name: "Requires Level",
                      value: 8
                    }]],
                    onChange: function (p10617, p10618) {
                      v8069.actionMethod = p10618;
                    }
                  };
                  vO234.actions.children.actionCost = {
                    name: "Action Cost",
                    object: p10021.objConfig,
                    key: "actionCost",
                    type: "slider",
                    args: [0, 10000, 1],
                    onChange: function (p10619, p10620) {
                      v8069.actionCost = p10620;
                    }
                  };
                }
                vO234.actions.children.chance = {
                  name: "Action Chance (%)",
                  object: p10021.objConfig,
                  key: "chance",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (p10621, p10622) {
                    v8069.chance = p10622;
                  }
                };
                if (v8069.trigActions.length < config.triggerActionLimit) {
                  vO234.actions.children.add = {
                    line: "wide",
                    object: v8069,
                    key: "addAction",
                    type: "button",
                    args: ["Add Action"],
                    sub: 1
                  };
                }
                for (var vLN01313 = 0; vLN01313 < v8069.trigActions.length; vLN01313++) {
                  var vO235 = {
                    name: "Action " + vLN01313,
                    type: "folder",
                    size: "small",
                    closed: true,
                    children: {},
                    sub: 1
                  };
                  var v8080 = p10029.actions[v8069.trigActions[vLN01313].action];
                  if (vLN01313 > 0) {
                    vO235.children.remove = {
                      id: vLN01313,
                      line: "wide",
                      object: v8069,
                      key: "removeAction",
                      type: "button",
                      args: ["Remove Action " + vLN01313],
                      sub: 1
                    };
                  }
                  vO235.children.action = {
                    name: "Action",
                    object: p10021.objConfig.trigActions[vLN01313],
                    id: vLN01313,
                    key: "action",
                    type: "select",
                    args: [p10029.actions.map((p10623, p10624) => ({
                      name: p10623.name,
                      value: p10624
                    })).filter(p10625 => !p10029.actions[p10625.value].devOnly || p10029.actions[p10625.value].devOnly && !config.isProd)],
                    onChange: function (p10626, p10627) {
                      v8069.trigActions[this.id].action = p10627;
                      vO230.panel.state.refresh("panel_right_object");
                    },
                    sub: 1
                  };
                  if (!v8080 || !v8080.hasCust) {
                    v8069.trigActions[vLN01313].constantType = 0;
                  }
                  var v8081 = parseInt(v8069.trigActions[vLN01313].constantType) || 0;
                  if (v8080 && v8080.hasCust) {
                    vO235.children.constantType = {
                      name: "Value Type",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "constantType",
                      id: vLN01313,
                      type: "select",
                      args: [config.inputTypes.map((p10628, p10629) => ({
                        name: p10628,
                        value: p10629
                      }))],
                      onChange: function (p10630, p10631) {
                        v8069.trigActions[this.id].constantType = p10631;
                        vO230.panel.state.refresh("panel_right_object");
                      }
                    };
                  }
                  if (v8080 && v8080.hasCust && v8081) {
                    vO235.children.constantCust = {
                      name: v8080 && v8080.actionValueCust ? v8080.actionValueCust : "Key",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "constantCust",
                      id: vLN01313,
                      type: "text",
                      args: ["Text"],
                      onChange: function (p10632, p10633) {
                        v8069.trigActions[this.id].constantCust = p10633;
                      }
                    };
                  }
                  if (v8080 && (v8080.type == "Both" || v8080.type == "Text") && (v8080.bypassType || !v8081)) {
                    vO235.children.constantTxt = {
                      name: v8080 && v8080.actionValueTxt ? v8080.actionValueTxt : "Value",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "constantTxt",
                      id: vLN01313,
                      type: "text",
                      args: ["Text"],
                      onChange: function (p10634, p10635) {
                        v8069.trigActions[this.id].constantTxt = p10635;
                      }
                    };
                  }
                  if (v8080 && (v8080.type == "Both" || v8080.type != "Text") && !v8081) {
                    vO235.children.constant = {
                      name: v8080 && v8080.actionValue ? v8080.actionValue : "Action Value",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "constant",
                      id: vLN01313,
                      type: "slider",
                      args: [-10000, 10000, 1],
                      onChange: function (p10636, p10637) {
                        v8069.trigActions[this.id].constant = p10637;
                      }
                    };
                    if (v8080.actionOptions) {
                      vO235.children.constant.type = "select";
                      vO235.children.constant.args = [v8080.actionOptions];
                      vO235.children.constant.args = [Object.keys(v8080.actionOptions).map(p10638 => ({
                        name: v8080.actionOptions[p10638],
                        value: parseInt(p10638)
                      }))];
                    }
                  }
                  if (v8080 && v8080.hasExtra && (v8080.bypassType || !v8081)) {
                    vO235.children.constant2 = {
                      name: v8080 && v8080.actionValue2 ? v8080.actionValue2 : "Action Value",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "constant2",
                      id: vLN01313,
                      type: "slider",
                      args: [-10000, 10000, 1],
                      onChange: function (p10639, p10640) {
                        v8069.trigActions[this.id].constant2 = p10640;
                      }
                    };
                    if (v8080.actionOptions2) {
                      vO235.children.constant2.type = "select";
                      vO235.children.constant2.args = [v8080.actionOptions2];
                      vO235.children.constant2.args = [Object.keys(v8080.actionOptions2).map(p10641 => ({
                        name: v8080.actionOptions2[p10641],
                        value: parseInt(p10641)
                      }))];
                    }
                  }
                  if (v8080) {
                    vO235.children.delay = {
                      name: "Delay",
                      object: p10021.objConfig.trigActions[vLN01313],
                      key: "delay",
                      id: vLN01313,
                      type: "slider",
                      args: [0, 60, 0.1],
                      onChange: function (p10642, p10643) {
                        v8069.trigActions[this.id].delay = p10643;
                      }
                    };
                  }
                  if (p10029.events[v8069.event]) {
                    var v8082 = p10029.conditions[v8069.trigActions[vLN01313].condition || 0];
                    vO235.children.conditions = {
                      name: "Condition",
                      type: "folder",
                      closed: true,
                      size: "small",
                      children: {
                        type: {
                          name: "Condition",
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "condition",
                          id: vLN01313,
                          type: "select",
                          args: [p10029.conditions.map((p10644, p10645) => ({
                            name: p10644.name,
                            value: p10645
                          }))],
                          onChange: function (p10646, p10647) {
                            v8069.trigActions[this.id].condition = p10647;
                            vO230.panel.state.refresh("panel_right_object");
                          }
                        }
                      },
                      sub: 1
                    };
                    if (v8082.vals) {
                      var v8083;
                      for (var vLN01314 = 0; vLN01314 < v8082.vals.length; vLN01314++) {
                        v8083 = v8082.vals[vLN01314];
                        vO235.children.conditions.children[v8083.name] = v8083.input ? {
                          name: v8083.name,
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "conditionVal" + vLN01314,
                          id: vLN01313,
                          id2: vLN01314,
                          type: "text",
                          args: [v8083.name],
                          onChange: function (p10648, p10649) {
                            v8069.trigActions[this.id][this.key] = p10649;
                          }
                        } : v8083.select ? {
                          name: v8083.name,
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "conditionVal" + vLN01314,
                          id: vLN01313,
                          type: "select",
                          args: [v8083.select.map((p10650, p10651) => ({
                            name: p10650,
                            value: p10651
                          }))],
                          onChange: function (p10652, p10653) {
                            v8069.trigActions[this.id][this.key] = p10653;
                          }
                        } : {
                          name: v8083.name,
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "conditionVal" + vLN01314,
                          id: vLN01313,
                          type: "slider",
                          args: [v8083.min, v8083.max, v8083.step],
                          onChange: function (p10654, p10655) {
                            v8069.trigActions[this.id][this.key] = p10655;
                          }
                        };
                      }
                    }
                  }
                  if (v8069.trigActions[vLN01313].action == 14 || v8069.trigActions[vLN01313].action == 34 || v8069.trigActions[vLN01313].action == 54) {
                    vO235.children.sound = {
                      name: "Sound",
                      type: "folder",
                      closed: true,
                      size: "small",
                      children: {
                        type: {
                          name: "Type",
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "snd",
                          id: vLN01313,
                          type: "select",
                          args: [Object.keys(p10021.soundsList).map(p10656 => ({
                            name: p10656,
                            value: p10021.soundsList[p10656]
                          }))],
                          onChange: function (p10657, p10658) {
                            v8069.trigActions[this.id].snd = p10658;
                          }
                        },
                        custom: {
                          name: "Asset ID",
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "assetSound",
                          id: vLN01313,
                          type: "number",
                          args: ["Sound Asset ID", 0],
                          onChange: function (p10659, p10660) {
                            v8069.trigActions[this.id].assetSound = p10660;
                          }
                        },
                        customSelect: {
                          line: "wide",
                          object: v8069,
                          key: "selectActionAudio",
                          id: vLN01313,
                          type: "button",
                          args: ["Select Custom"]
                        },
                        volume: {
                          name: "Volume",
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "vol",
                          id: vLN01313,
                          type: "slider",
                          args: [config.emitterVolMin, config.emitterVolMax, 0.01],
                          onChange: function (p10661, p10662) {
                            v8069.trigActions[this.id].vol = p10662;
                          }
                        },
                        rate: {
                          name: "Rate",
                          object: p10021.objConfig.trigActions[vLN01313],
                          key: "rate",
                          id: vLN01313,
                          type: "slider",
                          args: [config.emitterRateMin, config.emitterRateMax, 0.1],
                          onChange: function (p10663, p10664) {
                            v8069.trigActions[this.id].rate = p10664;
                          }
                        }
                      },
                      sub: 1
                    };
                    vO235.children.sound.children.emitfrom = {
                      name: "Emit From",
                      object: p10021.objConfig.trigActions[vLN01313],
                      id: vLN01313,
                      key: "emitfrom",
                      type: "select",
                      args: [[{
                        name: "Trigger (3D)",
                        value: 0
                      }, {
                        name: "Player (3D)",
                        value: 1
                      }, {
                        name: "Global (2D)",
                        value: 2
                      }]],
                      onChange: function (p10665, p10666) {
                        v8069.trigActions[this.id].emitfrom = p10666;
                      }
                    };
                  }
                  vO234.actions.children["action" + vLN01313] = vO235;
                  vO234.actions.children["rul" + vLN01313] = {
                    type: "rule"
                  };
                }
              }
              let vO236 = {};
              if (v8069.objType != "WEAPON_PICKUP" && v8069.prefab.canInterface) {
                vO236.id = {
                  name: "ID",
                  object: p10021.objConfig,
                  key: "interfaceId",
                  type: "slider",
                  args: [0, config.interfaceIDMax, 1],
                  onChange: function (p10667, p10668) {
                    var v8084 = p10668 != v8069.interfaceId;
                    if (v8069.interfaceId) {
                      p10021.warningCheck("interface", v8069, -1);
                    }
                    v8069.interfaceId = p10668;
                    if (v8069.interfaceId) {
                      p10021.warningCheck("interface", v8069, 1);
                    }
                    if (v8084) {
                      p10021.checkConnections();
                    }
                  },
                  sub: 1
                };
              }
              if (v8069.prefab.canTargetInterface) {
                vO236.target = {
                  name: "Target",
                  object: p10021.objConfig,
                  key: "interfaceIdT",
                  type: "slider",
                  args: [0, config.interfaceIDMax, 1],
                  onChange: function (p10669, p10670) {
                    var v8085 = p10670 != v8069.interfaceIdT;
                    v8069.interfaceIdT = p10670;
                    if (v8085) {
                      p10021.checkConnections();
                    }
                  },
                  sub: 1
                };
              }
              if (Object.keys(vO236).length) {
                vO234.interface = {
                  name: "Interface",
                  type: "folder",
                  size: "small",
                  closed: true,
                  children: vO236
                };
              }
              if (v8069.prefab.name == "TELEPORTER") {
                vO234.node = {
                  name: "Node",
                  object: p10021.objConfig,
                  key: "node",
                  type: "select",
                  args: [[{
                    name: "Sending",
                    value: 0
                  }, {
                    name: "Receiving",
                    value: 1
                  }, {
                    name: "Both",
                    value: 2
                  }]],
                  onChange: function (p10671, p10672) {
                    v8069.node = p10672;
                    p10021.checkConnections();
                  }
                };
                vO234.channel = {
                  name: "Channel",
                  object: p10021.objConfig,
                  key: "channel",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (p10673, p10674) {
                    v8069.channel = p10674;
                    p10021.checkConnections();
                  }
                };
                vO234.momentum = {
                  name: "Stop Momentum",
                  object: p10021.objConfig,
                  key: "momentum",
                  type: "switch",
                  onChange: function (p10675, p10676) {
                    v8069.momentum = p10676;
                  }
                };
                vO234.telCheckPoint = {
                  name: "Use Active Checkpoint",
                  object: p10021.objConfig,
                  key: "telCheckPoint",
                  type: "switch",
                  onChange: function (p10677, p10678) {
                    v8069.telCheckPoint = p10678;
                  }
                };
              }
              if (v8069.prefab.canScript) {
                vO234.scriptId = {
                  name: "Script #",
                  object: p10021.objConfig,
                  key: "scriptId",
                  type: "text",
                  onChange: function (p10679, p10680) {
                    v8069.scriptId = p10680;
                  }
                };
              }
              if (Object.keys(vO234).length) {
                this.blueprint.technical = {
                  name: "Technical & Logic",
                  closed: !v8070,
                  type: "folder",
                  size: "standard",
                  children: vO234
                };
              }
            }
            if (v8069.prefab.editFaces) {
              this.blueprint.renderFaces = {
                name: "Render Faces",
                type: "folder",
                size: "standard",
                children: {
                  ...p10021.faces.map((p10681, p10682) => ({
                    name: p10681,
                    object: p10021.objConfig.faces,
                    key: p10682,
                    type: "switch",
                    onChange: function () {
                      v8069.faces = p10021.objConfig.faces;
                      v8069.regen();
                    }
                  }))
                },
                closed: true
              };
            }
            if (v8069.prefab.name == "ENVIRONMENT_ZONE") {
              this.blueprint.environments = {
                name: "Environment",
                type: "folder",
                size: "standard",
                children: {
                  skyDome: {
                    name: "Sky",
                    object: p10021.objConfig,
                    key: "skyDome",
                    type: "select",
                    args: [["Solid", "Gradient"].map((p10683, p10684) => ({
                      name: p10683,
                      value: p10684
                    }))],
                    onChange: function (p10685, p10686) {
                      [...p10685.children].forEach(p10687 => {
                        document.getElementById("ensky_" + p10687.value).style.display = "none";
                      });
                      document.getElementById("ensky_" + p10686).style.display = null;
                      v8069.skyDome = !!parseInt(p10686);
                    }
                  },
                  sky0: {
                    id: "ensky_0",
                    type: "div",
                    size: "standard",
                    show: !v8069.skyDome,
                    children: {
                      sky: {
                        name: "Color",
                        object: vO232,
                        key: "sky",
                        type: "color",
                        onChange: function (p10688, p10689) {
                          v8069.sky = p10689;
                        },
                        sub: 1
                      }
                    }
                  },
                  sky1: {
                    id: "ensky_1",
                    type: "div",
                    size: "standard",
                    show: !!v8069.skyDome,
                    children: {
                      color: {
                        name: "Color",
                        type: "folder",
                        size: "small",
                        children: {
                          skyDomeCol0: {
                            name: "Top",
                            object: vO232,
                            key: "skyDomeCol0",
                            type: "color",
                            onChange: function (p10690, p10691) {
                              v8069.skyDomeCol0 = p10691;
                            },
                            sub: 2
                          },
                          skyDomeCol1: {
                            name: "Middle",
                            object: vO232,
                            key: "skyDomeCol1",
                            type: "color",
                            onChange: function (p10692, p10693) {
                              v8069.skyDomeCol1 = p10693;
                            },
                            sub: 2
                          },
                          skyDomeCol2: {
                            name: "Bottom",
                            object: vO232,
                            key: "skyDomeCol2",
                            type: "color",
                            onChange: function (p10694, p10695) {
                              v8069.skyDomeCol2 = p10695;
                            },
                            sub: 2
                          }
                        },
                        sub: 1
                      },
                      skyDomeTex: {
                        name: "Cloud Texture",
                        object: p10021.objConfig,
                        key: "skyDomeTex",
                        type: "switch",
                        onChange: function (p10696, p10697) {
                          v8069.skyDomeTex = p10697;
                          encloud.style.display = p10697 ? null : "none";
                        },
                        sub: 1
                      }
                    }
                  },
                  cloud: {
                    id: "encloud",
                    type: "div",
                    size: "standard",
                    show: !!v8069.skyDomeTex,
                    children: {
                      skyDomeEmis: {
                        name: "Emissive",
                        object: vO232,
                        key: "skyDomeEmis",
                        type: "color",
                        onChange: function (p10698, p10699) {
                          v8069.skyDomeEmis = p10699;
                        },
                        sub: 2
                      },
                      skyDomeEmisTex: {
                        name: "Emissive Asset ID",
                        object: p10021.objConfig,
                        key: "skyDomeEmisTex",
                        type: "text",
                        args: ["Emissive Asset ID"],
                        onChange: function (p10700, p10701) {
                          v8069.skyDomeEmisTex = p10701;
                        },
                        sub: 2
                      },
                      selectEmissiveCloud: {
                        line: "wide",
                        object: p10021.advancedOptions,
                        key: "selectEmissiveCloudEN",
                        type: "button",
                        args: ["Select Emissive"],
                        sub: 2
                      },
                      skyDomeMovT: {
                        name: "Speed",
                        object: p10021.objConfig,
                        key: "skyDomeMovT",
                        type: "slider",
                        args: [-20, 20, 0.1],
                        onChange: function (p10702, p10703) {
                          v8069.skyDomeMovT = p10703;
                        },
                        sub: 2
                      },
                      skyDomeMovD: {
                        name: "Axis",
                        object: p10021.objConfig,
                        key: "skyDomeMovD",
                        type: "select",
                        args: [["X", "Y"].map((p10704, p10705) => ({
                          name: p10704,
                          value: p10705
                        }))],
                        onChange: function (p10706, p10707) {
                          v8069.skyDomeMovD = p10707;
                        },
                        sub: 2
                      },
                      skyDomeTexA: {
                        name: "Asset ID",
                        object: p10021.objConfig,
                        key: "skyDomeTexA",
                        type: "text",
                        args: ["Texture Asset ID"],
                        onChange: function (p10708, p10709) {
                          v8069.skyDomeTexA = p10709;
                        },
                        sub: 2
                      },
                      selectCloud: {
                        line: "wide",
                        object: p10021.advancedOptions,
                        key: "selectCloudEN",
                        type: "button",
                        args: ["Select Custom"],
                        sub: 2
                      }
                    },
                    sub: 2
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
              this.blueprint.environments.children.ambient = {
                name: "Ambient",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  ambInd: {
                    name: "Sound",
                    object: p10021.objConfig,
                    key: "ambInd",
                    type: "select",
                    args: [Object.keys(config.soundScapes).map(p10710 => ({
                      name: p10710,
                      value: config.soundScapes[p10710]
                    }))],
                    onChange: function (p10711, p10712) {
                      v8069.ambInd = p10712;
                    }
                  },
                  ambIndC: {
                    name: "Custom Sound ID",
                    object: p10021.objConfig,
                    key: "ambIndC",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10713, p10714) {
                      v8069.ambIndC = p10714;
                    }
                  },
                  selectAmbEN: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectAmbEN",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  ambientI: {
                    name: "Intensity",
                    object: p10021.objConfig,
                    key: "ambientI",
                    type: "slider",
                    args: [0.1, 3, 0.1],
                    onChange: function (p10715, p10716) {
                      v8069.ambientI = p10716;
                    }
                  },
                  ambientC: {
                    name: "Color",
                    object: vO232,
                    key: "ambientC",
                    type: "color",
                    onChange: function (p10717, p10718) {
                      v8069.ambientC = p10718;
                    }
                  }
                }
              };
              this.blueprint.environments.children.light = {
                name: "Light",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  lightC: {
                    name: "Color",
                    object: vO232,
                    key: "lightC",
                    type: "color",
                    onChange: function (p10719, p10720) {
                      v8069.lightC = p10720;
                    }
                  },
                  lightD: {
                    name: "Distance",
                    object: p10021.objConfig,
                    key: "lightD",
                    type: "slider",
                    args: [10, 5000, 1],
                    onChange: function (p10721, p10722) {
                      v8069.lightD = p10722;
                    }
                  },
                  lightI: {
                    name: "Intensity",
                    object: p10021.objConfig,
                    key: "lightI",
                    type: "slider",
                    args: [0.1, 3, 0.1],
                    onChange: function (p10723, p10724) {
                      v8069.lightI = p10724;
                    }
                  },
                  angle: {
                    name: "Angle",
                    type: "folder",
                    size: "small",
                    children: {
                      sunAngX: {
                        name: "X",
                        object: p10021.objConfig,
                        key: "sunAngX",
                        type: "slider",
                        args: [0, 360, 1],
                        onChange: function (p10725, p10726) {
                          v8069.sunAngX = p10726;
                        }
                      },
                      sunAngY: {
                        name: "Y",
                        object: p10021.objConfig,
                        key: "sunAngY",
                        type: "slider",
                        args: [0, 360, 1],
                        onChange: function (p10727, p10728) {
                          v8069.sunAngY = p10728;
                        }
                      }
                    },
                    sub: 1
                  }
                }
              };
              this.blueprint.environments.children.shadows = {
                name: "Shadows",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  shadowR: {
                    name: "Resolution",
                    object: p10021.objConfig,
                    key: "shadowR",
                    type: "slider",
                    args: [128, 4096, 1],
                    onChange: function (p10729, p10730) {
                      v8069.shadowR = p10730;
                    }
                  },
                  shadowD: {
                    name: "Distance",
                    object: p10021.objConfig,
                    key: "shadowD",
                    type: "slider",
                    args: [128, 4096, 1],
                    onChange: function (p10731, p10732) {
                      v8069.shadowD = p10732;
                    }
                  }
                }
              };
              this.blueprint.environments.children.weather = {
                name: "Weather",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  fog: {
                    name: "Fog",
                    type: "folder",
                    size: "small",
                    children: {
                      fogC: {
                        name: "Color",
                        object: vO232,
                        key: "fogC",
                        type: "color",
                        onChange: function (p10733, p10734) {
                          v8069.fogC = p10734;
                        }
                      },
                      fogD: {
                        name: "Distance",
                        object: p10021.objConfig,
                        key: "fogD",
                        type: "slider",
                        args: [0, 15000, 1],
                        onChange: function (p10735, p10736) {
                          v8069.fogD = p10736;
                        }
                      }
                    },
                    sub: 1
                  }
                }
              };
              this.blueprint.environments.children.render = {
                name: "Render",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  toneMapping: {
                    name: "ToneMapping",
                    object: p10021.objConfig,
                    key: "toneMapping",
                    type: "select",
                    args: [config.toneTypes.map((p10737, p10738) => ({
                      name: p10737,
                      value: p10738
                    }))],
                    onChange: function (p10739, p10740) {
                      v8069.toneMapping = p10740;
                    }
                  },
                  toneMappingExposure: {
                    name: "ToneMapping Exposure",
                    object: p10021.objConfig,
                    key: "toneMappingExposure",
                    type: "slider",
                    args: [0, 10, 0.1],
                    onChange: function (p10741, p10742) {
                      v8069.toneMappingExposure = p10742;
                    }
                  },
                  outputEncoding: {
                    name: "Output Encoding",
                    object: p10021.objConfig,
                    key: "outputEncoding",
                    type: "select",
                    args: [config.encodingTypes.map((p10743, p10744) => ({
                      name: p10743.name,
                      value: p10744
                    }))],
                    onChange: function (p10745, p10746) {
                      v8069.outputEncoding = p10746;
                    }
                  },
                  correctLights: {
                    name: "Physically Correct Lights",
                    object: p10021.objConfig,
                    key: "correctLights",
                    type: "switch",
                    onChange: function (p10747, p10748) {
                      v8069.correctLights = p10748;
                    }
                  }
                }
              };
            }
            if (v8069.prefab.light || v8069.prefab.name == "DIRECTIONAL_LIGHT" || v8069.prefab.name == "RECTAREA_LIGHT" || v8069.prefab.name == "SPOT_LIGHT") {
              this.blueprint.lighting = {
                name: "Lighting",
                type: "folder",
                size: "standard",
                children: {
                  intensity: {
                    name: "Intensity",
                    object: p10021.objConfig,
                    key: "intensity",
                    type: "slider",
                    args: [0, 15, 0.1],
                    onChange: function (p10749, p10750) {
                      v8069.intensity = p10750;
                    }
                  }
                }
              };
              if (v8069.prefab.light || v8069.prefab.name == "SPOT_LIGHT") {
                this.blueprint.lighting.children.distance = {
                  name: "Distance",
                  object: p10021.objConfig,
                  key: "distance",
                  type: "slider",
                  args: [0, 1000, 0.1],
                  onChange: function (p10751, p10752) {
                    v8069.distance = p10752;
                  }
                };
                this.blueprint.lighting.children.decay = {
                  name: "Decay",
                  object: p10021.objConfig,
                  key: "decay",
                  type: "slider",
                  args: [0, 2, 0.1],
                  onChange: function (p10753, p10754) {
                    v8069.decay = p10754;
                  }
                };
              }
              if (v8069.prefab.name == "DIRECTIONAL_LIGHT" || v8069.prefab.name == "SPOT_LIGHT") {
                this.blueprint.lighting.children.target = {
                  name: "Target",
                  object: p10021.objConfig,
                  key: "lightTarget",
                  type: "vector3",
                  onChange: function (p10755, p10756) {
                    v8069.lightTarget = p10756;
                  }
                };
              }
              if (v8069.prefab.name == "SPOT_LIGHT") {
                this.blueprint.lighting.children.angle = {
                  name: "Angle",
                  object: p10021.objConfig,
                  key: "angle",
                  type: "slider",
                  args: [1, 90, 1],
                  onChange: function (p10757, p10758) {
                    v8069.angle = p10758;
                  }
                };
                this.blueprint.lighting.children.penumbra = {
                  name: "Penumbra",
                  object: p10021.objConfig,
                  key: "penumbra",
                  type: "slider",
                  args: [0, 1, 0.1],
                  onChange: function (p10759, p10760) {
                    v8069.penumbra = p10760;
                  }
                };
              }
              this.blueprint.lighting.children.rule = {
                type: "rule"
              };
            }
            if (v8069.objType == "BILLBOARD") {
              this.blueprint.billboard = {
                name: "Billboard",
                type: "folder",
                size: "standard",
                children: {
                  poster: {
                    name: "Poster",
                    object: p10021.objConfig,
                    key: "poster",
                    type: "select",
                    args: [config.billboards.map((p10761, p10762) => ({
                      name: p10761,
                      value: p10762
                    }))],
                    onChange: function (p10763, p10764) {
                      v8069.poster = p10764;
                      v8069.regen(true);
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
            }
            if (v8069.objType == "PARTICLES") {
              this.blueprint.particles = {
                name: "Particles",
                type: "folder",
                size: "standard",
                children: {
                  texture: {
                    name: "Texture",
                    object: p10021.objConfig,
                    key: "part",
                    type: "select",
                    args: [Object.keys(p10021.particleList).map(p10765 => ({
                      name: p10765,
                      value: p10021.particleList[p10765]
                    }))],
                    onChange: function (p10766, p10767) {
                      v8069.part = p10767;
                    }
                  },
                  blending: {
                    name: "Blending",
                    object: p10021.objConfig,
                    key: "partB",
                    type: "select",
                    args: [Object.keys(p10021.blendingList).map(p10768 => ({
                      name: p10768,
                      value: p10021.blendingList[p10768]
                    }))],
                    onChange: function (p10769, p10770) {
                      v8069.partB = p10770;
                    }
                  },
                  count: {
                    name: "Count",
                    object: p10021.objConfig,
                    key: "partC",
                    type: "slider",
                    args: [0, 300, 1],
                    onChange: function (p10771, p10772) {
                      v8069.partC = p10772;
                    }
                  },
                  size: {
                    name: "Size",
                    object: p10021.objConfig,
                    key: "partS",
                    type: "slider",
                    args: [0, 30, 0.1],
                    onChange: function (p10773, p10774) {
                      v8069.partS = p10774;
                    }
                  },
                  scale: {
                    name: "Scale",
                    object: p10021.objConfig,
                    key: "partSC",
                    type: "slider",
                    args: [-10, 10, 0.1],
                    onChange: function (p10775, p10776) {
                      v8069.partSC = p10776;
                    }
                  },
                  movement: {
                    name: "Movement",
                    type: "folder",
                    size: "small",
                    children: {
                      speed: {
                        name: "Speed",
                        object: p10021.objConfig,
                        key: "partSP",
                        type: "slider",
                        args: [-10, 10, 0.1],
                        onChange: function (p10777, p10778) {
                          v8069.partSP = p10778;
                        },
                        sub: 1
                      },
                      deceleration: {
                        name: "Deceleration",
                        object: p10021.objConfig,
                        key: "partD",
                        type: "slider",
                        args: [-1, 1, 0.1],
                        onChange: function (p10779, p10780) {
                          v8069.partD = p10780;
                        },
                        sub: 1
                      },
                      gravity: {
                        name: "Gravity",
                        object: p10021.objConfig,
                        key: "partG",
                        type: "slider",
                        args: [-10, 10, 0.1],
                        onChange: function (p10781, p10782) {
                          v8069.partG = p10782;
                        },
                        sub: 1
                      },
                      rule: {
                        type: "rule"
                      }
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
            }
            if (v8069.prefab.hasText) {
              this.blueprint.text = {
                name: "Text",
                type: "folder",
                size: "standard",
                children: {
                  content: {
                    name: "Content",
                    object: p10021.objConfig,
                    key: "text",
                    type: "text",
                    args: ["Content"],
                    onChange: function (p10783, p10784) {
                      v8069.text = p10784;
                      v8069.regen(true);
                    }
                  },
                  align: {
                    name: "Align",
                    object: p10021.objConfig,
                    key: "tAlign",
                    type: "select",
                    args: [[{
                      name: "Left",
                      value: 0
                    }, {
                      name: "Center",
                      value: 1
                    }, {
                      name: "Right",
                      value: 2
                    }]],
                    onChange: function (p10785, p10786) {
                      v8069.tAlign = p10786;
                      v8069.regen(true);
                    }
                  },
                  font: {
                    name: "Font",
                    type: "folder",
                    size: "small",
                    children: {
                      size: {
                        name: "Size",
                        object: p10021.objConfig,
                        key: "fsize",
                        type: "slider",
                        args: [config.signFontMin, config.signFontMax, 1],
                        onChange: function (p10787, p10788) {
                          v8069.fsize = p10788;
                          v8069.regen(true);
                        },
                        sub: 1
                      },
                      noScaleFont: {
                        name: "Dont Scale Font",
                        object: p10021.objConfig,
                        key: "noSCF",
                        type: "switch",
                        onChange: function (p10789, p10790) {
                          v8069.noSCF = p10790;
                          v8069.regen(true);
                        },
                        sub: 1
                      },
                      color: {
                        name: "Color",
                        object: vO232,
                        key: "fcolor",
                        type: "color",
                        onChange: function (p10791, p10792) {
                          v8069.fcolor = p10792;
                          v8069.regen(true);
                        },
                        sub: 1
                      },
                      outline: {
                        name: "Outline Color",
                        object: vO232,
                        key: "ocolor",
                        type: "color",
                        onChange: function (p10793, p10794) {
                          v8069.ocolor = p10794;
                          v8069.regen(true);
                        },
                        sub: 1
                      },
                      outlineT: {
                        name: "Outline Thickness",
                        object: p10021.objConfig,
                        key: "othick",
                        type: "slider",
                        args: [1, 50, 1],
                        onChange: function (p10795, p10796) {
                          v8069.othick = p10796;
                          v8069.regen(true);
                        },
                        sub: 1
                      }
                    },
                    rule: {
                      type: "rule"
                    }
                  },
                  background: {
                    name: "Background",
                    type: "folder",
                    size: "small",
                    children: {
                      color: {
                        name: "Color",
                        object: vO232,
                        key: "bcolor",
                        type: "color",
                        onChange: function (p10797, p10798) {
                          v8069.bcolor = p10798;
                          v8069.regen(true);
                        },
                        sub: 1
                      },
                      visible: {
                        name: "Visible",
                        object: p10021.objConfig,
                        key: "backVisible",
                        type: "switch",
                        onChange: function (p10799, p10800) {
                          v8069.backVisible = p10800;
                          v8069.regen(true);
                        },
                        sub: 1
                      }
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
              if (v8069.prefab.name == "LEADERBOARD") {
                delete this.blueprint.text.children.content;
                delete this.blueprint.text.children.align;
              }
            }
            if (v8069.objType == "SPAWN_POINT") {
              this.blueprint.spawnpoint = {
                name: "Spawn Point",
                type: "folder",
                size: "standard",
                children: {
                  cmpSpwn: {
                    name: "Starting Area",
                    object: p10021.objConfig,
                    key: "cmpSpwn",
                    type: "switch",
                    onChange: function (p10801, p10802) {
                      v8069.cmpSpwn = p10802;
                      v8069.regen();
                    }
                  },
                  teamOnly: {
                    name: "Team Only",
                    object: p10021.objConfig,
                    key: "teamOnly",
                    type: "switch",
                    onChange: function (p10803, p10804) {
                      v8069.teamOnly = p10804;
                      v8069.regen();
                    }
                  },
                  spread: {
                    name: "Spawn Spread",
                    object: p10021.objConfig,
                    key: "spread",
                    type: "slider",
                    args: [0, 50, 0.1],
                    onChange: function (p10805, p10806) {
                      v8069.spread = p10806;
                      v8069.regen();
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
            }
            if (v8069.objType == "LIQUID") {
              this.blueprint.liquid = {
                name: "Wave",
                type: "folder",
                size: "standard",
                children: {
                  wave: {
                    name: "Liquid",
                    type: "folder",
                    size: "small",
                    children: {
                      speed: {
                        name: "Speed",
                        object: p10021.objConfig,
                        key: "wSpeed",
                        type: "slider",
                        args: [0, 25, 0.1],
                        onChange: function (p10807, p10808) {
                          v8069.wSpeed = p10808;
                        },
                        sub: 1
                      },
                      height: {
                        name: "Height",
                        object: p10021.objConfig,
                        key: "wHeight",
                        type: "slider",
                        args: [0, 5, 0.1],
                        onChange: function (p10809, p10810) {
                          v8069.wHeight = p10810;
                        },
                        sub: 1
                      },
                      rule: {
                        type: "rule"
                      }
                    }
                  },
                  depth: {
                    name: "Depth",
                    type: "folder",
                    size: "small",
                    children: {
                      x: {
                        name: "X",
                        object: p10021.objConfig,
                        key: "tilesX",
                        type: "slider",
                        args: [2, 100, 1],
                        onChange: function (p10811, p10812) {
                          v8069.tilesX = p10812;
                          v8069.regen();
                        },
                        sub: 1
                      },
                      z: {
                        name: "Z",
                        object: p10021.objConfig,
                        key: "tilesZ",
                        type: "slider",
                        args: [2, 100, 1],
                        onChange: function (p10813, p10814) {
                          v8069.tilesZ = p10814;
                          v8069.regen();
                        },
                        sub: 1
                      }
                    },
                    rule: {
                      type: "rule"
                    }
                  },
                  rule: {
                    type: "rule"
                  }
                }
              };
            }
            if (v8069.objType == "SOUND_EMITTER" || v8069.prefab.hasSound) {
              this.blueprint.sound = {
                name: "Sound",
                type: "folder",
                closed: true,
                size: "standard",
                children: {
                  type: {
                    name: "Type",
                    object: p10021.objConfig,
                    key: "snd",
                    type: "select",
                    args: [Object.keys(p10021.soundsList).map(p10815 => ({
                      name: p10815,
                      value: p10021.soundsList[p10815]
                    }))],
                    onChange: function (p10816, p10817) {
                      v8069.snd = p10817;
                    }
                  },
                  custom: {
                    name: "Asset ID",
                    object: p10021.objConfig,
                    key: "assetSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10818, p10819) {
                      v8069.assetSound = p10819;
                    }
                  },
                  customSelect: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectAudio",
                    type: "button",
                    args: ["Select Custom"]
                  },
                  volume: {
                    name: "Volume",
                    object: p10021.objConfig,
                    key: "vol",
                    type: "slider",
                    args: [config.emitterVolMin, config.emitterVolMax, 0.01],
                    onChange: function (p10820, p10821) {
                      v8069.vol = p10821;
                    }
                  },
                  rate: {
                    name: "Rate",
                    object: p10021.objConfig,
                    key: "rate",
                    type: "slider",
                    args: [config.emitterRateMin, config.emitterRateMax, 0.01],
                    onChange: function (p10822, p10823) {
                      v8069.rate = p10823;
                    }
                  }
                }
              };
              if (v8069.objType == "SOUND_EMITTER") {
                this.blueprint.sound.children.dist = {
                  name: "Reference Distance",
                  object: p10021.objConfig,
                  key: "dist",
                  type: "slider",
                  args: [config.emitterDistMin, config.emitterDistMax, 1],
                  onChange: function (p10824, p10825) {
                    v8069.dist = p10825;
                  }
                };
                this.blueprint.sound.children.distM = {
                  name: "Distance Model",
                  object: p10021.objConfig,
                  key: "distM",
                  type: "select",
                  args: [[{
                    name: "Inverse",
                    value: 0
                  }, {
                    name: "Linear",
                    value: 1
                  }, {
                    name: "Exponential",
                    value: 2
                  }]],
                  onChange: function (p10826, p10827) {
                    v8069.distM = p10827;
                  }
                };
                this.blueprint.sound.children.roll = {
                  name: "Roll-off",
                  object: p10021.objConfig,
                  key: "roll",
                  type: "slider",
                  args: [config.emitterRollMin, config.emitterRollMax, 0.01],
                  onChange: function (p10828, p10829) {
                    v8069.roll = p10829;
                  }
                };
              } else {
                this.blueprint.sound.children.emitfrom = {
                  name: "Emit From",
                  object: p10021.objConfig,
                  key: "emitfrom",
                  type: "select",
                  args: [[{
                    name: "Trigger (3D)",
                    value: 0
                  }, {
                    name: "Player (3D)",
                    value: 1
                  }, {
                    name: "Global (2D)",
                    value: 2
                  }]],
                  onChange: function (p10830, p10831) {
                    v8069.emitfrom = p10831;
                  }
                };
              }
            }
            if (v8069.prefab.ai) {
              this.blueprint.sound = {
                name: "Sound",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  death: {
                    name: "Death Sound ID",
                    object: p10021.objConfig,
                    key: "deathSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10832, p10833) {
                      v8069.deathSound = p10833;
                    }
                  },
                  customDeath: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectDeath",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  idle: {
                    name: "Idle Sound ID",
                    object: p10021.objConfig,
                    key: "idleSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10834, p10835) {
                      v8069.idleSound = p10835;
                    }
                  },
                  customIdle: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectIdle",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  shoot: {
                    name: "Shoot Sound ID",
                    object: p10021.objConfig,
                    key: "shootSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10836, p10837) {
                      v8069.shootSound = p10837;
                    }
                  },
                  customShoot: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectShoot",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  shootHit: {
                    name: "Shoot-Hit Sound ID",
                    object: p10021.objConfig,
                    key: "shootHitSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10838, p10839) {
                      v8069.shootHitSound = p10839;
                    }
                  },
                  customShootHit: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectShootHit",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  mel: {
                    name: "Melee Sound ID",
                    object: p10021.objConfig,
                    key: "melSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10840, p10841) {
                      v8069.melSound = p10841;
                    }
                  },
                  customMel: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectMelee",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  melHit: {
                    name: "Melee-Hit Sound ID",
                    object: p10021.objConfig,
                    key: "melHitSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10842, p10843) {
                      v8069.melHitSound = p10843;
                    }
                  },
                  customMelHit: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectMeleeHit",
                    type: "button",
                    args: ["Select Sound"]
                  },
                  agro: {
                    name: "Agro Sound ID",
                    object: p10021.objConfig,
                    key: "agroSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (p10844, p10845) {
                      v8069.agroSound = p10845;
                    }
                  },
                  customAgro: {
                    line: "wide",
                    object: p10021.advancedOptions,
                    key: "selectAgro",
                    type: "button",
                    args: ["Select Sound"]
                  }
                }
              };
            }
            if (v8069.prefab.name == "CUSTOM_ASSET" || v8069.prefab.ai || v8069.prefab.name == "TRIGGER") {
              this.blueprint.animations = {
                name: "Animations",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  animS: {
                    name: "Animation Speed",
                    object: p10021.objConfig,
                    key: "animS",
                    type: "slider",
                    args: [0.01, 10, 0.01],
                    onChange: function (p10846, p10847) {
                      v8069.animS = p10847;
                    }
                  },
                  startAnim: {
                    name: "Start Animation",
                    object: p10021.objConfig,
                    key: "startAnim",
                    type: "text",
                    args: [""],
                    onChange: function (p10848, p10849) {
                      v8069.startAnim = p10849;
                    }
                  }
                }
              };
            }
            vO230.panel.state.setActive(this.objKeys);
            vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        environment: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (vO230.panel.right.locked && !vO230.panel.state.isActive(this.objKeys)) {
              return;
            }
            let vA408 = ["ambient", "sky", "light", "fog"];
            let vO237 = {};
            let v8086 = p10021.mapConfig;
            for (let v8087 of vA408) {
              Object.defineProperty(vO237, v8087, {
                get() {
                  return UTILS.stringifyColor(v8086[v8087]);
                },
                set(p10850) {
                  return v8086[v8087] = UTILS.parseColor(p10850);
                }
              });
            }
            var v8088 = new f1330({
              type: "folder",
              size: "standard"
            });
            v8088.addPanelButton("Environment", "right");
            v8088.add("select", "Sky", p10021.mapConfig, "skyDome", ["Solid", "Gradient"].map((p10851, p10852) => ({
              name: p10851,
              value: p10852
            })), function (p10853, p10854) {
              [...p10853.children].forEach(p10855 => {
                document.getElementById("sky_" + p10855.value).style.display = "none";
              });
              document.getElementById("sky_" + p10854).style.display = null;
              cloud.style.display = !!parseInt(p10854) && p10021.mapConfig.skyDomeTex ? null : "none";
              p10021.mapConfig.skyDome = !!parseInt(p10854);
              p10021.regenSky();
            });
            var v8089 = v8088.addDiv("sky_0", null, null, !p10021.mapConfig.skyDome);
            v8089.add("color", "Color", vO237, "sky", null, function (p10856, p10857) {
              p10021.backgroundScene.background = new p10023.Color(p10857);
              p10021.regenSky();
            }, null, 1);
            var v8090 = v8088.addDiv("sky_1", null, null, !!p10021.mapConfig.skyDome);
            var v8091 = v8090.addFolder("Color", null, null, "folder", "small", null, 1);
            v8091.add("color", "Top", p10021.mapConfig, "skyDomeCol0", null, function () {
              p10021.regenSky();
            }, null, 2);
            v8091.add("color", "Middle", p10021.mapConfig, "skyDomeCol1", null, function () {
              p10021.regenSky();
            }, null, 2);
            v8091.add("color", "Bottom", p10021.mapConfig, "skyDomeCol2", null, function () {
              p10021.regenSky();
            }, null, 2);
            v8090.add("switch", "Cloud Texture", p10021.mapConfig, "skyDomeTex", null, function (p10858, p10859) {
              cloud.style.display = p10859 ? null : "none";
              p10021.regenSky();
            }, null, 1);
            var v8092 = v8088.addDiv("cloud", null, null, p10021.mapConfig.skyDomeTex);
            v8092.add("color", "Emissive", p10021.mapConfig, "skyDomeEmis", null, function () {
              p10021.regenSky();
            }, null, 2);
            v8092.add("text", "Emissive Asset ID", p10021.mapConfig, "skyDomeEmisTex", "Emissive Asset ID", function () {
              p10021.regenSky();
            }, null, 2);
            v8092.add("button", null, p10021.advancedOptions, "selectEmissiveCloud", "Select Emissive", null, true);
            v8092.add("slider", "Speed", p10021.mapConfig, "skyDomeMovT", [-20, 20, 0.1], function () {
              p10021.regenSky();
            }, null, 2);
            v8092.add("select", "Axis", p10021.mapConfig, "skyDomeMovD", ["X", "Y"].map((p10860, p10861) => ({
              name: p10860,
              value: p10861
            })), function () {
              p10021.regenSky();
            }, null, 2);
            v8092.add("text", "Asset ID", p10021.mapConfig, "skyDomeTexA", "Texture Asset ID", function () {
              p10021.regenSky();
            }, null, 2);
            v8092.add("button", null, p10021.advancedOptions, "selectCloud", "Select Custom", null, true);
            v8088.addRule();
            var v8093 = v8088.addFolder("Ambient", null, null, null, null, true);
            v8093.add("select", "Sound", p10021.mapConfig, "ambInd", Object.keys(config.soundScapes).map(p10862 => ({
              name: p10862,
              value: config.soundScapes[p10862]
            })));
            v8093.add("number", "Custom Sound ID", p10021.mapConfig, "ambIndC", ["Sound Asset ID", 0], function (p10863, p10864) {
              p10021.mapConfig.ambIndC = p10864;
            });
            v8093.add("button", null, p10021.advancedOptions, "selectAmb", "Select Sound", null, true);
            v8093.add("slider", "Intensity", p10021.mapConfig, "ambientI", [0.1, 3, 0.1], function (p10865, p10866) {
              p10021.ambientLight.intensity = p10866;
            });
            v8093.add("color", "Color", vO237, "ambient", null, function (p10867, p10868) {
              p10021.ambientLight.color.set(p10868);
            });
            var v8094 = v8088.addFolder("Light", null, null, null, null, true);
            v8094.add("color", "Color", vO237, "light", null, function (p10869, p10870) {
              p10021.skyLight.color.set(p10870);
              p10021.updateSun();
            });
            v8094.add("slider", "Distance", p10021.mapConfig, "lightD", [10, 5000, 1], function () {
              p10021.updateSun();
            });
            v8094.add("slider", "Intensity", p10021.mapConfig, "lightI", [0.1, 3, 0.1], function (p10871, p10872) {
              p10021.ambientLight.intensity = p10872;
            });
            var v8095 = v8094.addFolder("Angle", null, null, null, "small", true);
            v8095.add("slider", "X", p10021.mapConfig, "sunAngX", [0, 360, 1], function () {
              p10021.updateSun();
            }, null, 1);
            v8095.add("slider", "Y", p10021.mapConfig, "sunAngY", [0, 360, 1], function () {
              p10021.updateSun();
            }, null, 1);
            var v8096 = v8088.addFolder("Shadows", null, null, null, null, true);
            v8096.add("slider", "Resolution", p10021.mapConfig, "shadowR", [128, 4096, 1]);
            v8096.add("slider", "Distance", p10021.mapConfig, "shadowD", [128, 4096, 1]);
            var v8097 = v8088.addFolder("Weather", null, null, null, null, true);
            var v8098 = v8097.addFolder("Fog", null, null, null, "small");
            v8098.add("color", "Color", vO237, "fog", null, function (p10873, p10874) {
              p10021.scene.fog.color.set(p10874);
            }, null, 2);
            v8098.add("slider", "Distance", p10021.mapConfig, "fogD", [10, 15000, 1], function (p10875, p10876) {
              p10021.scene.fog.far = p10876;
            }, null, 2);
            var v8099 = v8088.addFolder("Render", null, null, null, null, true);
            v8099.add("select", "ToneMapping", p10021.mapConfig, "toneMapping", config.toneTypes.map((p10877, p10878) => ({
              name: p10877,
              value: p10878
            })), function () {}, null, 2);
            v8099.add("slider", "ToneMapping Exposure", p10021.mapConfig, "toneMappingExposure", [0, 10, 0.1]);
            v8099.add("select", "Output Encoding", p10021.mapConfig, "outputEncoding", config.encodingTypes.map((p10879, p10880) => ({
              name: p10879.name,
              value: p10880
            })), function () {}, null, 2);
            v8099.add("switch", "Physically Correct Lights", p10021.mapConfig, "correctLights", null);
            this.blueprint = v8088.toJSON();
            vO230.panel.state.setActive(this.objKeys);
            vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        terrain: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              var v8100 = new f1330({
                type: "folder",
                size: "standard"
              });
              v8100.addPanelButton("Terrain", "right");
              v8100.add("text", "Seed", p10021.mapConfig, "terrainSeed", "Seed", () => p10021.regenTerrain());
              v8100.add("button", null, p10021.mapConfig, "terrainSeed", "Generate Random", function () {
                p10021.mapConfig.terrainSeed = Math.random().toString(36).substring(4);
                vO230.panel.state.refresh("panel_right_terrain");
                p10021.regenTerrain();
              }, true, 1);
              v8100.add("text", "Tree Seed", p10021.mapConfig, "terrainTSeed", "Seed", () => p10021.regenTerrain());
              v8100.add("button", null, p10021.mapConfig, "terrainTSeed", "Generate Random", function () {
                p10021.mapConfig.terrainTSeed = Math.random().toString(36).substring(4);
                vO230.panel.state.refresh("panel_right_terrain");
                p10021.regenTerrain();
              }, true, 1);
              v8100.add("select", "Easing", p10021.mapConfig, "terrainEase", p10021.EASE_LIST.map((p10881, p10882) => ({
                name: p10881,
                value: p10882
              })), function () {
                vO230.panel.state.refresh("panel_right_terrain");
                p10021.regenTerrain();
              }, null, 1);
              v8100.addRule();
              var v8101 = v8100.addFolder("Dimensions", null, null, null, null, true);
              v8101.add("slider", "Width", p10021.mapConfig, "terrainWidth", [config.minTerrainSize, config.maxTerrainSize, 1], () => p10021.regenTerrain());
              v8101.add("slider", "Length", p10021.mapConfig, "terrainHeight", [config.minTerrainSize, config.maxTerrainSize, 1], () => p10021.regenTerrain());
              v8101.add("slider", "Height", p10021.mapConfig, "terrainMntMlt", [config.minMountainMlt, config.maxMountainMlt, 0.05], () => p10021.regenTerrain());
              var v8102 = v8100.addFolder("Style", null, null, null, null, true);
              var v8103 = v8102.addFolder("Color", null, null, null, "small");
              v8103.add("color", "Snow", p10021.mapConfig, "terrainSnwCol", null, () => p10021.regenTerrain(), null, 1);
              v8103.add("color", "Mountain", p10021.mapConfig, "terrainMntCol", null, () => p10021.regenTerrain(), null, 1);
              v8103.add("color", "Grass", p10021.mapConfig, "terrainGrsCol", null, () => p10021.regenTerrain(), null, 1);
              v8103.add("color", "Dirt", p10021.mapConfig, "terrainDrtCol", null, () => p10021.regenTerrain(), null, 1);
              v8103.add("color", "Sand", p10021.mapConfig, "terrainSndCol", null, () => p10021.regenTerrain(), null, 1);
              this.blueprint = v8100.toJSON();
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        zone: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              var v8104 = new f1330({
                type: "folder",
                size: "standard"
              });
              v8104.addPanelButton("Zone", "right");
              v8104.add("switch", "Enabled", p10021.mapConfig, "zone", null, () => p10021.regenZone());
              v8104.add("slider", "Speed", p10021.mapConfig, "zoneSpeed", [config.minShrinkSpeed, config.maxShrinkSpeed, 0.1]);
              v8104.add("slider", "Stages", p10021.mapConfig, "zoneStages", [config.minZoneStages, config.maxZoneStages, 1]);
              v8104.add("slider", "Wait Timer (s)", p10021.mapConfig, "zoneWait", [config.minZoneWait, config.maxZoneWait, 1]);
              v8104.add("switch", "Random Endpoint", p10021.mapConfig, "zoneRnd", null, () => p10021.regenZone());
              v8104.addRule();
              var v8105 = v8104.addFolder("Dimensions");
              v8105.add("slider", "Size", p10021.mapConfig, "zoneSize", [config.minZoneSize, config.maxZoneSize, 10], () => p10021.regenZone());
              v8105.add("slider", "Height", p10021.mapConfig, "zoneHeight", [config.minZoneHeight, config.maxZoneHeight, 10], () => p10021.regenZone());
              var v8106 = v8104.addFolder("Style");
              var v8107 = v8106.addFolder("Color", null, null, null, "small");
              v8107.add("color", "Top", p10021.mapConfig, "zoneCol0", null, () => p10021.regenZone(), null, 1);
              v8107.add("color", "Middle", p10021.mapConfig, "zoneCol1", null, () => p10021.regenZone(), null, 1);
              v8107.add("color", "Bottom", p10021.mapConfig, "zoneCol2", null, () => p10021.regenZone(), null, 1);
              this.blueprint = v8104.toJSON();
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        ocean: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              var v8108 = new f1330({
                type: "folder",
                size: "standard"
              });
              v8108.addPanelButton("Ocean", "right");
              v8108.add("switch", "Enabled", p10021.mapConfig, "ocean", null, () => p10021.regenOcean());
              v8108.add("color", "Water Color", p10021.mapConfig, "ocCol", null, () => p10021.regenOcean());
              v8108.add("slider", "Opacity", p10021.mapConfig, "ocOpac", [0, 1, 0.1], () => p10021.regenOcean());
              v8108.add("slider", "Distortion", p10021.mapConfig, "ocDist", [0, 10, 0.01], () => p10021.regenOcean());
              v8108.add("slider", "Wave Speed", p10021.mapConfig, "ocSpd", [0.1, 5, 0.1], () => p10021.regenOcean());
              v8108.add("slider", "Y Offset", p10021.mapConfig, "ocYOff", [-1000, 1000, 0.01], () => p10021.regenOcean());
              v8108.add("select", "Reflection Resolution", p10021.mapConfig, "ocRefRes", [{
                name: "32",
                value: 1
              }, {
                name: "64",
                value: 2
              }, {
                name: "128",
                value: 3
              }, {
                name: "256",
                value: 4
              }, {
                name: "1024",
                value: 5
              }, {
                name: "2048",
                value: 6
              }], () => p10021.regenOcean());
              v8108.add("slider", "Width", p10021.mapConfig, "ocW", [100, 20000, 1], () => p10021.regenOcean());
              v8108.add("slider", "Length", p10021.mapConfig, "ocL", [100, 20000, 1], () => p10021.regenOcean());
              this.blueprint = v8108.toJSON();
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        tools: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (vO230.panel.right.locked && !vO230.panel.state.isActive(this.objKeys)) {
              return;
            }
            let vO238 = {};
            let vA409 = ["Space", "Dir"];
            for (let v8109 of vA409) {
              Object.defineProperty(vO238, v8109, {
                get() {
                  return p10021.xyzKeys.map(p10883 => p10021.advancedOptions["planner" + p10883 + v8109]);
                },
                set(p10884) {
                  return p10021.xyzKeys.forEach((p10885, p10886) => {
                    p10021.advancedOptions["planner" + p10885 + v8109] = p10884[p10886];
                  });
                }
              });
            }
            var v8110 = new f1330({
              type: "folder",
              size: "standard"
            });
            v8110.addPanelButton("Tools", "right");
            v8110.addRule();
            var v8111 = v8110.addFolder("Optimizations", null, null, "folder", "standard");
            v8111.add("button", "Optimize Faces", p10021.advancedOptions, "optimizeFaces", "Execute");
            v8111.addRule();
            var v8112 = v8111.addFolder("Color Merging");
            v8112.add("slider", "Color Range", p10021.advancedOptions, "colorRange", [500, 50000, 100]);
            v8112.add("button", null, p10021.advancedOptions, "mergeColors", "Merge Colors", null, true);
            var v8113 = v8110.addFolder("Text Generator", null, null, "folder", "standard", true);
            v8113.add("button", "Enter Text", p10021.advancedOptions, "textGen", "Open");
            var v8114 = v8110.addFolder("Image Converter", null, null, "folder", "standard", true);
            v8114.add("number", "Size", p10021.settings, "imageSize", null, function (p10887, p10888) {
              p10021.setSettings("imageSize", p10888);
            });
            v8114.add("number", "Depth", p10021.settings, "imageDepth", null, function (p10889, p10890) {
              p10021.setSettings("imageDepth", p10890);
            });
            v8114.add("switch", "Collidable", p10021.settings, "imageCol", null, function (p10891, p10892) {
              p10021.setSettings("imageCol", p10892);
            });
            v8114.add("button", "Convert", p10021.advancedOptions, "imageConvert", "Convert");
            v8114.add("button", "Import", p10021.advancedOptions, "imageImport", "Import");
            var v8115 = v8110.addFolder("Voxel Manager", null, null, "folder", "standard", true);
            v8115.add("switch", "Merge", p10021.settings, "mergeVoxels", null, function (p10893, p10894) {
              p10021.setSettings("mergeVoxels", p10894);
            });
            v8115.add("number", "Size", p10021.settings, "voxelSize", null, function (p10895, p10896) {
              p10021.setSettings("voxelSize", p10896);
            });
            v8115.add("button", "Convert", p10021.advancedOptions, "voxelConvert", "Convert");
            v8115.add("button", "Import", p10021.advancedOptions, "voxelImport", "Import");
            var v8116 = v8110.addFolder("Layout Planner", null, null, "folder", "standard", true);
            v8116.add("switch", "Merge", p10021.settings, "mergeVoxels", null, function (p10897, p10898) {
              p10021.setSettings("mergeVoxels", p10898);
            });
            v8116.add("number", "Size", p10021.advancedOptions, "plannerSize");
            v8116.add("color", "Color", p10021.advancedOptions, "plannerColor");
            v8116.add("vector3", "Cubes in XYZ", vO238, "Dir");
            v8116.add("vector3", "Space in XYZ", vO238, "Space");
            v8116.add("button", null, p10021.advancedOptions, "plannerExecute", "Execute", null, true);
            let vO239 = {};
            let vA410 = ["scaleMap"];
            for (let v8117 of vA410) {
              Object.defineProperty(vO239, v8117, {
                get() {
                  return p10021.xyzKeys.map(p10899 => p10021.advancedOptions[v8117 + p10899]);
                },
                set(p10900) {
                  return p10021.xyzKeys.forEach((p10901, p10902) => {
                    p10021.advancedOptions[v8117 + p10901] = p10900[p10902];
                  });
                }
              });
            }
            var v8118 = v8110.addFolder("Timelapse", null, null, "folder", "standard", true);
            v8118.add("slider", "Timer", p10021.advancedOptions, "timelapseMS", [100, 5000, 1]);
            v8118.add("switch", "Follow Objects", p10021.advancedOptions, "timelapseFollow");
            v8118.add("button", null, p10021.advancedOptions, "timelapseMap", "Execute", null, true);
            var v8119 = v8110.addFolder("Transform", null, null, "folder", "standard", true);
            v8119.add("vector3", "Scale", vO239, "scaleMap");
            v8119.add("button", null, p10021.advancedOptions, "scaleMap", "Scale", null, true);
            v8119.add("select", "Reflection", p10021.advancedOptions, "reflectDir", [{
              name: "X",
              value: 0
            }, {
              name: "Y",
              value: 1
            }, {
              name: "Z",
              value: 2
            }]);
            v8119.add("button", null, p10021.advancedOptions, "reflectMap", "Reflect", null, true);
            var v8120 = v8110.addFolder("Frame", null, null, "folder", "standard", true);
            v8120.add("number", "Wall Thickness", p10021.advancedOptions, "frameThickness", "Thickness");
            v8120.add("switch", "Has Ceiling", p10021.advancedOptions, "frameThickness");
            v8120.add("switch", "Has Floor", p10021.advancedOptions, "frameFloor");
            v8120.add("button", null, p10021.advancedOptions, "frameObject", "Frame It", null, true);
            var v8121 = v8110.addFolder("Breakable", null, null, "folder", "standard", true);
            v8121.add("slider", "Health", p10021.advancedOptions, "breakableHealth", [1, 500, 1]);
            v8121.add("switch", "Force Collision", p10021.advancedOptions, "breakableCollision");
            v8121.add("button", null, p10021.advancedOptions, "breakableMap", "Execute", null, true);
            var v8122 = v8110.addFolder("Colorize", null, null, "folder", "standard", true);
            v8122.add("button", "Random", p10021.advancedOptions, "colorizeR", "Execute");
            v8122.add("button", "Gold", p10021.advancedOptions, "colorizeG", "Execute");
            v8122.add("button", "Input", p10021.advancedOptions, "colorizeI", "Execute");
            v8110.add("button", "Drunk Map", p10021.advancedOptions, "drunkMap", "Execute");
            this.blueprint = v8110.toJSON();
            vO230.panel.state.setActive(this.objKeys);
            vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        prefab: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              var v8123 = new f1330({
                type: "folder",
                size: "standard"
              });
              v8123.addPanelButton("Prefabs", "right");
              v8123.addRule();
              v8123.add("switch", "Auto Group", p10021.settings, "assetAutoGroup", null, function (p10903, p10904) {
                p10021.setSettings("assetAutoGroup", p10904);
              });
              v8123.add("slider", "Rotation", p10021.advancedOptions, "rotation", [0, 359, 1]);
              var v8124 = v8123.addFolder("Import", null, null, null, "small");
              v8124.add("button", "Json", p10021.advancedOptions, "json", "Import", null, null, 1);
              v8124.add("button", "File", p10021.advancedOptions, "file", "Import", null, null, 1);
              v8123.add("switch", "Object Painter", p10021.advancedOptions, "objectPainter", null, function (p10905, p10906) {
                objPaint.style.display = p10906 ? null : "none";
              });
              var v8125 = v8123.addDiv("objPaint", null, null, p10021.advancedOptions.objectPainterType);
              v8125.add("text", "JSON", p10021.advancedOptions, "objectPainterJson", "JSON", null, null, 1);
              v8125.add("select", "Type", p10021.advancedOptions, "objectPainterType", [{
                name: "JSON",
                value: 0
              }, {
                name: "Junk",
                value: 1
              }, {
                name: "Cloth",
                value: 2
              }, {
                name: "Wood",
                value: 3
              }, {
                name: "Wires",
                value: 4
              }, {
                name: "Tin can",
                value: 5
              }, {
                name: "Chocolate",
                value: 6
              }, {
                name: "Carrot",
                value: 7
              }, {
                name: "Frog",
                value: 8
              }], null, null, 1);
              this.blueprint = v8123.toJSON();
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        objectList: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  label: "Objects"
                }
              };
              let vA411 = [];
              for (let v8126 in p10021.objInsts) {
                vA411[v8126] = {};
                this.blueprint["Object" + v8126] = {
                  key: v8126,
                  object: vA411,
                  name: UTILS.formatConstName(p10021.objInsts[v8126].name),
                  type: "button",
                  args: ["Focus"],
                  onChange: function () {
                    p10021.focusObject(v8126);
                  }
                };
              }
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        },
        gui: {
          show: function () {
            p10021.resizable.restore(vO230.panel.right.restore);
            if (!vO230.panel.right.locked || vO230.panel.state.isActive(this.objKeys)) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  label: "Custom GUIs"
                }
              };
              this.blueprint.rule = {
                type: "rule"
              };
              this.blueprint.toggle = {
                name: "Show GUI",
                object: p10030,
                key: "enabled",
                type: "switch",
                onChange: function (p10907, p10908) {
                  p10030.enabled = p10908;
                  vO230.panel.state.refresh("panel_right_gui");
                }
              };
              this.blueprint.add = {
                line: "wide",
                object: p10021,
                key: "addGUIElement",
                type: "button",
                args: ["Add Element"]
              };
              var v8127;
              for (var vLN01315 = 0; vLN01315 < p10030.customGUIs.length; vLN01315++) {
                v8127 = {
                  name: "Element " + vLN01315 + (p10030.customGUIs[vLN01315].lbl ? " - " + p10030.customGUIs[vLN01315].lbl.toString().replace(/[^\w\s]+/gmi, "") : ""),
                  type: "folder",
                  size: "standard",
                  children: {}
                };
                v8127.children.remove = {
                  id: vLN01315,
                  line: "wide",
                  object: p10021,
                  key: "removeGUIElement",
                  type: "button",
                  args: ["Remove Element " + vLN01315],
                  sub: 1
                };
                v8127.children.duplicate = {
                  id: vLN01315,
                  line: "wide",
                  object: p10021,
                  key: "duplicateGUIElement",
                  type: "button",
                  args: ["Duplicate Element " + vLN01315],
                  sub: 1
                };
                v8127.children.elementLabel = {
                  name: "Element Label",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "lbl",
                  type: "text",
                  args: [""],
                  onChange: function (p10909, p10910) {
                    p10030.customGUIs[this.id].lbl = p10910.toString().replace(/[^\w\s]+/gmi, "");
                  },
                  onChange: function () {
                    delayTimer("ElementLabel" + this.id, function () {
                      vO230.panel.state.refresh("panel_right_gui");
                    }, 1000);
                  },
                  sub: 1
                };
                v8127.children.type = {
                  name: "Type",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "t",
                  type: "select",
                  args: [config.custGUITypes.map((p10911, p10912) => ({
                    name: p10911,
                    value: p10912
                  }))],
                  onChange: function (p10913, p10914) {
                    p10030.customGUIs[this.id].t = p10914;
                    vO230.panel.state.refresh("panel_right_gui");
                  },
                  sub: 1
                };
                if (p10030.customGUIs[vLN01315].t == 1 || p10030.customGUIs[vLN01315].t == 3) {
                  var v8128 = p10030.customGUIs[vLN01315].vt || 0;
                  v8127.children.valueType = {
                    name: "Value Type",
                    object: p10030.customGUIs[vLN01315],
                    id: vLN01315,
                    key: "vt",
                    type: "select",
                    args: [config.inputTypesGUI.map((p10915, p10916) => ({
                      name: p10915,
                      value: p10916
                    }))],
                    onChange: function (p10917, p10918) {
                      p10030.customGUIs[this.id].vt = p10918;
                      vO230.panel.state.refresh("panel_right_gui");
                    }
                  };
                  v8127.children.text = {
                    name: v8128 ? "Key" : "Text",
                    object: p10030.customGUIs[vLN01315],
                    id: vLN01315,
                    key: "v",
                    type: "text",
                    args: [v8128 ? "Key" : "Text"],
                    onChange: function (p10919, p10920) {
                      p10030.customGUIs[this.id].v = p10920;
                    },
                    sub: 1
                  };
                }
                if (p10030.customGUIs[vLN01315].t == 1 || p10030.customGUIs[vLN01315].t == 3) {
                  v8127.children.fontsize = {
                    name: "Font Size",
                    object: p10030.customGUIs[vLN01315],
                    id: vLN01315,
                    key: "f",
                    type: "slider",
                    args: [0, 100, 1],
                    onChange: function (p10921, p10922) {
                      p10030.customGUIs[this.id].f = p10922;
                    },
                    sub: 1
                  };
                }
                if (p10030.customGUIs[vLN01315].t == 2) {
                  v8127.children.img = {
                    name: "Image Asset ID",
                    object: p10030.customGUIs[vLN01315],
                    id: vLN01315,
                    key: "s",
                    type: "text",
                    args: ["ID"],
                    onChange: function (p10923, p10924) {
                      p10030.customGUIs[this.id].s = p10924;
                    },
                    sub: 1
                  };
                  v8127.children.imgBtn = {
                    id: vLN01315,
                    line: "wide",
                    object: p10021,
                    key: "selectImage",
                    type: "button",
                    args: ["Select Image"],
                    sub: 1
                  };
                }
                if (p10030.customGUIs[vLN01315].t != 2) {
                  v8127.children.color = {
                    name: "Color",
                    object: p10030.customGUIs[vLN01315],
                    id: vLN01315,
                    key: "c",
                    type: "color",
                    onChange: function (p10925, p10926) {
                      p10030.customGUIs[this.id].c = p10926;
                    },
                    sub: 1
                  };
                }
                v8127.children.opacity = {
                  name: "Opacity",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "o",
                  type: "slider",
                  args: [0, 1, 0.1],
                  onChange: function (p10927, p10928) {
                    p10030.customGUIs[this.id].o = p10928;
                  },
                  sub: 1
                };
                v8127.children.x = {
                  name: "X",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "x",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (p10929, p10930) {
                    p10030.customGUIs[this.id].x = p10930;
                  },
                  sub: 1
                };
                v8127.children.y = {
                  name: "Y",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "y",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (p10931, p10932) {
                    p10030.customGUIs[this.id].y = p10932;
                  },
                  sub: 1
                };
                v8127.children.width = {
                  name: "Width",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "w",
                  type: "slider",
                  args: [0, 2000, 1],
                  onChange: function (p10933, p10934) {
                    p10030.customGUIs[this.id].w = p10934;
                  },
                  sub: 1
                };
                v8127.children.height = {
                  name: "Height",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "h",
                  type: "slider",
                  args: [0, 2000, 1],
                  onChange: function (p10935, p10936) {
                    p10030.customGUIs[this.id].h = p10936;
                  },
                  sub: 1
                };
                v8127.children.zIndex = {
                  name: "Order Index",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "z",
                  type: "slider",
                  args: [0, 2000, 1],
                  onChange: function (p10937, p10938) {
                    p10030.customGUIs[this.id].z = p10938;
                  },
                  sub: 1
                };
                v8127.children.hide = {
                  name: "Hide",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "nv",
                  type: "switch",
                  onChange: function (p10939, p10940) {
                    p10030.customGUIs[this.id].nv = ~~!!p10940;
                  },
                  sub: 1
                };
                v8127.children.elementId = {
                  name: "Element Id",
                  object: p10030.customGUIs[vLN01315],
                  id: vLN01315,
                  key: "id",
                  type: "slider",
                  args: [0, 2000, 1],
                  onChange: function (p10941, p10942) {
                    p10030.customGUIs[this.id].id = p10942;
                  },
                  sub: 1
                };
                this.blueprint["element" + vLN01315] = v8127;
              }
              vO230.panel.state.setActive(this.objKeys);
              vO230.panel.right.elem.innerHTML = vO230._build([...this.objKeys, "blueprint"]);
            }
          }
        }
      }
    },
    _window: {
      controls: {
        default: {
          gen: function () {
            this.blueprint = {
              rule: {
                type: "rule"
              }
            };
            this.blueprint.movement = {
              name: "Movement",
              type: "folder",
              size: "standard",
              children: {
                fowardKey: {
                  name: "Fly forward",
                  object: p10021.settings,
                  key: "fowardKey",
                  type: "key",
                  args: [[vO230._html.arrow("up")], true],
                  onChange: function (p10943, p10944) {
                    p10944 = p10944.toUpperCase();
                    p10021.setSettings(this.key, p10944);
                  }
                },
                backwardKey: {
                  name: "Fly backwards",
                  object: p10021.settings,
                  key: "backwardKey",
                  type: "key",
                  args: [[vO230._html.arrow("down")], true],
                  onChange: function (p10945, p10946) {
                    p10946 = p10946.toUpperCase();
                    p10021.setSettings(this.key, p10946);
                  }
                },
                leftKey: {
                  name: "Fly left",
                  object: p10021.settings,
                  key: "leftKey",
                  type: "key",
                  args: [[vO230._html.arrow("left")], true],
                  onChange: function (p10947, p10948) {
                    p10948 = p10948.toUpperCase();
                    p10021.setSettings(this.key, p10948);
                  }
                },
                rightKey: {
                  name: "Fly right",
                  object: p10021.settings,
                  key: "rightKey",
                  type: "key",
                  args: [[vO230._html.arrow("right")], true],
                  onChange: function (p10949, p10950) {
                    p10950 = p10950.toUpperCase();
                    p10021.setSettings(this.key, p10950);
                  }
                },
                upKey: {
                  name: "Fly up",
                  object: p10021.settings,
                  key: "upKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10951, p10952) {
                    p10952 = p10952.toUpperCase();
                    p10021.setSettings(this.key, p10952);
                  }
                },
                downKey: {
                  name: "Fly down",
                  object: p10021.settings,
                  key: "downKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10953, p10954) {
                    p10954 = p10954.toUpperCase();
                    p10021.setSettings(this.key, p10954);
                  }
                },
                shiftKey: {
                  name: "Hold to fly faster",
                  object: {
                    val: "Shift"
                  },
                  key: "val",
                  type: "key"
                },
                speed: {
                  name: "Speed",
                  type: "folder",
                  size: "small",
                  children: {
                    speedNormal: {
                      name: "Normal",
                      object: p10021.settings,
                      key: "speedNormal",
                      type: "number",
                      onChange: function (p10955, p10956) {
                        p10021.setSettings("speedNormal", Math.abs(p10956) || p10021.defaultSettings.speedNormal);
                      },
                      sub: 1
                    },
                    speedSprint: {
                      name: "Sprinting",
                      object: p10021.settings,
                      key: "speedSprint",
                      type: "number",
                      onChange: function (p10957, p10958) {
                        p10021.setSettings("speedSprint", Math.abs(p10958) || p10021.defaultSettings.speedSprint);
                      },
                      sub: 1
                    },
                    speedReset: {
                      name: "Reset Speed",
                      object: p10021.advancedOptions,
                      key: "speedReset",
                      type: "button",
                      args: ["Reset"],
                      sub: 1
                    }
                  }
                }
              }
            };
            this.blueprint.transform = {
              name: "Transform",
              type: "folder",
              size: "standard",
              children: {
                translateKey: {
                  name: "Translate",
                  object: p10021.settings,
                  key: "translateKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10959, p10960) {
                    p10960 = p10960.toUpperCase();
                    p10021.setSettings(this.key, p10960);
                  }
                },
                rotateKey: {
                  name: "Rotate",
                  object: p10021.settings,
                  key: "rotateKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10961, p10962) {
                    p10962 = p10962.toUpperCase();
                    p10021.setSettings(this.key, p10962);
                  }
                },
                scaleKey: {
                  name: "Scale",
                  object: p10021.settings,
                  key: "scaleKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10963, p10964) {
                    p10964 = p10964.toUpperCase();
                    p10021.setSettings(this.key, p10964);
                  }
                },
                transformSpaceKey: {
                  name: "Toggle World / Local space",
                  object: p10021.settings,
                  key: "transformSpaceKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10965, p10966) {
                    p10966 = p10966.toUpperCase();
                    p10021.setSettings(this.key, p10966);
                  }
                }
              }
            };
            this.blueprint.edit = {
              name: "Edit",
              type: "folder",
              size: "standard",
              children: {
                ...[{
                  keys: ["Ctrl + Z"],
                  name: "Undo"
                }, {
                  keys: ["Ctrl + Y", "Shift + Ctrl + Z"],
                  name: "Redo"
                }].map(p10967 => ({
                  name: p10967.name,
                  object: {
                    val: p10967.keys.join(" or ")
                  },
                  key: "val",
                  type: "key"
                }))
              }
            };
            this.blueprint.object = {
              name: "Object",
              type: "folder",
              size: "standard",
              children: {
                faceModeKey: {
                  name: "Face Selection Mode",
                  object: p10021.settings,
                  key: "faceModeKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10968, p10969) {
                    p10969 = p10969.toUpperCase();
                    p10021.setSettings(this.key, p10969);
                    p10021.updateFaceSelection();
                  }
                },
                groupModeKey: {
                  name: "Group Selection Mode",
                  object: p10021.settings,
                  key: "groupModeKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10970, p10971) {
                    p10971 = p10971.toUpperCase();
                    p10021.setSettings(this.key, p10971);
                    p10021.updateGroupSelection();
                  }
                },
                wireframeKey: {
                  name: "Wireframe Mode",
                  object: p10021.settings,
                  key: "wireframeKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (p10972, p10973) {
                    p10973 = p10973.toUpperCase();
                    p10021.setSettings(this.key, p10973);
                    p10021.updateWireframe();
                  }
                },
                delElement: {
                  name: "Delete element",
                  object: {
                    val: ["Del", "Backspace"].join(" or ")
                  },
                  key: "val",
                  type: "key"
                },
                snapping: {
                  name: "Toggle snapping",
                  object: {
                    val: "Control"
                  },
                  key: "val",
                  type: "key"
                },
                collidable: {
                  name: "Toggle collidable",
                  object: {
                    val: "Shift + C"
                  },
                  key: "val",
                  type: "key"
                },
                visible: {
                  name: "Toggle visibilty",
                  object: {
                    val: "Shift + V"
                  },
                  key: "val",
                  type: "key"
                }
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        advanced: {
          gen: function () {
            this.blueprint = {
              textureKey: {
                name: "Open Texture/Model List",
                object: p10021.settings,
                key: "textureKey",
                type: "key",
                args: [[], true],
                onChange: function (p10974, p10975) {
                  p10975 = p10975.toUpperCase();
                  p10021.setSettings(this.key, p10975);
                }
              },
              scriptingKey: {
                name: "Open Scripting Window",
                object: p10021.settings,
                key: "scriptingKey",
                type: "key",
                args: [[], true],
                onChange: function (p10976, p10977) {
                  p10977 = p10977.toUpperCase();
                  p10021.setSettings(this.key, p10977);
                }
              },
              placeHolderKey: {
                name: "Create placeholder",
                object: p10021.settings,
                key: "placeHolderKey",
                type: "key",
                args: [[], true],
                onChange: function (p10978, p10979) {
                  p10979 = p10979.toUpperCase();
                  p10021.setSettings(this.key, p10979);
                }
              },
              createCubeKey: {
                name: "Create Cube",
                object: p10021.settings,
                key: "createCubeKey",
                type: "key",
                args: [[], true],
                onChange: function (p10980, p10981) {
                  p10981 = p10981.toUpperCase();
                  p10021.setSettings(this.key, p10981);
                }
              },
              createGateKey: {
                name: "Create Gate",
                object: p10021.settings,
                key: "createGateKey",
                type: "key",
                args: [[], true],
                onChange: function (p10982, p10983) {
                  p10983 = p10983.toUpperCase();
                  p10021.setSettings(this.key, p10983);
                }
              },
              createTriggerKey: {
                name: "Create Trigger",
                object: p10021.settings,
                key: "createTriggerKey",
                type: "key",
                args: [[], true],
                onChange: function (p10984, p10985) {
                  p10985 = p10985.toUpperCase();
                  p10021.setSettings(this.key, p10985);
                }
              },
              hitbox: {
                name: "Hitbox fixer",
                object: {
                  val: "Shift + F"
                },
                key: "val",
                type: "key"
              },
              flipXZ: {
                name: "Flip x/z size",
                object: {
                  val: "F"
                },
                key: "val",
                type: "key"
              },
              quickAddKey: {
                name: "Quick Add",
                object: p10021.settings,
                key: "quickAddKey",
                type: "key",
                args: [[], true],
                onChange: function (p10986, p10987) {
                  p10987 = p10987.toUpperCase();
                  p10021.setSettings(this.key, p10987);
                }
              },
              rule: {
                type: "rule"
              }
            };
            this.blueprint.group = {
              name: "Group",
              type: "folder",
              size: "standard",
              children: {
                ...[{
                  keys: ["Shift + Alt + G"],
                  name: "Remove all groups"
                }, {
                  keys: ["Shift + G"],
                  name: "Create group / Remove group if exist"
                }, {
                  keys: ["Shift + R"],
                  name: "Duplicate Group / Object"
                }, {
                  keys: ["Ctrl + C"],
                  name: "Copy group"
                }, {
                  keys: ["Ctrl + V"],
                  name: "Paste group"
                }].map(p10988 => ({
                  name: p10988.name,
                  object: {
                    val: p10988.keys.join(" or ")
                  },
                  key: "val",
                  type: "key"
                }))
              }
            };
            this.blueprint.file = {
              name: "File",
              type: "folder",
              size: "standard",
              children: {
                ...[{
                  keys: ["Shift + Click + Import"],
                  name: "Import from file"
                }, {
                  keys: ["Shift + Click + Export"],
                  name: "Export & copy"
                }].map(p10989 => ({
                  name: p10989.name,
                  object: {
                    val: p10989.keys.join(" or ")
                  },
                  key: "val",
                  type: "key"
                }))
              }
            };
            this.blueprint.file = {
              name: "File",
              type: "folder",
              size: "standard",
              children: {
                ...[{
                  keys: ["Shift + Click (w/ Objectpainter)"],
                  name: "Paste preset JSON"
                }].map(p10990 => ({
                  name: p10990.name,
                  object: {
                    val: p10990.keys.join(" or ")
                  },
                  key: "val",
                  type: "key"
                }))
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        }
      },
      settings: {
        general: {
          gen: function () {
            this.blueprint = {
              controls: {
                name: "Controls",
                object: {},
                key: "",
                type: "button",
                args: ["Open Controls"],
                onChange: function () {
                  showWindow(1);
                }
              },
              autoBackups: {
                name: "Auto Backup",
                object: p10021.settings,
                key: "autoBackups",
                type: "switch",
                onChange: function (p10991, p10992) {
                  p10021.setSettings("autoBackups", !!p10992);
                  p10021.initAutoBackup();
                }
              },
              backupTimer: {
                name: "Backup Timer (Minutes)",
                object: p10021.settings,
                key: "backupTimer",
                type: "slider",
                args: [1, 30, 1],
                onChange: function (p10993, p10994) {
                  p10021.setSettings("backupTimer", Math.abs(p10994));
                  p10021.initAutoBackup();
                }
              },
              uiScale: {
                name: "UI Scale",
                object: p10021.settings,
                key: "uiScale",
                type: "slider",
                args: [0.5, 1.5, 0.1],
                onChange: function (p10995, p10996) {
                  p10021.setSettings("uiScale", p10996);
                  p10021.scaleUI();
                }
              },
              pointerLock: {
                name: "Pointer Lock",
                object: p10021.settings,
                key: "pointerLock",
                type: "switch",
                onChange: function (p10997, p10998) {
                  p10021.setSettings("pointerLock", p10998);
                }
              },
              disableWarnings: {
                name: "Disable Warnings",
                object: p10021.settings,
                key: "disableWarnings",
                type: "switch",
                onChange: function (p10999, p11000) {
                  p10021.setSettings("disableWarnings", p11000);
                  p10021.clearWarnings();
                }
              },
              testInEditor: {
                name: "Test Map in Editor",
                object: p10021.settings,
                key: "testInEditor",
                type: "switch",
                onChange: function (p11001, p11002) {
                  p10021.setSettings("testInEditor", p11002);
                }
              },
              autoLogin: {
                name: "Autologin",
                object: p10021.settings,
                key: "autoLog",
                type: "switch",
                onChange: function (p11003, p11004) {
                  p10021.setSettings("autoLog", p11004);
                }
              },
              rule: {
                type: "rule"
              },
              render: {
                name: "Render",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  res: {
                    name: "Resolution",
                    object: p10021.settings,
                    key: "resMltV",
                    type: "slider",
                    args: [0.1, 2, 0.1],
                    onChange: function (p11005, p11006) {
                      p10021.setSettings("resMltV", Math.abs(p11006));
                      p10021.setResMlt();
                    }
                  },
                  antiAlias: {
                    name: "Anti-aliasing",
                    object: p10021.settings,
                    key: "resMltV",
                    type: "switch",
                    onChange: function (p11007, p11008) {
                      p10021.setSettings("antiAlias", p11008);
                      alert("This change will occur after you refresh");
                    }
                  },
                  renderDist: {
                    name: "Render Distance",
                    object: p10021.settings,
                    key: "renderDist",
                    type: "slider",
                    args: [100, 20000, 50],
                    onChange: function (p11009, p11010) {
                      p10021.setSettings("renderDist", p11010);
                      if (p10021.camera) {
                        p10021.camera.far = p11010;
                      }
                    }
                  }
                }
              },
              history: {
                name: "History",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  disable: {
                    name: "Disable",
                    object: p10021.settings,
                    key: "disableHistory",
                    type: "switch",
                    onChange: function (p11011, p11012) {
                      grid.style.display = p11012 ? "none" : null;
                      p10021.setSettings("disableHistory", p11012);
                      p10021.toggleHistory(p11012);
                    }
                  },
                  history: {
                    type: "div",
                    id: "grid",
                    show: !p10021.settings.disableHistory,
                    children: {
                      limit: {
                        name: "Limit",
                        object: p10021.settings,
                        key: "historyLimit",
                        type: "slider",
                        args: [0, 1000, 1],
                        onChange: function (p11013, p11014) {
                          p10021.setSettings("historyLimit", p11014);
                        },
                        sub: 1
                      }
                    }
                  }
                }
              },
              game: {
                name: "Game",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  showRealHitbox: {
                    name: "Show Real Hitbox",
                    object: p10021.settings,
                    key: "showRealHitbox",
                    type: "switch",
                    onChange: function (p11015, p11016) {
                      p10021.setSettings("showRealHitbox", p11016);
                      p10022.showRealHitbox = p11016;
                    }
                  }
                }
              },
              scripting: {
                name: "Scripting",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  scriptFont: {
                    name: "Scripting Font Size",
                    object: p10021.settings,
                    key: "scriptFont",
                    type: "slider",
                    args: [5, 30, 1],
                    onChange: function (p11017, p11018) {
                      p10021.setSettings("scriptFont", p11018);
                    }
                  }
                }
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        display: {
          gen: function () {
            this.blueprint = {
              showFPS: {
                name: "Show FPS",
                object: p10021.settings,
                key: "showFPS",
                type: "switch",
                onChange: function (p11019, p11020) {
                  p10021.setSettings("showFPS", p11020);
                  p10030.showFPS = p11020;
                }
              },
              darkMode: {
                name: "Dark Mode",
                object: p10021.settings,
                key: "darkMode",
                type: "switch",
                onChange: function (p11021, p11022) {
                  p10021.setSettings("darkMode", p11022);
                  p10021.updateTheme();
                }
              },
              rule: {
                type: "rule"
              },
              grid: {
                name: "Grid",
                type: "folder",
                size: "standard",
                children: {
                  gridVisibility: {
                    name: "Visible",
                    object: p10021.settings,
                    key: "gridVisibility",
                    type: "switch",
                    onChange: function (p11023, p11024) {
                      grid.style.display = p11024 ? null : "none";
                      p10021.setSettings("gridVisibility", p11024);
                      p10021.updateGridHelper();
                    }
                  },
                  grid: {
                    type: "div",
                    id: "grid",
                    show: p10021.settings.gridVisibility,
                    children: {
                      gridOpacity: {
                        name: "Opacity",
                        object: p10021.settings,
                        key: "gridOpacity",
                        type: "slider",
                        args: [0.05, 1, 0.05],
                        onChange: function (p11025, p11026) {
                          p10021.setSettings("gridOpacity", p11026);
                          p10021.updateGridHelper();
                        },
                        sub: 1
                      },
                      gridSize: {
                        name: "Size",
                        object: p10021.settings,
                        key: "gridSize",
                        type: "number",
                        onChange: function (p11027, p11028) {
                          p10021.setSettings("gridSize", Math.abs(p11028));
                          p10021.updateGridHelper();
                        },
                        sub: 1
                      },
                      gridSpacing: {
                        name: "Spacing",
                        object: p10021.settings,
                        key: "gridSpacing",
                        type: "number",
                        onChange: function (p11029, p11030) {
                          p10021.setSettings("gridSpacing", Math.abs(p11030) || p10021.defaultSettings.gridSpacing);
                          p10021.updateGridHelper();
                        },
                        sub: 1
                      }
                    }
                  },
                  gridReset: {
                    name: "Reset Grid",
                    object: p10021.advancedOptions,
                    key: "gridReset",
                    type: "button",
                    args: ["Reset"]
                  }
                }
              },
              deathBarrier: {
                name: "Death Barrier",
                type: "folder",
                size: "standard",
                children: {
                  dbVisibility: {
                    name: "Visible",
                    object: p10021.settings,
                    key: "dbVisibility",
                    type: "switch",
                    onChange: function (p11031, p11032) {
                      deathBarrier.style.display = p11032 ? null : "none";
                      p10021.setSettings("dbVisibility", p11032);
                      p10021.updateDeathBarrier();
                    }
                  },
                  deathBarrier: {
                    type: "div",
                    id: "deathBarrier",
                    show: p10021.settings.dbVisibility,
                    children: {
                      dbOpacity: {
                        name: "Opacity",
                        object: p10021.settings,
                        key: "dbOpacity",
                        type: "slider",
                        args: [0.05, 1, 0.05],
                        onChange: function (p11033, p11034) {
                          p10021.setSettings("dbOpacity", p11034);
                          p10021.updateDeathBarrier();
                        },
                        sub: 1
                      }
                    }
                  },
                  dbReset: {
                    name: "Reset Barrier",
                    object: p10021.advancedOptions,
                    key: "dbReset",
                    type: "button",
                    args: ["Reset"]
                  }
                }
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        object: {
          gen: function () {
            this.blueprint = {
              triggerCons: {
                name: "Object Connections",
                object: p10021.settings,
                key: "triggerCons",
                type: "switch",
                onChange: function (p11035, p11036) {
                  p10021.setSettings("triggerCons", p11036);
                  p10021.checkConnections();
                }
              },
              selectThrough: {
                name: "Select through invisible objects [ALT]",
                object: p10021.settings,
                key: "selectThroughInvis",
                type: "switch",
                onChange: function (p11037, p11038) {
                  p10021.setSettings("selectThroughInvis", p11038);
                }
              },
              borderVisuals: {
                name: "Object Border Visuals",
                object: p10021.settings,
                key: "borderVisuals",
                type: "switch",
                onChange: function (p11039, p11040) {
                  p10021.setSettings("borderVisuals", p11040);
                  p10021.updateBorderVisuals();
                }
              },
              res: {
                name: "Highlight",
                object: p10021.settings,
                key: "objectHighlight",
                type: "switch",
                onChange: function (p11041, p11042) {
                  p10021.setSettings("objectHighlight", p11042);
                }
              },
              antiAlias: {
                name: "Create Near",
                object: p10021.settings,
                key: "createObjectNear",
                type: "switch",
                onChange: function (p11043, p11044) {
                  p10021.setSettings("createObjectNear", p11044);
                }
              },
              togLightCones: {
                name: "Lightcone Boundingbox",
                object: p10021.advancedOptions,
                key: "togLightCones",
                type: "button",
                args: ["Toggle"]
              },
              togModels: {
                name: "Model & Asset Boundingbox",
                object: p10021.advancedOptions,
                key: "togModels",
                type: "button",
                args: ["Toggle"]
              },
              rule: {
                type: "rule"
              },
              config: {
                name: "Config",
                type: "folder",
                size: "standard",
                children: {
                  degToRad: {
                    name: "Anti Radians",
                    object: p10021.settings,
                    key: "degToRad",
                    type: "switch",
                    onChange: function (p11045, p11046) {
                      p10021.setSettings("degToRad", p11046);
                    }
                  },
                  preserveFolderState: {
                    name: "Preserve Folders",
                    object: p10021.settings,
                    key: "preserveFolderState",
                    type: "switch",
                    onChange: function (p11047, p11048) {
                      p10021.setSettings("preserveFolderState", p11048);
                    }
                  }
                }
              },
              snapping: {
                name: "Snapping",
                type: "folder",
                size: "standard",
                children: {
                  translation: {
                    name: "Translation",
                    object: p10021.settings,
                    key: "translationSnapping",
                    type: "slider",
                    args: [0.001, 25, 0.001],
                    onChange: function (p11049, p11050) {
                      p10021.setSettings("translationSnapping", Math.abs(p11050) || p10021.defaultSettings.translationSnapping);
                      p10021.updateSnapping();
                    }
                  },
                  rotation: {
                    name: "Rotation",
                    object: p10021.settings,
                    key: "rotationSnapping",
                    type: "slider",
                    args: [0.001, 45, 0.001],
                    onChange: function (p11051, p11052) {
                      p10021.setSettings("rotationSnapping", Math.abs(p11052) || p10021.defaultSettings.rotationSnapping);
                      p10021.updateSnapping();
                    }
                  },
                  scale: {
                    name: "Scale",
                    object: p10021.settings,
                    key: "scaleSnapping",
                    type: "slider",
                    args: [0.001, 25, 0.001],
                    onChange: function (p11053, p11054) {
                      p10021.setSettings("scaleSnapping", Math.abs(p11054) || p10021.defaultSettings.scaleSnapping);
                      p10021.updateSnapping();
                    }
                  },
                  reset: {
                    name: "Reset Snapping",
                    object: p10021.advancedOptions,
                    key: "snappingReset",
                    type: "button",
                    args: ["Reset"]
                  }
                }
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        },
        quickgui: {
          gen: function () {
            this.blueprint = {
              enabled: {
                name: "Enabled",
                object: p10021.settings,
                key: "quickGUI",
                type: "switch",
                onChange: function (p11055, p11056) {
                  quickgui.style.display = p11056 ? null : "none";
                  p10021.setSettings("quickGUI", p11056);
                }
              },
              quickgui: {
                type: "div",
                id: "quickgui",
                show: p10021.settings.quickGUI,
                children: {
                  quickGUIOpen: {
                    name: "Open On",
                    object: p10021.settings,
                    key: "quickGUIOpen",
                    type: "select",
                    args: [[{
                      name: "Middle Click",
                      value: 0
                    }, {
                      name: "Right Click",
                      value: 1
                    }]],
                    onChange: function (p11057, p11058) {
                      p10021.setSettings("quickGUIOpen", parseInt(p11058));
                    },
                    sub: 1
                  }
                }
              }
            };
            return vO230._build([...this.objKeys, "blueprint"]);
          }
        }
      },
      quickaddcust: {
        gen: function () {
          let vA412 = [];
          let vA413 = [];
          let vA414 = [];
          for (let v8129 in p10024.prefabs) {
            if ((!p10024.prefabs[v8129].localOnly || !config.isProd) && !p10024.prefabs[v8129].custom && !p10024.prefabs[v8129].noExport) {
              if (p10024.prefabs[v8129].name != "") {
                (p10024.prefabs[v8129].tool || p10024.prefabs[v8129].tool2 ? vA413 : p10024.prefabs[v8129].gen ? vA412 : vA414).push({
                  name: UTILS.formatConstName(p10024.prefabs[v8129].name),
                  object: {},
                  key: "",
                  type: "button",
                  args: ["Add"],
                  onChange: function () {
                    windows[3].changeButton({
                      name: UTILS.formatConstName(p10024.prefabs[v8129].name),
                      desc: "Click to add",
                      item: v8129
                    });
                  }
                });
              }
            }
          }
          this.blueprint = {
            rule: {
              type: "rule"
            },
            general: {
              name: "General",
              type: "folder",
              size: "standard",
              children: {
                customAsset: {
                  name: "Custom Asset",
                  object: {},
                  key: "",
                  type: "button",
                  args: ["Add"],
                  onChange: function () {
                    windows[3].changeButton({
                      name: "Custom Asset",
                      desc: "Import community made assets",
                      cust: true
                    });
                  }
                },
                placeholder: {
                  name: "Placeholder",
                  object: {},
                  key: "",
                  type: "button",
                  args: ["Add"],
                  onChange: function () {
                    windows[3].changeButton({
                      name: "Placeholder",
                      desc: "Stretch over objects to form a group",
                      place: true
                    });
                  }
                }
              }
            },
            basic: {
              name: "Basic",
              type: "folder",
              size: "standard",
              children: {
                ...vA414
              }
            },
            models: {
              name: "Models",
              type: "folder",
              size: "standard",
              children: {
                ...vA412
              }
            },
            tools: {
              name: "Tools",
              type: "folder",
              size: "standard",
              children: {
                ...vA413
              }
            }
          };
          return vO230._build([...this.objKeys, "blueprint"]);
        }
      }
    },
    _quicksettings: {
      gen: function () {
        this.blueprint = {
          duplicate: {
            name: "Duplicate",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              if (p10021.quickGUI.obj.objType == "PLACEHOLDER") {
                p10021.duplicateGroup(p10021.quickGUI.obj);
              } else {
                p10021.duplicateObject(p10021.quickGUI.obj);
              }
            }
          },
          delete: {
            name: "Delete",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              if (p10021.quickGUI.obj.objType == "PLACEHOLDER") {
                p10021.removeGroup(p10021.quickGUI.obj);
              } else {
                p10021.removeObject({
                  boundingMesh: p10021.quickGUI.obj
                });
              }
            }
          },
          rule0: {
            type: "rule"
          },
          group: {
            name: "Group",
            type: "toolbar",
            pos: "menu",
            children: {
              form: {
                name: "Create",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.copyObjects(false, true, false, p10021.quickGUI.obj);
                }
              },
              separate: {
                name: "Stop",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.stopGroup(false, p10021.quickGUI.obj);
                }
              },
              rule: {
                type: "rule"
              },
              copy: {
                name: "Copy",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.copyObjects(false, false, false, p10021.quickGUI.obj);
                }
              },
              paste: {
                name: "Paste",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.pasteObjects(p10021.quickGUI.obj);
                }
              }
            }
          },
          rule1: {
            type: "rule"
          },
          fixHitbox: {
            name: "Fix Hitbox",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              p10021.fixHitbox(this.quickGUI.obj);
            }
          },
          rule2: {
            type: "rule"
          },
          replace: {
            name: "Replace",
            type: "toolbar",
            pos: "menu",
            children: {
              form: {
                name: "JSON",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.jsonInput(false, p10021.quickGUI.obj);
                }
              },
              separate: {
                name: "File",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  p10021.jsonInput(true, p10021.quickGUI.obj);
                }
              }
            }
          },
          rule3: {
            type: "rule"
          },
          json: {
            name: "JSON",
            type: "toolbar",
            pos: "menu",
            children: {
              textArea: {
                type: "toolbar",
                pos: "textarea"
              }
            }
          }
        };
        return vO230._build([...this.objKeys, "blueprint"]);
      }
    }
  };
  UTILS.getObjKeys(vO230, ["_html", "update", "action", "_build", "state", "blueprint", "folderStore", "show", "gen", "elem", "restore"]).forEach(p11059 => {
    let vVO2306 = vO230;
    let v8130 = p11059.split("|");
    v8130.forEach(p11060 => vVO2306 = vVO2306[p11060]);
    vVO2306.objKeys = v8130;
  });
  window.addEventListener("mousemove", vO230.update.number.mousemove);
  window.addEventListener("mouseup", vO230.update.number.mouseup);
  window.addEventListener("keydown", vO230.update.key.keydown);
  window.addEventListener("mousedown", vO230.update.key.mousedown);
  vO230.update.color.init();
  window.GUI = UTILS.removePrivateKeys(vO230);
  return vO230;
};